const Pb = ["licensePlate", "inspectionExpiryDate"];
function Li({ firstRegistration: o }) {
  return o == null ? !0 : typeof o == "string" && o.trim() === "";
}
function Ob(o, t) {
  return Pb.some((n) => n === o) && Li(t);
}
const zb = [
  "registrationDocument",
  "registrationDocumentPartTwo",
  "inspectionSticker"
];
function Gb(o, t) {
  return zb.some((n) => n === o) && Li(t);
}
const Ub = [
  // Visibility-only: visible Back Office where shown, hidden elsewhere.
  "useType",
  "engineBrand",
  "engineModel",
  "width",
  "height",
  // Responsibility-varying: always visible; Back Office/Inspector and required both vary.
  "length",
  "axles",
  "wheels",
  "wheelsSizeAxle1",
  "wheelsSizeAxle2",
  "wheelsSizeAxle3",
  "inspectionExpiryDate",
  // Inspector or hidden.
  "hasDepotService"
], tT = [
  "cocDocument",
  "registrationDocument",
  "registrationDocumentPartTwo",
  "maintenanceCard",
  "technicalSheet",
  "inspectionAndMileageCheck",
  "inspectionSticker"
], ao = { visibility: "hidden" }, C = { visibility: "visible", responsibility: "BackOffice", required: !0 }, Wo = { visibility: "visible", responsibility: "BackOffice", required: !1 }, so = { visibility: "visible", responsibility: "Inspector", required: !0 }, Ho = { visibility: "visible", responsibility: "Inspector", required: !1 }, ki = {
  useType: { default: ao, overrides: { IT: C } },
  engineBrand: {
    default: ao,
    overrides: {
      IT: C,
      ES: C,
      PT: C,
      BE: C,
      AT: C,
      NL: C
    }
  },
  engineModel: { default: ao, overrides: { IT: C, ES: C, AT: C } },
  width: {
    default: ao,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: C }
  },
  height: { default: ao, overrides: { ES: C, DE: C, AT: C, LU: C } },
  length: {
    default: so,
    overrides: {
      IT: C,
      ES: C,
      BE: C,
      DE: C,
      AT: C,
      CZ: C,
      NL: C,
      LU: C,
      PT: Ho
    }
  },
  axles: {
    default: so,
    overrides: {
      IT: C,
      ES: C,
      DE: C,
      AT: C,
      LU: C,
      PT: Ho
    }
  },
  wheels: {
    default: so,
    overrides: {
      IT: C,
      ES: C,
      DE: C,
      AT: C,
      LU: C,
      PT: Ho
    }
  },
  wheelsSizeAxle1: {
    default: Ho,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: C }
  },
  wheelsSizeAxle2: {
    default: Ho,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: Wo }
  },
  wheelsSizeAxle3: {
    default: Ho,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: Wo }
  },
  inspectionExpiryDate: { default: C, overrides: { PT: so, DE: so } },
  // Deliberately NOT aligned to PT-703 (BSD-4329): the sheet's "Depot Service" (code 60) is an attribute the
  // inspector observes, whereas this column is a commercial flag, set when the seller accepts the depot terms
  // (BusAsset.depotTermsAcceptedAt). Same name, different thing — do not sync this row from the sheet.
  hasDepotService: { default: ao, overrides: { IT: Ho } }
}, Bi = {
  cocDocument: { default: Wo, overrides: { BE: C, NL: C } },
  registrationDocument: { default: C, overrides: { DE: so, AT: so, CZ: so } },
  registrationDocumentPartTwo: { default: ao, overrides: { DE: C, AT: C, CZ: C } },
  maintenanceCard: { default: Wo },
  technicalSheet: { default: ao, overrides: { ES: C } },
  inspectionAndMileageCheck: { default: ao, overrides: { IT: Wo, ES: Wo, PL: Wo } },
  inspectionSticker: { default: ao, overrides: { DE: so, AT: so } }
};
function gr(o, t) {
  const { default: n, overrides: a } = o;
  if (t != null && a !== void 0) {
    const u = a[t];
    if (u !== void 0) return u;
  }
  return n;
}
function nT(o, t) {
  return gr(ki[o], t).visibility === "hidden";
}
function Zb(o, t, n) {
  if (n !== void 0 && Ob(o, n)) return !1;
  const a = gr(ki[o], t);
  return a.visibility === "visible" && a.required;
}
function iT(o, t) {
  const n = gr(ki[o], t);
  return n.visibility === "visible" ? n.responsibility : void 0;
}
function aT(o, t) {
  return Ub.filter((n) => Zb(n, o, t));
}
function sT(o, t) {
  return gr(Bi[o], t).visibility === "hidden";
}
function uT(o, t, n) {
  if (n !== void 0 && Gb(o, n)) return !1;
  const a = gr(Bi[o], t);
  return a.visibility === "visible" && a.required;
}
function lT(o, t) {
  const n = gr(Bi[o], t);
  return n.visibility === "visible" ? n.responsibility : void 0;
}
const cT = ["Autobus", "Minibus", "Other"], dT = ["ClassOne", "ClassTwo", "ClassThree", "ClassA", "ClassB", "SchoolBus"], qb = [
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 13 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 12 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 11.5 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 11 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 9 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 8 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 7.5 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 10 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 9 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 8.5 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 8 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 6 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 5.5 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 5 }
], $b = 2;
function pT(o) {
  if (o.class === "ClassOne") return null;
  if (o.type === "Minibus") return $b;
  if (o.type !== "Autobus" || o.class !== "ClassTwo" && o.class !== "ClassThree") return null;
  const { axles: t, passThroughLuggageCompartment: n, toilet: a, driverBerth: u } = o;
  return t == null || n === null || n === void 0 || a === null || a === void 0 || u === null || u === void 0 ? null : qb.find(
    (d) => d.axles === t && d.passThroughLuggageCompartment === n && d.toilet === a && d.driverBerth === u
  )?.cubicMetres ?? null;
}
function I(o, t, n) {
  function a(_, T) {
    if (_._zod || Object.defineProperty(_, "_zod", {
      value: {
        def: T,
        constr: d,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), _._zod.traits.has(o))
      return;
    _._zod.traits.add(o), t(_, T);
    const S = d.prototype, w = Object.keys(S);
    for (let z = 0; z < w.length; z++) {
      const D = w[z];
      D in _ || (_[D] = S[D].bind(_));
    }
  }
  const u = n?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: o });
  function d(_) {
    var T;
    const S = n?.Parent ? new f() : this;
    a(S, _), (T = S._zod).deferred ?? (T.deferred = []);
    for (const w of S._zod.deferred)
      w();
    return S;
  }
  return Object.defineProperty(d, "init", { value: a }), Object.defineProperty(d, Symbol.hasInstance, {
    value: (_) => n?.Parent && _ instanceof n.Parent ? !0 : _?._zod?.traits?.has(o)
  }), Object.defineProperty(d, "name", { value: o }), d;
}
class _r extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Qu extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const el = {};
function Vo(o) {
  return el;
}
function ol(o) {
  const t = Object.values(o).filter((a) => typeof a == "number");
  return Object.entries(o).filter(([a, u]) => t.indexOf(+a) === -1).map(([a, u]) => u);
}
function vi(o, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ri(o) {
  return {
    get value() {
      {
        const t = o();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Pi(o) {
  return o == null;
}
function Oi(o) {
  const t = o.startsWith("^") ? 1 : 0, n = o.endsWith("$") ? o.length - 1 : o.length;
  return o.slice(t, n);
}
function Kb(o, t) {
  const n = (o.toString().split(".")[1] || "").length, a = t.toString();
  let u = (a.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(a)) {
    const T = a.match(/\d?e-(\d?)/);
    T?.[1] && (u = Number.parseInt(T[1]));
  }
  const f = n > u ? n : u, d = Number.parseInt(o.toFixed(f).replace(".", "")), _ = Number.parseInt(t.toFixed(f).replace(".", ""));
  return d % _ / 10 ** f;
}
const wu = /* @__PURE__ */ Symbol("evaluating");
function j(o, t, n) {
  let a;
  Object.defineProperty(o, t, {
    get() {
      if (a !== wu)
        return a === void 0 && (a = wu, a = n()), a;
    },
    set(u) {
      Object.defineProperty(o, t, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function jo(o, t, n) {
  Object.defineProperty(o, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Lo(...o) {
  const t = {};
  for (const n of o) {
    const a = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, a);
  }
  return Object.defineProperties({}, t);
}
function Eu(o) {
  return JSON.stringify(o);
}
function Hb(o) {
  return o.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const rl = "captureStackTrace" in Error ? Error.captureStackTrace : (...o) => {
};
function Vt(o) {
  return typeof o == "object" && o !== null && !Array.isArray(o);
}
const Wb = Ri(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const o = Function;
    return new o(""), !0;
  } catch {
    return !1;
  }
});
function Vr(o) {
  if (Vt(o) === !1)
    return !1;
  const t = o.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Vt(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function tl(o) {
  return Vr(o) ? { ...o } : Array.isArray(o) ? [...o] : o;
}
const Vb = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function br(o) {
  return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ko(o, t, n) {
  const a = new o._zod.constr(t ?? o._zod.def);
  return (!t || n?.parent) && (a._zod.parent = o), a;
}
function L(o) {
  const t = o;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Jb(o) {
  return Object.keys(o).filter((t) => o[t]._zod.optin === "optional" && o[t]._zod.optout === "optional");
}
const jb = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Yb(o, t) {
  const n = o._zod.def, a = n.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Lo(o._zod.def, {
    get shape() {
      const d = {};
      for (const _ in t) {
        if (!(_ in n.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        t[_] && (d[_] = n.shape[_]);
      }
      return jo(this, "shape", d), d;
    },
    checks: []
  });
  return ko(o, f);
}
function Xb(o, t) {
  const n = o._zod.def, a = n.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Lo(o._zod.def, {
    get shape() {
      const d = { ...o._zod.def.shape };
      for (const _ in t) {
        if (!(_ in n.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        t[_] && delete d[_];
      }
      return jo(this, "shape", d), d;
    },
    checks: []
  });
  return ko(o, f);
}
function Qb(o, t) {
  if (!Vr(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = o._zod.def.checks;
  if (n && n.length > 0) {
    const f = o._zod.def.shape;
    for (const d in t)
      if (Object.getOwnPropertyDescriptor(f, d) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Lo(o._zod.def, {
    get shape() {
      const f = { ...o._zod.def.shape, ...t };
      return jo(this, "shape", f), f;
    }
  });
  return ko(o, u);
}
function eA(o, t) {
  if (!Vr(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Lo(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...t };
      return jo(this, "shape", a), a;
    }
  });
  return ko(o, n);
}
function oA(o, t) {
  const n = Lo(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...t._zod.def.shape };
      return jo(this, "shape", a), a;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return ko(o, n);
}
function rA(o, t, n) {
  const u = t._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const d = Lo(t._zod.def, {
    get shape() {
      const _ = t._zod.def.shape, T = { ..._ };
      if (n)
        for (const S in n) {
          if (!(S in _))
            throw new Error(`Unrecognized key: "${S}"`);
          n[S] && (T[S] = o ? new o({
            type: "optional",
            innerType: _[S]
          }) : _[S]);
        }
      else
        for (const S in _)
          T[S] = o ? new o({
            type: "optional",
            innerType: _[S]
          }) : _[S];
      return jo(this, "shape", T), T;
    },
    checks: []
  });
  return ko(t, d);
}
function tA(o, t, n) {
  const a = Lo(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, f = { ...u };
      if (n)
        for (const d in n) {
          if (!(d in f))
            throw new Error(`Unrecognized key: "${d}"`);
          n[d] && (f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          }));
        }
      else
        for (const d in u)
          f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          });
      return jo(this, "shape", f), f;
    }
  });
  return ko(t, a);
}
function fr(o, t = 0) {
  if (o.aborted === !0)
    return !0;
  for (let n = t; n < o.issues.length; n++)
    if (o.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function nl(o, t) {
  return t.map((n) => {
    var a;
    return (a = n).path ?? (a.path = []), n.path.unshift(o), n;
  });
}
function $t(o) {
  return typeof o == "string" ? o : o?.message;
}
function Jo(o, t, n) {
  const a = { ...o, path: o.path ?? [] };
  if (!o.message) {
    const u = $t(o.inst?._zod.def?.error?.(o)) ?? $t(t?.error?.(o)) ?? $t(n.customError?.(o)) ?? $t(n.localeError?.(o)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, t?.reportInput || delete a.input, a;
}
function zi(o) {
  return Array.isArray(o) ? "array" : typeof o == "string" ? "string" : "unknown";
}
function Jr(...o) {
  const [t, n, a] = o;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: a
  } : { ...t };
}
const il = (o, t) => {
  o.name = "$ZodError", Object.defineProperty(o, "_zod", {
    value: o._zod,
    enumerable: !1
  }), Object.defineProperty(o, "issues", {
    value: t,
    enumerable: !1
  }), o.message = JSON.stringify(t, vi, 2), Object.defineProperty(o, "toString", {
    value: () => o.message,
    enumerable: !1
  });
}, al = I("$ZodError", il), sl = I("$ZodError", il, { Parent: Error });
function nA(o, t = (n) => n.message) {
  const n = {}, a = [];
  for (const u of o.issues)
    u.path.length > 0 ? (n[u.path[0]] = n[u.path[0]] || [], n[u.path[0]].push(t(u))) : a.push(t(u));
  return { formErrors: a, fieldErrors: n };
}
function iA(o, t = (n) => n.message) {
  const n = { _errors: [] }, a = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((d) => a({ issues: d }));
      else if (f.code === "invalid_key")
        a({ issues: f.issues });
      else if (f.code === "invalid_element")
        a({ issues: f.issues });
      else if (f.path.length === 0)
        n._errors.push(t(f));
      else {
        let d = n, _ = 0;
        for (; _ < f.path.length; ) {
          const T = f.path[_];
          _ === f.path.length - 1 ? (d[T] = d[T] || { _errors: [] }, d[T]._errors.push(t(f))) : d[T] = d[T] || { _errors: [] }, d = d[T], _++;
        }
      }
  };
  return a(o), n;
}
const Gi = (o) => (t, n, a, u) => {
  const f = a ? Object.assign(a, { async: !1 }) : { async: !1 }, d = t._zod.run({ value: n, issues: [] }, f);
  if (d instanceof Promise)
    throw new _r();
  if (d.issues.length) {
    const _ = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, Vo())));
    throw rl(_, u?.callee), _;
  }
  return d.value;
}, Ui = (o) => async (t, n, a, u) => {
  const f = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let d = t._zod.run({ value: n, issues: [] }, f);
  if (d instanceof Promise && (d = await d), d.issues.length) {
    const _ = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, Vo())));
    throw rl(_, u?.callee), _;
  }
  return d.value;
}, Qt = (o) => (t, n, a) => {
  const u = a ? { ...a, async: !1 } : { async: !1 }, f = t._zod.run({ value: n, issues: [] }, u);
  if (f instanceof Promise)
    throw new _r();
  return f.issues.length ? {
    success: !1,
    error: new (o ?? al)(f.issues.map((d) => Jo(d, u, Vo())))
  } : { success: !0, data: f.value };
}, aA = /* @__PURE__ */ Qt(sl), en = (o) => async (t, n, a) => {
  const u = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let f = t._zod.run({ value: n, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new o(f.issues.map((d) => Jo(d, u, Vo())))
  } : { success: !0, data: f.value };
}, sA = /* @__PURE__ */ en(sl), uA = (o) => (t, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Gi(o)(t, n, u);
}, lA = (o) => (t, n, a) => Gi(o)(t, n, a), cA = (o) => async (t, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Ui(o)(t, n, u);
}, dA = (o) => async (t, n, a) => Ui(o)(t, n, a), pA = (o) => (t, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Qt(o)(t, n, u);
}, fA = (o) => (t, n, a) => Qt(o)(t, n, a), mA = (o) => async (t, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return en(o)(t, n, u);
}, hA = (o) => async (t, n, a) => en(o)(t, n, a), _A = /^[cC][^\s-]{8,}$/, bA = /^[0-9a-z]+$/, AA = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, gA = /^[0-9a-vA-V]{20}$/, yA = /^[A-Za-z0-9]{27}$/, TA = /^[a-zA-Z0-9_-]{21}$/, MA = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, IA = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Cu = (o) => o ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${o}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, xA = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, FA = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function SA() {
  return new RegExp(FA, "u");
}
const NA = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, wA = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, EA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, CA = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ul = /^[A-Za-z0-9_-]*$/, DA = /^\+[1-9]\d{6,14}$/, ll = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", LA = /* @__PURE__ */ new RegExp(`^${ll}$`);
function cl(o) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof o.precision == "number" ? o.precision === -1 ? `${t}` : o.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${o.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function kA(o) {
  return new RegExp(`^${cl(o)}$`);
}
function BA(o) {
  const t = cl({ precision: o.precision }), n = ["Z"];
  o.local && n.push(""), o.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${ll}T(?:${a})$`);
}
const RA = (o) => {
  const t = o ? `[\\s\\S]{${o?.minimum ?? 0},${o?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, PA = /^-?\d+$/, OA = /^-?\d+(?:\.\d+)?$/, zA = /^[^A-Z]*$/, GA = /^[^a-z]*$/, Ee = /* @__PURE__ */ I("$ZodCheck", (o, t) => {
  var n;
  o._zod ?? (o._zod = {}), o._zod.def = t, (n = o._zod).onattach ?? (n.onattach = []);
}), dl = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, pl = /* @__PURE__ */ I("$ZodCheckLessThan", (o, t) => {
  Ee.init(o, t);
  const n = dl[typeof t.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < f && (t.inclusive ? u.maximum = t.value : u.exclusiveMaximum = t.value);
  }), o._zod.check = (a) => {
    (t.inclusive ? a.value <= t.value : a.value < t.value) || a.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: o,
      continue: !t.abort
    });
  };
}), fl = /* @__PURE__ */ I("$ZodCheckGreaterThan", (o, t) => {
  Ee.init(o, t);
  const n = dl[typeof t.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > f && (t.inclusive ? u.minimum = t.value : u.exclusiveMinimum = t.value);
  }), o._zod.check = (a) => {
    (t.inclusive ? a.value >= t.value : a.value > t.value) || a.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: o,
      continue: !t.abort
    });
  };
}), UA = /* @__PURE__ */ I("$ZodCheckMultipleOf", (o, t) => {
  Ee.init(o, t), o._zod.onattach.push((n) => {
    var a;
    (a = n._zod.bag).multipleOf ?? (a.multipleOf = t.value);
  }), o._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Kb(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: o,
      continue: !t.abort
    });
  };
}), ZA = /* @__PURE__ */ I("$ZodCheckNumberFormat", (o, t) => {
  Ee.init(o, t), t.format = t.format || "float64";
  const n = t.format?.includes("int"), a = n ? "int" : "number", [u, f] = jb[t.format];
  o._zod.onattach.push((d) => {
    const _ = d._zod.bag;
    _.format = t.format, _.minimum = u, _.maximum = f, n && (_.pattern = PA);
  }), o._zod.check = (d) => {
    const _ = d.value;
    if (n) {
      if (!Number.isInteger(_)) {
        d.issues.push({
          expected: a,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: _,
          inst: o
        });
        return;
      }
      if (!Number.isSafeInteger(_)) {
        _ > 0 ? d.issues.push({
          input: _,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        }) : d.issues.push({
          input: _,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    _ < u && d.issues.push({
      origin: "number",
      input: _,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: o,
      continue: !t.abort
    }), _ > f && d.issues.push({
      origin: "number",
      input: _,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: o,
      continue: !t.abort
    });
  };
}), qA = /* @__PURE__ */ I("$ZodCheckMaxLength", (o, t) => {
  var n;
  Ee.init(o, t), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < u && (a._zod.bag.maximum = t.maximum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length <= t.maximum)
      return;
    const d = zi(u);
    a.issues.push({
      origin: d,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !t.abort
    });
  };
}), $A = /* @__PURE__ */ I("$ZodCheckMinLength", (o, t) => {
  var n;
  Ee.init(o, t), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > u && (a._zod.bag.minimum = t.minimum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length >= t.minimum)
      return;
    const d = zi(u);
    a.issues.push({
      origin: d,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !t.abort
    });
  };
}), KA = /* @__PURE__ */ I("$ZodCheckLengthEquals", (o, t) => {
  var n;
  Ee.init(o, t), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.minimum = t.length, u.maximum = t.length, u.length = t.length;
  }), o._zod.check = (a) => {
    const u = a.value, f = u.length;
    if (f === t.length)
      return;
    const d = zi(u), _ = f > t.length;
    a.issues.push({
      origin: d,
      ..._ ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), on = /* @__PURE__ */ I("$ZodCheckStringFormat", (o, t) => {
  var n, a;
  Ee.init(o, t), o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = t.format, t.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(t.pattern));
  }), t.pattern ? (n = o._zod).check ?? (n.check = (u) => {
    t.pattern.lastIndex = 0, !t.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: u.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: o,
      continue: !t.abort
    });
  }) : (a = o._zod).check ?? (a.check = () => {
  });
}), HA = /* @__PURE__ */ I("$ZodCheckRegex", (o, t) => {
  on.init(o, t), o._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: o,
      continue: !t.abort
    });
  };
}), WA = /* @__PURE__ */ I("$ZodCheckLowerCase", (o, t) => {
  t.pattern ?? (t.pattern = zA), on.init(o, t);
}), VA = /* @__PURE__ */ I("$ZodCheckUpperCase", (o, t) => {
  t.pattern ?? (t.pattern = GA), on.init(o, t);
}), JA = /* @__PURE__ */ I("$ZodCheckIncludes", (o, t) => {
  Ee.init(o, t);
  const n = br(t.includes), a = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = a, o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(a);
  }), o._zod.check = (u) => {
    u.value.includes(t.includes, t.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: u.value,
      inst: o,
      continue: !t.abort
    });
  };
}), jA = /* @__PURE__ */ I("$ZodCheckStartsWith", (o, t) => {
  Ee.init(o, t);
  const n = new RegExp(`^${br(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(n);
  }), o._zod.check = (a) => {
    a.value.startsWith(t.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), YA = /* @__PURE__ */ I("$ZodCheckEndsWith", (o, t) => {
  Ee.init(o, t);
  const n = new RegExp(`.*${br(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(n);
  }), o._zod.check = (a) => {
    a.value.endsWith(t.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), XA = /* @__PURE__ */ I("$ZodCheckOverwrite", (o, t) => {
  Ee.init(o, t), o._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class QA {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((d) => d), u = Math.min(...a.map((d) => d.length - d.trimStart().length)), f = a.map((d) => d.slice(u)).map((d) => " ".repeat(this.indent * 2) + d);
    for (const d of f)
      this.content.push(d);
  }
  compile() {
    const t = Function, n = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new t(...n, u.join(`
`));
  }
}
const e0 = {
  major: 4,
  minor: 3,
  patch: 6
}, ce = /* @__PURE__ */ I("$ZodType", (o, t) => {
  var n;
  o ?? (o = {}), o._zod.def = t, o._zod.bag = o._zod.bag || {}, o._zod.version = e0;
  const a = [...o._zod.def.checks ?? []];
  o._zod.traits.has("$ZodCheck") && a.unshift(o);
  for (const u of a)
    for (const f of u._zod.onattach)
      f(o);
  if (a.length === 0)
    (n = o._zod).deferred ?? (n.deferred = []), o._zod.deferred?.push(() => {
      o._zod.run = o._zod.parse;
    });
  else {
    const u = (d, _, T) => {
      let S = fr(d), w;
      for (const z of _) {
        if (z._zod.def.when) {
          if (!z._zod.def.when(d))
            continue;
        } else if (S)
          continue;
        const D = d.issues.length, P = z._zod.check(d);
        if (P instanceof Promise && T?.async === !1)
          throw new _r();
        if (w || P instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await P, d.issues.length !== D && (S || (S = fr(d, D)));
          });
        else {
          if (d.issues.length === D)
            continue;
          S || (S = fr(d, D));
        }
      }
      return w ? w.then(() => d) : d;
    }, f = (d, _, T) => {
      if (fr(d))
        return d.aborted = !0, d;
      const S = u(_, a, T);
      if (S instanceof Promise) {
        if (T.async === !1)
          throw new _r();
        return S.then((w) => o._zod.parse(w, T));
      }
      return o._zod.parse(S, T);
    };
    o._zod.run = (d, _) => {
      if (_.skipChecks)
        return o._zod.parse(d, _);
      if (_.direction === "backward") {
        const S = o._zod.parse({ value: d.value, issues: [] }, { ..._, skipChecks: !0 });
        return S instanceof Promise ? S.then((w) => f(w, d, _)) : f(S, d, _);
      }
      const T = o._zod.parse(d, _);
      if (T instanceof Promise) {
        if (_.async === !1)
          throw new _r();
        return T.then((S) => u(S, a, _));
      }
      return u(T, a, _);
    };
  }
  j(o, "~standard", () => ({
    validate: (u) => {
      try {
        const f = aA(o, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return sA(o, u).then((d) => d.success ? { value: d.data } : { issues: d.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Zi = /* @__PURE__ */ I("$ZodString", (o, t) => {
  ce.init(o, t), o._zod.pattern = [...o?._zod.bag?.patterns ?? []].pop() ?? RA(o._zod.bag), o._zod.parse = (n, a) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: o
    }), n;
  };
}), te = /* @__PURE__ */ I("$ZodStringFormat", (o, t) => {
  on.init(o, t), Zi.init(o, t);
}), o0 = /* @__PURE__ */ I("$ZodGUID", (o, t) => {
  t.pattern ?? (t.pattern = IA), te.init(o, t);
}), r0 = /* @__PURE__ */ I("$ZodUUID", (o, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Cu(a));
  } else
    t.pattern ?? (t.pattern = Cu());
  te.init(o, t);
}), t0 = /* @__PURE__ */ I("$ZodEmail", (o, t) => {
  t.pattern ?? (t.pattern = xA), te.init(o, t);
}), n0 = /* @__PURE__ */ I("$ZodURL", (o, t) => {
  te.init(o, t), o._zod.check = (n) => {
    try {
      const a = n.value.trim(), u = new URL(a);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(u.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: o,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: o,
        continue: !t.abort
      })), t.normalize ? n.value = u.href : n.value = a;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
}), i0 = /* @__PURE__ */ I("$ZodEmoji", (o, t) => {
  t.pattern ?? (t.pattern = SA()), te.init(o, t);
}), a0 = /* @__PURE__ */ I("$ZodNanoID", (o, t) => {
  t.pattern ?? (t.pattern = TA), te.init(o, t);
}), s0 = /* @__PURE__ */ I("$ZodCUID", (o, t) => {
  t.pattern ?? (t.pattern = _A), te.init(o, t);
}), u0 = /* @__PURE__ */ I("$ZodCUID2", (o, t) => {
  t.pattern ?? (t.pattern = bA), te.init(o, t);
}), l0 = /* @__PURE__ */ I("$ZodULID", (o, t) => {
  t.pattern ?? (t.pattern = AA), te.init(o, t);
}), c0 = /* @__PURE__ */ I("$ZodXID", (o, t) => {
  t.pattern ?? (t.pattern = gA), te.init(o, t);
}), d0 = /* @__PURE__ */ I("$ZodKSUID", (o, t) => {
  t.pattern ?? (t.pattern = yA), te.init(o, t);
}), p0 = /* @__PURE__ */ I("$ZodISODateTime", (o, t) => {
  t.pattern ?? (t.pattern = BA(t)), te.init(o, t);
}), f0 = /* @__PURE__ */ I("$ZodISODate", (o, t) => {
  t.pattern ?? (t.pattern = LA), te.init(o, t);
}), m0 = /* @__PURE__ */ I("$ZodISOTime", (o, t) => {
  t.pattern ?? (t.pattern = kA(t)), te.init(o, t);
}), h0 = /* @__PURE__ */ I("$ZodISODuration", (o, t) => {
  t.pattern ?? (t.pattern = MA), te.init(o, t);
}), _0 = /* @__PURE__ */ I("$ZodIPv4", (o, t) => {
  t.pattern ?? (t.pattern = NA), te.init(o, t), o._zod.bag.format = "ipv4";
}), b0 = /* @__PURE__ */ I("$ZodIPv6", (o, t) => {
  t.pattern ?? (t.pattern = vA), te.init(o, t), o._zod.bag.format = "ipv6", o._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
}), A0 = /* @__PURE__ */ I("$ZodCIDRv4", (o, t) => {
  t.pattern ?? (t.pattern = wA), te.init(o, t);
}), g0 = /* @__PURE__ */ I("$ZodCIDRv6", (o, t) => {
  t.pattern ?? (t.pattern = EA), te.init(o, t), o._zod.check = (n) => {
    const a = n.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [u, f] = a;
      if (!f)
        throw new Error();
      const d = Number(f);
      if (`${d}` !== f)
        throw new Error();
      if (d < 0 || d > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
});
function ml(o) {
  if (o === "")
    return !0;
  if (o.length % 4 !== 0)
    return !1;
  try {
    return atob(o), !0;
  } catch {
    return !1;
  }
}
const y0 = /* @__PURE__ */ I("$ZodBase64", (o, t) => {
  t.pattern ?? (t.pattern = CA), te.init(o, t), o._zod.bag.contentEncoding = "base64", o._zod.check = (n) => {
    ml(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: o,
      continue: !t.abort
    });
  };
});
function T0(o) {
  if (!ul.test(o))
    return !1;
  const t = o.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return ml(n);
}
const M0 = /* @__PURE__ */ I("$ZodBase64URL", (o, t) => {
  t.pattern ?? (t.pattern = ul), te.init(o, t), o._zod.bag.contentEncoding = "base64url", o._zod.check = (n) => {
    T0(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: o,
      continue: !t.abort
    });
  };
}), I0 = /* @__PURE__ */ I("$ZodE164", (o, t) => {
  t.pattern ?? (t.pattern = DA), te.init(o, t);
});
function x0(o, t = null) {
  try {
    const n = o.split(".");
    if (n.length !== 3)
      return !1;
    const [a] = n;
    if (!a)
      return !1;
    const u = JSON.parse(atob(a));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || t && (!("alg" in u) || u.alg !== t));
  } catch {
    return !1;
  }
}
const F0 = /* @__PURE__ */ I("$ZodJWT", (o, t) => {
  te.init(o, t), o._zod.check = (n) => {
    x0(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: o,
      continue: !t.abort
    });
  };
}), hl = /* @__PURE__ */ I("$ZodNumber", (o, t) => {
  ce.init(o, t), o._zod.pattern = o._zod.bag.pattern ?? OA, o._zod.parse = (n, a) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const u = n.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return n;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: o,
      ...f ? { received: f } : {}
    }), n;
  };
}), S0 = /* @__PURE__ */ I("$ZodNumberFormat", (o, t) => {
  ZA.init(o, t), hl.init(o, t);
}), N0 = /* @__PURE__ */ I("$ZodUnknown", (o, t) => {
  ce.init(o, t), o._zod.parse = (n) => n;
}), v0 = /* @__PURE__ */ I("$ZodNever", (o, t) => {
  ce.init(o, t), o._zod.parse = (n, a) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: o
  }), n);
});
function Du(o, t, n) {
  o.issues.length && t.issues.push(...nl(n, o.issues)), t.value[n] = o.value;
}
const w0 = /* @__PURE__ */ I("$ZodArray", (o, t) => {
  ce.init(o, t), o._zod.parse = (n, a) => {
    const u = n.value;
    if (!Array.isArray(u))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: o
      }), n;
    n.value = Array(u.length);
    const f = [];
    for (let d = 0; d < u.length; d++) {
      const _ = u[d], T = t.element._zod.run({
        value: _,
        issues: []
      }, a);
      T instanceof Promise ? f.push(T.then((S) => Du(S, n, d))) : Du(T, n, d);
    }
    return f.length ? Promise.all(f).then(() => n) : n;
  };
});
function Jt(o, t, n, a, u) {
  if (o.issues.length) {
    if (u && !(n in a))
      return;
    t.issues.push(...nl(n, o.issues));
  }
  o.value === void 0 ? n in a && (t.value[n] = void 0) : t.value[n] = o.value;
}
function _l(o) {
  const t = Object.keys(o.shape);
  for (const a of t)
    if (!o.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const n = Jb(o.shape);
  return {
    ...o,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function bl(o, t, n, a, u, f) {
  const d = [], _ = u.keySet, T = u.catchall._zod, S = T.def.type, w = T.optout === "optional";
  for (const z in t) {
    if (_.has(z))
      continue;
    if (S === "never") {
      d.push(z);
      continue;
    }
    const D = T.run({ value: t[z], issues: [] }, a);
    D instanceof Promise ? o.push(D.then((P) => Jt(P, n, z, t, w))) : Jt(D, n, z, t, w);
  }
  return d.length && n.issues.push({
    code: "unrecognized_keys",
    keys: d,
    input: t,
    inst: f
  }), o.length ? Promise.all(o).then(() => n) : n;
}
const E0 = /* @__PURE__ */ I("$ZodObject", (o, t) => {
  if (ce.init(o, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const _ = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const T = { ..._ };
        return Object.defineProperty(t, "shape", {
          value: T
        }), T;
      }
    });
  }
  const a = Ri(() => _l(t));
  j(o._zod, "propValues", () => {
    const _ = t.shape, T = {};
    for (const S in _) {
      const w = _[S]._zod;
      if (w.values) {
        T[S] ?? (T[S] = /* @__PURE__ */ new Set());
        for (const z of w.values)
          T[S].add(z);
      }
    }
    return T;
  });
  const u = Vt, f = t.catchall;
  let d;
  o._zod.parse = (_, T) => {
    d ?? (d = a.value);
    const S = _.value;
    if (!u(S))
      return _.issues.push({
        expected: "object",
        code: "invalid_type",
        input: S,
        inst: o
      }), _;
    _.value = {};
    const w = [], z = d.shape;
    for (const D of d.keys) {
      const P = z[D], ae = P._zod.optout === "optional", ee = P._zod.run({ value: S[D], issues: [] }, T);
      ee instanceof Promise ? w.push(ee.then((co) => Jt(co, _, D, S, ae))) : Jt(ee, _, D, S, ae);
    }
    return f ? bl(w, S, _, T, a.value, o) : w.length ? Promise.all(w).then(() => _) : _;
  };
}), C0 = /* @__PURE__ */ I("$ZodObjectJIT", (o, t) => {
  E0.init(o, t);
  const n = o._zod.parse, a = Ri(() => _l(t)), u = (D) => {
    const P = new QA(["shape", "payload", "ctx"]), ae = a.value, ee = (De) => {
      const oe = Eu(De);
      return `shape[${oe}]._zod.run({ value: input[${oe}], issues: [] }, ctx)`;
    };
    P.write("const input = payload.value;");
    const co = /* @__PURE__ */ Object.create(null);
    let Ce = 0;
    for (const De of ae.keys)
      co[De] = `key_${Ce++}`;
    P.write("const newResult = {};");
    for (const De of ae.keys) {
      const oe = co[De], he = Eu(De), Bo = D[De]?._zod?.optout === "optional";
      P.write(`const ${oe} = ${ee(De)};`), Bo ? P.write(`
        if (${oe}.issues.length) {
          if (${he} in input) {
            payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${he}, ...iss.path] : [${he}]
            })));
          }
        }
        
        if (${oe}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${oe}.value;
        }
        
      `) : P.write(`
        if (${oe}.issues.length) {
          payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${he}, ...iss.path] : [${he}]
          })));
        }
        
        if (${oe}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${oe}.value;
        }
        
      `);
    }
    P.write("payload.value = newResult;"), P.write("return payload;");
    const Mo = P.compile();
    return (De, oe) => Mo(D, De, oe);
  };
  let f;
  const d = Vt, _ = !el.jitless, S = _ && Wb.value, w = t.catchall;
  let z;
  o._zod.parse = (D, P) => {
    z ?? (z = a.value);
    const ae = D.value;
    return d(ae) ? _ && S && P?.async === !1 && P.jitless !== !0 ? (f || (f = u(t.shape)), D = f(D, P), w ? bl([], ae, D, P, z, o) : D) : n(D, P) : (D.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ae,
      inst: o
    }), D);
  };
});
function Lu(o, t, n, a) {
  for (const f of o)
    if (f.issues.length === 0)
      return t.value = f.value, t;
  const u = o.filter((f) => !fr(f));
  return u.length === 1 ? (t.value = u[0].value, u[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: o.map((f) => f.issues.map((d) => Jo(d, a, Vo())))
  }), t);
}
const D0 = /* @__PURE__ */ I("$ZodUnion", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), j(o._zod, "optout", () => t.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), j(o._zod, "values", () => {
    if (t.options.every((u) => u._zod.values))
      return new Set(t.options.flatMap((u) => Array.from(u._zod.values)));
  }), j(o._zod, "pattern", () => {
    if (t.options.every((u) => u._zod.pattern)) {
      const u = t.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Oi(f.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, a = t.options[0]._zod.run;
  o._zod.parse = (u, f) => {
    if (n)
      return a(u, f);
    let d = !1;
    const _ = [];
    for (const T of t.options) {
      const S = T._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (S instanceof Promise)
        _.push(S), d = !0;
      else {
        if (S.issues.length === 0)
          return S;
        _.push(S);
      }
    }
    return d ? Promise.all(_).then((T) => Lu(T, u, o, f)) : Lu(_, u, o, f);
  };
}), L0 = /* @__PURE__ */ I("$ZodIntersection", (o, t) => {
  ce.init(o, t), o._zod.parse = (n, a) => {
    const u = n.value, f = t.left._zod.run({ value: u, issues: [] }, a), d = t.right._zod.run({ value: u, issues: [] }, a);
    return f instanceof Promise || d instanceof Promise ? Promise.all([f, d]).then(([T, S]) => ku(n, T, S)) : ku(n, f, d);
  };
});
function wi(o, t) {
  if (o === t)
    return { valid: !0, data: o };
  if (o instanceof Date && t instanceof Date && +o == +t)
    return { valid: !0, data: o };
  if (Vr(o) && Vr(t)) {
    const n = Object.keys(t), a = Object.keys(o).filter((f) => n.indexOf(f) !== -1), u = { ...o, ...t };
    for (const f of a) {
      const d = wi(o[f], t[f]);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...d.mergeErrorPath]
        };
      u[f] = d.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(o) && Array.isArray(t)) {
    if (o.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let a = 0; a < o.length; a++) {
      const u = o[a], f = t[a], d = wi(u, f);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...d.mergeErrorPath]
        };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function ku(o, t, n) {
  const a = /* @__PURE__ */ new Map();
  let u;
  for (const _ of t.issues)
    if (_.code === "unrecognized_keys") {
      u ?? (u = _);
      for (const T of _.keys)
        a.has(T) || a.set(T, {}), a.get(T).l = !0;
    } else
      o.issues.push(_);
  for (const _ of n.issues)
    if (_.code === "unrecognized_keys")
      for (const T of _.keys)
        a.has(T) || a.set(T, {}), a.get(T).r = !0;
    else
      o.issues.push(_);
  const f = [...a].filter(([, _]) => _.l && _.r).map(([_]) => _);
  if (f.length && u && o.issues.push({ ...u, keys: f }), fr(o))
    return o;
  const d = wi(t.value, n.value);
  if (!d.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(d.mergeErrorPath)}`);
  return o.value = d.data, o;
}
const k0 = /* @__PURE__ */ I("$ZodEnum", (o, t) => {
  ce.init(o, t);
  const n = ol(t.entries), a = new Set(n);
  o._zod.values = a, o._zod.pattern = new RegExp(`^(${n.filter((u) => Vb.has(typeof u)).map((u) => typeof u == "string" ? br(u) : u.toString()).join("|")})$`), o._zod.parse = (u, f) => {
    const d = u.value;
    return a.has(d) || u.issues.push({
      code: "invalid_value",
      values: n,
      input: d,
      inst: o
    }), u;
  };
}), B0 = /* @__PURE__ */ I("$ZodLiteral", (o, t) => {
  if (ce.init(o, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  o._zod.values = n, o._zod.pattern = new RegExp(`^(${t.values.map((a) => typeof a == "string" ? br(a) : a ? br(a.toString()) : String(a)).join("|")})$`), o._zod.parse = (a, u) => {
    const f = a.value;
    return n.has(f) || a.issues.push({
      code: "invalid_value",
      values: t.values,
      input: f,
      inst: o
    }), a;
  };
}), R0 = /* @__PURE__ */ I("$ZodTransform", (o, t) => {
  ce.init(o, t), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new Qu(o.constructor.name);
    const u = t.transform(n.value, n);
    if (a.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((d) => (n.value = d, n));
    if (u instanceof Promise)
      throw new _r();
    return n.value = u, n;
  };
});
function Bu(o, t) {
  return o.issues.length && t === void 0 ? { issues: [], value: void 0 } : o;
}
const Al = /* @__PURE__ */ I("$ZodOptional", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", o._zod.optout = "optional", j(o._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), j(o._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Oi(n.source)})?$`) : void 0;
  }), o._zod.parse = (n, a) => {
    if (t.innerType._zod.optin === "optional") {
      const u = t.innerType._zod.run(n, a);
      return u instanceof Promise ? u.then((f) => Bu(f, n.value)) : Bu(u, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, a);
  };
}), P0 = /* @__PURE__ */ I("$ZodExactOptional", (o, t) => {
  Al.init(o, t), j(o._zod, "values", () => t.innerType._zod.values), j(o._zod, "pattern", () => t.innerType._zod.pattern), o._zod.parse = (n, a) => t.innerType._zod.run(n, a);
}), O0 = /* @__PURE__ */ I("$ZodNullable", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.innerType._zod.optin), j(o._zod, "optout", () => t.innerType._zod.optout), j(o._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Oi(n.source)}|null)$`) : void 0;
  }), j(o._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), o._zod.parse = (n, a) => n.value === null ? n : t.innerType._zod.run(n, a);
}), z0 = /* @__PURE__ */ I("$ZodDefault", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(n, a);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const u = t.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => Ru(f, t)) : Ru(u, t);
  };
});
function Ru(o, t) {
  return o.value === void 0 && (o.value = t.defaultValue), o;
}
const G0 = /* @__PURE__ */ I("$ZodPrefault", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (n, a) => (a.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, a));
}), U0 = /* @__PURE__ */ I("$ZodNonOptional", (o, t) => {
  ce.init(o, t), j(o._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((a) => a !== void 0)) : void 0;
  }), o._zod.parse = (n, a) => {
    const u = t.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => Pu(f, o)) : Pu(u, o);
  };
});
function Pu(o, t) {
  return !o.issues.length && o.value === void 0 && o.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: o.value,
    inst: t
  }), o;
}
const Z0 = /* @__PURE__ */ I("$ZodCatch", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.innerType._zod.optin), j(o._zod, "optout", () => t.innerType._zod.optout), j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(n, a);
    const u = t.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => (n.value = f.value, f.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: f.issues.map((d) => Jo(d, a, Vo()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = u.value, u.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: u.issues.map((f) => Jo(f, a, Vo()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), q0 = /* @__PURE__ */ I("$ZodPipe", (o, t) => {
  ce.init(o, t), j(o._zod, "values", () => t.in._zod.values), j(o._zod, "optin", () => t.in._zod.optin), j(o._zod, "optout", () => t.out._zod.optout), j(o._zod, "propValues", () => t.in._zod.propValues), o._zod.parse = (n, a) => {
    if (a.direction === "backward") {
      const f = t.out._zod.run(n, a);
      return f instanceof Promise ? f.then((d) => Kt(d, t.in, a)) : Kt(f, t.in, a);
    }
    const u = t.in._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => Kt(f, t.out, a)) : Kt(u, t.out, a);
  };
});
function Kt(o, t, n) {
  return o.issues.length ? (o.aborted = !0, o) : t._zod.run({ value: o.value, issues: o.issues }, n);
}
const $0 = /* @__PURE__ */ I("$ZodReadonly", (o, t) => {
  ce.init(o, t), j(o._zod, "propValues", () => t.innerType._zod.propValues), j(o._zod, "values", () => t.innerType._zod.values), j(o._zod, "optin", () => t.innerType?._zod?.optin), j(o._zod, "optout", () => t.innerType?._zod?.optout), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(n, a);
    const u = t.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then(Ou) : Ou(u);
  };
});
function Ou(o) {
  return o.value = Object.freeze(o.value), o;
}
const K0 = /* @__PURE__ */ I("$ZodCustom", (o, t) => {
  Ee.init(o, t), ce.init(o, t), o._zod.parse = (n, a) => n, o._zod.check = (n) => {
    const a = n.value, u = t.fn(a);
    if (u instanceof Promise)
      return u.then((f) => zu(f, n, a, o));
    zu(u, n, a, o);
  };
});
function zu(o, t, n, a) {
  if (!o) {
    const u = {
      code: "custom",
      input: n,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (u.params = a._zod.def.params), t.issues.push(Jr(u));
  }
}
var Gu;
class H0 {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const a = n[0];
    return this._map.set(t, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const a = { ...this.get(n) ?? {} };
      delete a.id;
      const u = { ...a, ...this._map.get(t) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function W0() {
  return new H0();
}
(Gu = globalThis).__zod_globalRegistry ?? (Gu.__zod_globalRegistry = W0());
const $r = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function V0(o, t) {
  return new o({
    type: "string",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function J0(o, t) {
  return new o({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uu(o, t) {
  return new o({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gl(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function j0(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Y0(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function X0(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Q0(o, t) {
  return new o({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eg(o, t) {
  return new o({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function og(o, t) {
  return new o({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rg(o, t) {
  return new o({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tg(o, t) {
  return new o({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ng(o, t) {
  return new o({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ig(o, t) {
  return new o({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ag(o, t) {
  return new o({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sg(o, t) {
  return new o({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ug(o, t) {
  return new o({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lg(o, t) {
  return new o({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cg(o, t) {
  return new o({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dg(o, t) {
  return new o({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pg(o, t) {
  return new o({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fg(o, t) {
  return new o({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mg(o, t) {
  return new o({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hg(o, t) {
  return new o({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _g(o, t) {
  return new o({
    type: "string",
    format: "date",
    check: "string_format",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bg(o, t) {
  return new o({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ag(o, t) {
  return new o({
    type: "string",
    format: "duration",
    check: "string_format",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gg(o, t) {
  return new o({
    type: "number",
    checks: [],
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yg(o, t) {
  return new o({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Tg(o) {
  return new o({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Mg(o, t) {
  return new o({
    type: "never",
    ...L(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zu(o, t) {
  return new pl({
    check: "less_than",
    ...L(t),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Si(o, t) {
  return new pl({
    check: "less_than",
    ...L(t),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function qu(o, t) {
  return new fl({
    check: "greater_than",
    ...L(t),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Ni(o, t) {
  return new fl({
    check: "greater_than",
    ...L(t),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function $u(o, t) {
  return new UA({
    check: "multiple_of",
    ...L(t),
    value: o
  });
}
// @__NO_SIDE_EFFECTS__
function yl(o, t) {
  return new qA({
    check: "max_length",
    ...L(t),
    maximum: o
  });
}
// @__NO_SIDE_EFFECTS__
function jt(o, t) {
  return new $A({
    check: "min_length",
    ...L(t),
    minimum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Tl(o, t) {
  return new KA({
    check: "length_equals",
    ...L(t),
    length: o
  });
}
// @__NO_SIDE_EFFECTS__
function Ig(o, t) {
  return new HA({
    check: "string_format",
    format: "regex",
    ...L(t),
    pattern: o
  });
}
// @__NO_SIDE_EFFECTS__
function xg(o) {
  return new WA({
    check: "string_format",
    format: "lowercase",
    ...L(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Fg(o) {
  return new VA({
    check: "string_format",
    format: "uppercase",
    ...L(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Sg(o, t) {
  return new JA({
    check: "string_format",
    format: "includes",
    ...L(t),
    includes: o
  });
}
// @__NO_SIDE_EFFECTS__
function Ng(o, t) {
  return new jA({
    check: "string_format",
    format: "starts_with",
    ...L(t),
    prefix: o
  });
}
// @__NO_SIDE_EFFECTS__
function vg(o, t) {
  return new YA({
    check: "string_format",
    format: "ends_with",
    ...L(t),
    suffix: o
  });
}
// @__NO_SIDE_EFFECTS__
function yr(o) {
  return new XA({
    check: "overwrite",
    tx: o
  });
}
// @__NO_SIDE_EFFECTS__
function wg(o) {
  return /* @__PURE__ */ yr((t) => t.normalize(o));
}
// @__NO_SIDE_EFFECTS__
function Eg() {
  return /* @__PURE__ */ yr((o) => o.trim());
}
// @__NO_SIDE_EFFECTS__
function Cg() {
  return /* @__PURE__ */ yr((o) => o.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Dg() {
  return /* @__PURE__ */ yr((o) => o.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Lg() {
  return /* @__PURE__ */ yr((o) => Hb(o));
}
// @__NO_SIDE_EFFECTS__
function kg(o, t, n) {
  return new o({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...L(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Bg(o, t, n) {
  return new o({
    type: "custom",
    check: "custom",
    fn: t,
    ...L(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Rg(o) {
  const t = /* @__PURE__ */ Pg((n) => (n.addIssue = (a) => {
    if (typeof a == "string")
      n.issues.push(Jr(a, n.value, t._zod.def));
    else {
      const u = a;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = n.value), u.inst ?? (u.inst = t), u.continue ?? (u.continue = !t._zod.def.abort), n.issues.push(Jr(u));
    }
  }, o(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Pg(o, t) {
  const n = new Ee({
    check: "custom",
    ...L(t)
  });
  return n._zod.check = o, n;
}
function Ml(o) {
  let t = o?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: o.processors ?? {},
    metadataRegistry: o?.metadata ?? $r,
    target: t,
    unrepresentable: o?.unrepresentable ?? "throw",
    override: o?.override ?? (() => {
    }),
    io: o?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: o?.cycles ?? "ref",
    reused: o?.reused ?? "inline",
    external: o?.external ?? void 0
  };
}
function Ae(o, t, n = { path: [], schemaPath: [] }) {
  var a;
  const u = o._zod.def, f = t.seen.get(o);
  if (f)
    return f.count++, n.schemaPath.includes(o) && (f.cycle = n.path), f.schema;
  const d = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(o, d);
  const _ = o._zod.toJSONSchema?.();
  if (_)
    d.schema = _;
  else {
    const w = {
      ...n,
      schemaPath: [...n.schemaPath, o],
      path: n.path
    };
    if (o._zod.processJSONSchema)
      o._zod.processJSONSchema(t, d.schema, w);
    else {
      const D = d.schema, P = t.processors[u.type];
      if (!P)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      P(o, t, D, w);
    }
    const z = o._zod.parent;
    z && (d.ref || (d.ref = z), Ae(z, t, w), t.seen.get(z).isParent = !0);
  }
  const T = t.metadataRegistry.get(o);
  return T && Object.assign(d.schema, T), t.io === "input" && Fe(o) && (delete d.schema.examples, delete d.schema.default), t.io === "input" && d.schema._prefault && ((a = d.schema).default ?? (a.default = d.schema._prefault)), delete d.schema._prefault, t.seen.get(o).schema;
}
function Il(o, t) {
  const n = o.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const d of o.seen.entries()) {
    const _ = o.metadataRegistry.get(d[0])?.id;
    if (_) {
      const T = a.get(_);
      if (T && T !== d[0])
        throw new Error(`Duplicate schema id "${_}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(_, d[0]);
    }
  }
  const u = (d) => {
    const _ = o.target === "draft-2020-12" ? "$defs" : "definitions";
    if (o.external) {
      const z = o.external.registry.get(d[0])?.id, D = o.external.uri ?? ((ae) => ae);
      if (z)
        return { ref: D(z) };
      const P = d[1].defId ?? d[1].schema.id ?? `schema${o.counter++}`;
      return d[1].defId = P, { defId: P, ref: `${D("__shared")}#/${_}/${P}` };
    }
    if (d[1] === n)
      return { ref: "#" };
    const S = `#/${_}/`, w = d[1].schema.id ?? `__schema${o.counter++}`;
    return { defId: w, ref: S + w };
  }, f = (d) => {
    if (d[1].schema.$ref)
      return;
    const _ = d[1], { ref: T, defId: S } = u(d);
    _.def = { ..._.schema }, S && (_.defId = S);
    const w = _.schema;
    for (const z in w)
      delete w[z];
    w.$ref = T;
  };
  if (o.cycles === "throw")
    for (const d of o.seen.entries()) {
      const _ = d[1];
      if (_.cycle)
        throw new Error(`Cycle detected: #/${_.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const d of o.seen.entries()) {
    const _ = d[1];
    if (t === d[0]) {
      f(d);
      continue;
    }
    if (o.external) {
      const S = o.external.registry.get(d[0])?.id;
      if (t !== d[0] && S) {
        f(d);
        continue;
      }
    }
    if (o.metadataRegistry.get(d[0])?.id) {
      f(d);
      continue;
    }
    if (_.cycle) {
      f(d);
      continue;
    }
    if (_.count > 1 && o.reused === "ref") {
      f(d);
      continue;
    }
  }
}
function xl(o, t) {
  const n = o.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (d) => {
    const _ = o.seen.get(d);
    if (_.ref === null)
      return;
    const T = _.def ?? _.schema, S = { ...T }, w = _.ref;
    if (_.ref = null, w) {
      a(w);
      const D = o.seen.get(w), P = D.schema;
      if (P.$ref && (o.target === "draft-07" || o.target === "draft-04" || o.target === "openapi-3.0") ? (T.allOf = T.allOf ?? [], T.allOf.push(P)) : Object.assign(T, P), Object.assign(T, S), d._zod.parent === w)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in S || delete T[ee];
      if (P.$ref && D.def)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in D.def && JSON.stringify(T[ee]) === JSON.stringify(D.def[ee]) && delete T[ee];
    }
    const z = d._zod.parent;
    if (z && z !== w) {
      a(z);
      const D = o.seen.get(z);
      if (D?.schema.$ref && (T.$ref = D.schema.$ref, D.def))
        for (const P in T)
          P === "$ref" || P === "allOf" || P in D.def && JSON.stringify(T[P]) === JSON.stringify(D.def[P]) && delete T[P];
    }
    o.override({
      zodSchema: d,
      jsonSchema: T,
      path: _.path ?? []
    });
  };
  for (const d of [...o.seen.entries()].reverse())
    a(d[0]);
  const u = {};
  if (o.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : o.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : o.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : o.target, o.external?.uri) {
    const d = o.external.registry.get(t)?.id;
    if (!d)
      throw new Error("Schema is missing an `id` property");
    u.$id = o.external.uri(d);
  }
  Object.assign(u, n.def ?? n.schema);
  const f = o.external?.defs ?? {};
  for (const d of o.seen.entries()) {
    const _ = d[1];
    _.def && _.defId && (f[_.defId] = _.def);
  }
  o.external || Object.keys(f).length > 0 && (o.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const d = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(d, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Yt(t, "input", o.processors),
          output: Yt(t, "output", o.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), d;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Fe(o, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(o))
    return !1;
  n.seen.add(o);
  const a = o._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return Fe(a.element, n);
  if (a.type === "set")
    return Fe(a.valueType, n);
  if (a.type === "lazy")
    return Fe(a.getter(), n);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return Fe(a.innerType, n);
  if (a.type === "intersection")
    return Fe(a.left, n) || Fe(a.right, n);
  if (a.type === "record" || a.type === "map")
    return Fe(a.keyType, n) || Fe(a.valueType, n);
  if (a.type === "pipe")
    return Fe(a.in, n) || Fe(a.out, n);
  if (a.type === "object") {
    for (const u in a.shape)
      if (Fe(a.shape[u], n))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const u of a.options)
      if (Fe(u, n))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const u of a.items)
      if (Fe(u, n))
        return !0;
    return !!(a.rest && Fe(a.rest, n));
  }
  return !1;
}
const Og = (o, t = {}) => (n) => {
  const a = Ml({ ...n, processors: t });
  return Ae(o, a), Il(a, o), xl(a, o);
}, Yt = (o, t, n = {}) => (a) => {
  const { libraryOptions: u, target: f } = a ?? {}, d = Ml({ ...u ?? {}, target: f, io: t, processors: n });
  return Ae(o, d), Il(d, o), xl(d, o);
}, zg = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Gg = (o, t, n, a) => {
  const u = n;
  u.type = "string";
  const { minimum: f, maximum: d, format: _, patterns: T, contentEncoding: S } = o._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof d == "number" && (u.maxLength = d), _ && (u.format = zg[_] ?? _, u.format === "" && delete u.format, _ === "time" && delete u.format), S && (u.contentEncoding = S), T && T.size > 0) {
    const w = [...T];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((z) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: z.source
      }))
    ]);
  }
}, Ug = (o, t, n, a) => {
  const u = n, { minimum: f, maximum: d, format: _, multipleOf: T, exclusiveMaximum: S, exclusiveMinimum: w } = o._zod.bag;
  typeof _ == "string" && _.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && t.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof S == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.maximum = S, u.exclusiveMaximum = !0) : u.exclusiveMaximum = S), typeof d == "number" && (u.maximum = d, typeof S == "number" && t.target !== "draft-04" && (S <= d ? delete u.maximum : delete u.exclusiveMaximum)), typeof T == "number" && (u.multipleOf = T);
}, Zg = (o, t, n, a) => {
  n.not = {};
}, qg = (o, t, n, a) => {
}, $g = (o, t, n, a) => {
  const u = o._zod.def, f = ol(u.entries);
  f.every((d) => typeof d == "number") && (n.type = "number"), f.every((d) => typeof d == "string") && (n.type = "string"), n.enum = f;
}, Kg = (o, t, n, a) => {
  const u = o._zod.def, f = [];
  for (const d of u.values)
    if (d === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof d == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(d));
    } else
      f.push(d);
  if (f.length !== 0) if (f.length === 1) {
    const d = f[0];
    n.type = d === null ? "null" : typeof d, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [d] : n.const = d;
  } else
    f.every((d) => typeof d == "number") && (n.type = "number"), f.every((d) => typeof d == "string") && (n.type = "string"), f.every((d) => typeof d == "boolean") && (n.type = "boolean"), f.every((d) => d === null) && (n.type = "null"), n.enum = f;
}, Hg = (o, t, n, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Wg = (o, t, n, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Vg = (o, t, n, a) => {
  const u = n, f = o._zod.def, { minimum: d, maximum: _ } = o._zod.bag;
  typeof d == "number" && (u.minItems = d), typeof _ == "number" && (u.maxItems = _), u.type = "array", u.items = Ae(f.element, t, { ...a, path: [...a.path, "items"] });
}, Jg = (o, t, n, a) => {
  const u = n, f = o._zod.def;
  u.type = "object", u.properties = {};
  const d = f.shape;
  for (const S in d)
    u.properties[S] = Ae(d[S], t, {
      ...a,
      path: [...a.path, "properties", S]
    });
  const _ = new Set(Object.keys(d)), T = new Set([..._].filter((S) => {
    const w = f.shape[S]._zod;
    return t.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  T.size > 0 && (u.required = Array.from(T)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = Ae(f.catchall, t, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : t.io === "output" && (u.additionalProperties = !1);
}, jg = (o, t, n, a) => {
  const u = o._zod.def, f = u.inclusive === !1, d = u.options.map((_, T) => Ae(_, t, {
    ...a,
    path: [...a.path, f ? "oneOf" : "anyOf", T]
  }));
  f ? n.oneOf = d : n.anyOf = d;
}, Yg = (o, t, n, a) => {
  const u = o._zod.def, f = Ae(u.left, t, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), d = Ae(u.right, t, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), _ = (S) => "allOf" in S && Object.keys(S).length === 1, T = [
    ..._(f) ? f.allOf : [f],
    ..._(d) ? d.allOf : [d]
  ];
  n.allOf = T;
}, Xg = (o, t, n, a) => {
  const u = o._zod.def, f = Ae(u.innerType, t, a), d = t.seen.get(o);
  t.target === "openapi-3.0" ? (d.ref = u.innerType, n.nullable = !0) : n.anyOf = [f, { type: "null" }];
}, Qg = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
}, e1 = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, n.default = JSON.parse(JSON.stringify(u.defaultValue));
}, o1 = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, r1 = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
  let d;
  try {
    d = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = d;
}, t1 = (o, t, n, a) => {
  const u = o._zod.def, f = t.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  Ae(f, t, a);
  const d = t.seen.get(o);
  d.ref = f;
}, n1 = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, n.readOnly = !0;
}, Fl = (o, t, n, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
}, i1 = /* @__PURE__ */ I("ZodISODateTime", (o, t) => {
  p0.init(o, t), ie.init(o, t);
});
function a1(o) {
  return /* @__PURE__ */ hg(i1, o);
}
const s1 = /* @__PURE__ */ I("ZodISODate", (o, t) => {
  f0.init(o, t), ie.init(o, t);
});
function u1(o) {
  return /* @__PURE__ */ _g(s1, o);
}
const l1 = /* @__PURE__ */ I("ZodISOTime", (o, t) => {
  m0.init(o, t), ie.init(o, t);
});
function c1(o) {
  return /* @__PURE__ */ bg(l1, o);
}
const d1 = /* @__PURE__ */ I("ZodISODuration", (o, t) => {
  h0.init(o, t), ie.init(o, t);
});
function p1(o) {
  return /* @__PURE__ */ Ag(d1, o);
}
const f1 = (o, t) => {
  al.init(o, t), o.name = "ZodError", Object.defineProperties(o, {
    format: {
      value: (n) => iA(o, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => nA(o, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        o.issues.push(n), o.message = JSON.stringify(o.issues, vi, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        o.issues.push(...n), o.message = JSON.stringify(o.issues, vi, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return o.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = I("ZodError", f1, {
  Parent: Error
}), m1 = /* @__PURE__ */ Gi(We), h1 = /* @__PURE__ */ Ui(We), _1 = /* @__PURE__ */ Qt(We), b1 = /* @__PURE__ */ en(We), A1 = /* @__PURE__ */ uA(We), g1 = /* @__PURE__ */ lA(We), y1 = /* @__PURE__ */ cA(We), T1 = /* @__PURE__ */ dA(We), M1 = /* @__PURE__ */ pA(We), I1 = /* @__PURE__ */ fA(We), x1 = /* @__PURE__ */ mA(We), F1 = /* @__PURE__ */ hA(We), de = /* @__PURE__ */ I("ZodType", (o, t) => (ce.init(o, t), Object.assign(o["~standard"], {
  jsonSchema: {
    input: Yt(o, "input"),
    output: Yt(o, "output")
  }
}), o.toJSONSchema = Og(o, {}), o.def = t, o.type = t.type, Object.defineProperty(o, "_def", { value: t }), o.check = (...n) => o.clone(Lo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), o.with = o.check, o.clone = (n, a) => ko(o, n, a), o.brand = () => o, o.register = ((n, a) => (n.add(o, a), o)), o.parse = (n, a) => m1(o, n, a, { callee: o.parse }), o.safeParse = (n, a) => _1(o, n, a), o.parseAsync = async (n, a) => h1(o, n, a, { callee: o.parseAsync }), o.safeParseAsync = async (n, a) => b1(o, n, a), o.spa = o.safeParseAsync, o.encode = (n, a) => A1(o, n, a), o.decode = (n, a) => g1(o, n, a), o.encodeAsync = async (n, a) => y1(o, n, a), o.decodeAsync = async (n, a) => T1(o, n, a), o.safeEncode = (n, a) => M1(o, n, a), o.safeDecode = (n, a) => I1(o, n, a), o.safeEncodeAsync = async (n, a) => x1(o, n, a), o.safeDecodeAsync = async (n, a) => F1(o, n, a), o.refine = (n, a) => o.check(Ay(n, a)), o.superRefine = (n) => o.check(gy(n)), o.overwrite = (n) => o.check(/* @__PURE__ */ yr(n)), o.optional = () => Vu(o), o.exactOptional = () => iy(o), o.nullable = () => Ju(o), o.nullish = () => Vu(Ju(o)), o.nonoptional = (n) => dy(o, n), o.array = () => J1(o), o.or = (n) => vl([o, n]), o.and = (n) => Q1(o, n), o.transform = (n) => ju(o, ty(n)), o.default = (n) => uy(o, n), o.prefault = (n) => cy(o, n), o.catch = (n) => fy(o, n), o.pipe = (n) => ju(o, n), o.readonly = () => _y(o), o.describe = (n) => {
  const a = o.clone();
  return $r.add(a, { description: n }), a;
}, Object.defineProperty(o, "description", {
  get() {
    return $r.get(o)?.description;
  },
  configurable: !0
}), o.meta = (...n) => {
  if (n.length === 0)
    return $r.get(o);
  const a = o.clone();
  return $r.add(a, n[0]), a;
}, o.isOptional = () => o.safeParse(void 0).success, o.isNullable = () => o.safeParse(null).success, o.apply = (n) => n(o), o)), Sl = /* @__PURE__ */ I("_ZodString", (o, t) => {
  Zi.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => Gg(o, a, u);
  const n = o._zod.bag;
  o.format = n.format ?? null, o.minLength = n.minimum ?? null, o.maxLength = n.maximum ?? null, o.regex = (...a) => o.check(/* @__PURE__ */ Ig(...a)), o.includes = (...a) => o.check(/* @__PURE__ */ Sg(...a)), o.startsWith = (...a) => o.check(/* @__PURE__ */ Ng(...a)), o.endsWith = (...a) => o.check(/* @__PURE__ */ vg(...a)), o.min = (...a) => o.check(/* @__PURE__ */ jt(...a)), o.max = (...a) => o.check(/* @__PURE__ */ yl(...a)), o.length = (...a) => o.check(/* @__PURE__ */ Tl(...a)), o.nonempty = (...a) => o.check(/* @__PURE__ */ jt(1, ...a)), o.lowercase = (a) => o.check(/* @__PURE__ */ xg(a)), o.uppercase = (a) => o.check(/* @__PURE__ */ Fg(a)), o.trim = () => o.check(/* @__PURE__ */ Eg()), o.normalize = (...a) => o.check(/* @__PURE__ */ wg(...a)), o.toLowerCase = () => o.check(/* @__PURE__ */ Cg()), o.toUpperCase = () => o.check(/* @__PURE__ */ Dg()), o.slugify = () => o.check(/* @__PURE__ */ Lg());
}), S1 = /* @__PURE__ */ I("ZodString", (o, t) => {
  Zi.init(o, t), Sl.init(o, t), o.email = (n) => o.check(/* @__PURE__ */ J0(N1, n)), o.url = (n) => o.check(/* @__PURE__ */ Q0(v1, n)), o.jwt = (n) => o.check(/* @__PURE__ */ mg(q1, n)), o.emoji = (n) => o.check(/* @__PURE__ */ eg(w1, n)), o.guid = (n) => o.check(/* @__PURE__ */ Uu(Ku, n)), o.uuid = (n) => o.check(/* @__PURE__ */ gl(Kr, n)), o.uuidv4 = (n) => o.check(/* @__PURE__ */ j0(Kr, n)), o.uuidv6 = (n) => o.check(/* @__PURE__ */ Y0(Kr, n)), o.uuidv7 = (n) => o.check(/* @__PURE__ */ X0(Kr, n)), o.nanoid = (n) => o.check(/* @__PURE__ */ og(E1, n)), o.guid = (n) => o.check(/* @__PURE__ */ Uu(Ku, n)), o.cuid = (n) => o.check(/* @__PURE__ */ rg(C1, n)), o.cuid2 = (n) => o.check(/* @__PURE__ */ tg(D1, n)), o.ulid = (n) => o.check(/* @__PURE__ */ ng(L1, n)), o.base64 = (n) => o.check(/* @__PURE__ */ dg(G1, n)), o.base64url = (n) => o.check(/* @__PURE__ */ pg(U1, n)), o.xid = (n) => o.check(/* @__PURE__ */ ig(k1, n)), o.ksuid = (n) => o.check(/* @__PURE__ */ ag(B1, n)), o.ipv4 = (n) => o.check(/* @__PURE__ */ sg(R1, n)), o.ipv6 = (n) => o.check(/* @__PURE__ */ ug(P1, n)), o.cidrv4 = (n) => o.check(/* @__PURE__ */ lg(O1, n)), o.cidrv6 = (n) => o.check(/* @__PURE__ */ cg(z1, n)), o.e164 = (n) => o.check(/* @__PURE__ */ fg(Z1, n)), o.datetime = (n) => o.check(a1(n)), o.date = (n) => o.check(u1(n)), o.time = (n) => o.check(c1(n)), o.duration = (n) => o.check(p1(n));
});
function Te(o) {
  return /* @__PURE__ */ V0(S1, o);
}
const ie = /* @__PURE__ */ I("ZodStringFormat", (o, t) => {
  te.init(o, t), Sl.init(o, t);
}), N1 = /* @__PURE__ */ I("ZodEmail", (o, t) => {
  t0.init(o, t), ie.init(o, t);
}), Ku = /* @__PURE__ */ I("ZodGUID", (o, t) => {
  o0.init(o, t), ie.init(o, t);
}), Kr = /* @__PURE__ */ I("ZodUUID", (o, t) => {
  r0.init(o, t), ie.init(o, t);
});
function Xt(o) {
  return /* @__PURE__ */ gl(Kr, o);
}
const v1 = /* @__PURE__ */ I("ZodURL", (o, t) => {
  n0.init(o, t), ie.init(o, t);
}), w1 = /* @__PURE__ */ I("ZodEmoji", (o, t) => {
  i0.init(o, t), ie.init(o, t);
}), E1 = /* @__PURE__ */ I("ZodNanoID", (o, t) => {
  a0.init(o, t), ie.init(o, t);
}), C1 = /* @__PURE__ */ I("ZodCUID", (o, t) => {
  s0.init(o, t), ie.init(o, t);
}), D1 = /* @__PURE__ */ I("ZodCUID2", (o, t) => {
  u0.init(o, t), ie.init(o, t);
}), L1 = /* @__PURE__ */ I("ZodULID", (o, t) => {
  l0.init(o, t), ie.init(o, t);
}), k1 = /* @__PURE__ */ I("ZodXID", (o, t) => {
  c0.init(o, t), ie.init(o, t);
}), B1 = /* @__PURE__ */ I("ZodKSUID", (o, t) => {
  d0.init(o, t), ie.init(o, t);
}), R1 = /* @__PURE__ */ I("ZodIPv4", (o, t) => {
  _0.init(o, t), ie.init(o, t);
}), P1 = /* @__PURE__ */ I("ZodIPv6", (o, t) => {
  b0.init(o, t), ie.init(o, t);
}), O1 = /* @__PURE__ */ I("ZodCIDRv4", (o, t) => {
  A0.init(o, t), ie.init(o, t);
}), z1 = /* @__PURE__ */ I("ZodCIDRv6", (o, t) => {
  g0.init(o, t), ie.init(o, t);
}), G1 = /* @__PURE__ */ I("ZodBase64", (o, t) => {
  y0.init(o, t), ie.init(o, t);
}), U1 = /* @__PURE__ */ I("ZodBase64URL", (o, t) => {
  M0.init(o, t), ie.init(o, t);
}), Z1 = /* @__PURE__ */ I("ZodE164", (o, t) => {
  I0.init(o, t), ie.init(o, t);
}), q1 = /* @__PURE__ */ I("ZodJWT", (o, t) => {
  F0.init(o, t), ie.init(o, t);
}), Nl = /* @__PURE__ */ I("ZodNumber", (o, t) => {
  hl.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => Ug(o, a, u), o.gt = (a, u) => o.check(/* @__PURE__ */ qu(a, u)), o.gte = (a, u) => o.check(/* @__PURE__ */ Ni(a, u)), o.min = (a, u) => o.check(/* @__PURE__ */ Ni(a, u)), o.lt = (a, u) => o.check(/* @__PURE__ */ Zu(a, u)), o.lte = (a, u) => o.check(/* @__PURE__ */ Si(a, u)), o.max = (a, u) => o.check(/* @__PURE__ */ Si(a, u)), o.int = (a) => o.check(Hu(a)), o.safe = (a) => o.check(Hu(a)), o.positive = (a) => o.check(/* @__PURE__ */ qu(0, a)), o.nonnegative = (a) => o.check(/* @__PURE__ */ Ni(0, a)), o.negative = (a) => o.check(/* @__PURE__ */ Zu(0, a)), o.nonpositive = (a) => o.check(/* @__PURE__ */ Si(0, a)), o.multipleOf = (a, u) => o.check(/* @__PURE__ */ $u(a, u)), o.step = (a, u) => o.check(/* @__PURE__ */ $u(a, u)), o.finite = () => o;
  const n = o._zod.bag;
  o.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, o.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, o.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), o.isFinite = !0, o.format = n.format ?? null;
});
function mr(o) {
  return /* @__PURE__ */ gg(Nl, o);
}
const $1 = /* @__PURE__ */ I("ZodNumberFormat", (o, t) => {
  S0.init(o, t), Nl.init(o, t);
});
function Hu(o) {
  return /* @__PURE__ */ yg($1, o);
}
const K1 = /* @__PURE__ */ I("ZodUnknown", (o, t) => {
  N0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => qg();
});
function Wu() {
  return /* @__PURE__ */ Tg(K1);
}
const H1 = /* @__PURE__ */ I("ZodNever", (o, t) => {
  v0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Zg(o, n, a);
});
function W1(o) {
  return /* @__PURE__ */ Mg(H1, o);
}
const V1 = /* @__PURE__ */ I("ZodArray", (o, t) => {
  w0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Vg(o, n, a, u), o.element = t.element, o.min = (n, a) => o.check(/* @__PURE__ */ jt(n, a)), o.nonempty = (n) => o.check(/* @__PURE__ */ jt(1, n)), o.max = (n, a) => o.check(/* @__PURE__ */ yl(n, a)), o.length = (n, a) => o.check(/* @__PURE__ */ Tl(n, a)), o.unwrap = () => o.element;
});
function J1(o, t) {
  return /* @__PURE__ */ kg(V1, o, t);
}
const j1 = /* @__PURE__ */ I("ZodObject", (o, t) => {
  C0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Jg(o, n, a, u), j(o, "shape", () => t.shape), o.keyof = () => qi(Object.keys(o._zod.def.shape)), o.catchall = (n) => o.clone({ ...o._zod.def, catchall: n }), o.passthrough = () => o.clone({ ...o._zod.def, catchall: Wu() }), o.loose = () => o.clone({ ...o._zod.def, catchall: Wu() }), o.strict = () => o.clone({ ...o._zod.def, catchall: W1() }), o.strip = () => o.clone({ ...o._zod.def, catchall: void 0 }), o.extend = (n) => Qb(o, n), o.safeExtend = (n) => eA(o, n), o.merge = (n) => oA(o, n), o.pick = (n) => Yb(o, n), o.omit = (n) => Xb(o, n), o.partial = (...n) => rA(wl, o, n[0]), o.required = (...n) => tA(El, o, n[0]);
});
function jr(o, t) {
  const n = {
    type: "object",
    shape: o ?? {},
    ...L(t)
  };
  return new j1(n);
}
const Y1 = /* @__PURE__ */ I("ZodUnion", (o, t) => {
  D0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => jg(o, n, a, u), o.options = t.options;
});
function vl(o, t) {
  return new Y1({
    type: "union",
    options: o,
    ...L(t)
  });
}
const X1 = /* @__PURE__ */ I("ZodIntersection", (o, t) => {
  L0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Yg(o, n, a, u);
});
function Q1(o, t) {
  return new X1({
    type: "intersection",
    left: o,
    right: t
  });
}
const Ei = /* @__PURE__ */ I("ZodEnum", (o, t) => {
  k0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => $g(o, a, u), o.enum = t.entries, o.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  o.extract = (a, u) => {
    const f = {};
    for (const d of a)
      if (n.has(d))
        f[d] = t.entries[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new Ei({
      ...t,
      checks: [],
      ...L(u),
      entries: f
    });
  }, o.exclude = (a, u) => {
    const f = { ...t.entries };
    for (const d of a)
      if (n.has(d))
        delete f[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new Ei({
      ...t,
      checks: [],
      ...L(u),
      entries: f
    });
  };
});
function qi(o, t) {
  const n = Array.isArray(o) ? Object.fromEntries(o.map((a) => [a, a])) : o;
  return new Ei({
    type: "enum",
    entries: n,
    ...L(t)
  });
}
const ey = /* @__PURE__ */ I("ZodLiteral", (o, t) => {
  B0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Kg(o, n, a), o.values = new Set(t.values), Object.defineProperty(o, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function oy(o, t) {
  return new ey({
    type: "literal",
    values: Array.isArray(o) ? o : [o],
    ...L(t)
  });
}
const ry = /* @__PURE__ */ I("ZodTransform", (o, t) => {
  R0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Wg(o, n), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new Qu(o.constructor.name);
    n.addIssue = (f) => {
      if (typeof f == "string")
        n.issues.push(Jr(f, n.value, t));
      else {
        const d = f;
        d.fatal && (d.continue = !1), d.code ?? (d.code = "custom"), d.input ?? (d.input = n.value), d.inst ?? (d.inst = o), n.issues.push(Jr(d));
      }
    };
    const u = t.transform(n.value, n);
    return u instanceof Promise ? u.then((f) => (n.value = f, n)) : (n.value = u, n);
  };
});
function ty(o) {
  return new ry({
    type: "transform",
    transform: o
  });
}
const wl = /* @__PURE__ */ I("ZodOptional", (o, t) => {
  Al.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Fl(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Vu(o) {
  return new wl({
    type: "optional",
    innerType: o
  });
}
const ny = /* @__PURE__ */ I("ZodExactOptional", (o, t) => {
  P0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Fl(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function iy(o) {
  return new ny({
    type: "optional",
    innerType: o
  });
}
const ay = /* @__PURE__ */ I("ZodNullable", (o, t) => {
  O0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Xg(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Ju(o) {
  return new ay({
    type: "nullable",
    innerType: o
  });
}
const sy = /* @__PURE__ */ I("ZodDefault", (o, t) => {
  z0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => e1(o, n, a, u), o.unwrap = () => o._zod.def.innerType, o.removeDefault = o.unwrap;
});
function uy(o, t) {
  return new sy({
    type: "default",
    innerType: o,
    get defaultValue() {
      return typeof t == "function" ? t() : tl(t);
    }
  });
}
const ly = /* @__PURE__ */ I("ZodPrefault", (o, t) => {
  G0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => o1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function cy(o, t) {
  return new ly({
    type: "prefault",
    innerType: o,
    get defaultValue() {
      return typeof t == "function" ? t() : tl(t);
    }
  });
}
const El = /* @__PURE__ */ I("ZodNonOptional", (o, t) => {
  U0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Qg(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function dy(o, t) {
  return new El({
    type: "nonoptional",
    innerType: o,
    ...L(t)
  });
}
const py = /* @__PURE__ */ I("ZodCatch", (o, t) => {
  Z0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => r1(o, n, a, u), o.unwrap = () => o._zod.def.innerType, o.removeCatch = o.unwrap;
});
function fy(o, t) {
  return new py({
    type: "catch",
    innerType: o,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const my = /* @__PURE__ */ I("ZodPipe", (o, t) => {
  q0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => t1(o, n, a, u), o.in = t.in, o.out = t.out;
});
function ju(o, t) {
  return new my({
    type: "pipe",
    in: o,
    out: t
    // ...util.normalizeParams(params),
  });
}
const hy = /* @__PURE__ */ I("ZodReadonly", (o, t) => {
  $0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => n1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function _y(o) {
  return new hy({
    type: "readonly",
    innerType: o
  });
}
const by = /* @__PURE__ */ I("ZodCustom", (o, t) => {
  K0.init(o, t), de.init(o, t), o._zod.processJSONSchema = (n, a, u) => Hg(o, n);
});
function Ay(o, t = {}) {
  return /* @__PURE__ */ Bg(by, o, t);
}
function gy(o) {
  return /* @__PURE__ */ Rg(o);
}
const Cl = jr({
  userId: Xt(),
  companyId: Xt()
}), yy = Cl.extend({
  auctionId: Xt()
}), Ty = Cl.extend({
  directSaleId: Xt()
}), fT = vl([yy, Ty]), mT = 50, hT = 1, _T = "bnk_", My = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    positionByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    positionAdminByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Front",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    positionByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 60
    },
    positionAdminByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Front Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    positionByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 70
    },
    positionAdminByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Left Side",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    positionByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    positionAdminByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Rear Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    positionByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    positionAdminByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 100,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Rear",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    positionByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    positionAdminByType: {
      MinibusCityIntercity: 110,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 110,
      DoubleDecker: 120
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Rear Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    positionByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 120,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    positionAdminByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 120,
      DoubleDecker: 130
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Right Side",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    positionByType: { Autobus18Mt: 110 },
    positionAdminByType: { Autobus18Mt: 130 },
    label: "Turntable External",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    positionByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    positionAdminByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Front Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    positionByType: {
      MinibusCityIntercity: 130,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 120,
      DoubleDecker: 120
    },
    positionAdminByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt"],
    label: "3/4 Front Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    positionByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 130,
      DoubleDecker: 130
    },
    positionAdminByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    requiredFor: ["AutobusNormalFloor3Axle"],
    label: "Front Door Open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    positionByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    positionAdminByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 150,
      Autobus18Mt: 160,
      DoubleDecker: 160
    },
    requiredFor: ["AutobusNormalFloor3Axle"],
    label: "Right Side Doors Open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    positionByType: {
      MinibusCityIntercity: 220,
      MinibusTouristic: 220,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    positionAdminByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 240,
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 170,
      DoubleDecker: 170
    },
    label: "Second Door Open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    positionByType: { AutobusLowFloorLowEntry8_12Mt: 150, Autobus18Mt: 160 },
    positionAdminByType: { AutobusLowFloorLowEntry8_12Mt: 170, Autobus18Mt: 180 },
    label: "Third Door Open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    positionByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 180,
      DoubleDecker: 160
    },
    positionAdminByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    label: "3/4 Rear Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    positionByType: { MinibusTouristic: 230, AutobusNormalFloor2Axle: 240, AutobusNormalFloor3Axle: 240, DoubleDecker: 250 },
    positionAdminByType: { MinibusTouristic: 250, AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    label: "Luggage Rack Left Side",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    positionByType: { MinibusTouristic: 240, AutobusNormalFloor2Axle: 250, AutobusNormalFloor3Axle: 250, DoubleDecker: 260 },
    positionAdminByType: { MinibusTouristic: 260, AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 280 },
    requiredFor: ["MinibusTouristic", "DoubleDecker"],
    label: "Luggage",
    group: "exteriors",
    description: "A photo showing the luggage compartment of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    positionByType: { AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    positionAdminByType: { AutobusNormalFloor2Axle: 280, AutobusNormalFloor3Axle: 280, DoubleDecker: 290 },
    label: "Luggage Under Carpet Photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    positionByType: {
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 170,
      Autobus18Mt: 190,
      DoubleDecker: 170
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Rear Hatch Open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    positionByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    label: "Air Conditioning Compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    positionByType: {
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    label: "Preheater",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "Fire Suppression System",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    positionByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    positionAdminByType: {
      MinibusCityIntercity: 200,
      MinibusTouristic: 200,
      AutobusNormalFloor2Axle: 240,
      AutobusNormalFloor3Axle: 240,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 250
    },
    label: "Platform Open",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    positionByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    },
    positionAdminByType: {
      MinibusCityIntercity: 210,
      MinibusTouristic: 210,
      AutobusNormalFloor2Axle: 250,
      AutobusNormalFloor3Axle: 250,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 260
    },
    label: "Platform Code",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    positionAdminByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Vehicle Plate",
    group: "technical-data",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    positionByType: {
      MinibusCityIntercity: 230,
      MinibusTouristic: 290,
      AutobusNormalFloor2Axle: 290,
      AutobusNormalFloor3Axle: 280,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 300
    },
    positionAdminByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 320
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Seats Plate",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    positionByType: { MinibusTouristic: 300, AutobusNormalFloor2Axle: 300, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    positionAdminByType: { MinibusTouristic: 320, AutobusNormalFloor2Axle: 320, AutobusNormalFloor3Axle: 310, DoubleDecker: 330 },
    label: "Driver Microphone",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    positionByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 320
    },
    positionAdminByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Driver's Seat",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    positionByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 320,
      AutobusNormalFloor2Axle: 320,
      AutobusNormalFloor3Axle: 310,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 330
    },
    positionAdminByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    label: "Steering Wheel",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    positionByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    positionAdminByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Dashboard Engine On",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    positionByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    positionAdminByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 360,
      AutobusNormalFloor3Axle: 350,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 370
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Complete Driver's Dashboard",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    positionByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    positionAdminByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 380
    },
    requiredFor: ["AutobusNormalFloor2Axle", "DoubleDecker"],
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    positionByType: { AutobusNormalFloor2Axle: 360, AutobusNormalFloor3Axle: 350, DoubleDecker: 370 },
    positionAdminByType: { AutobusNormalFloor2Axle: 380, AutobusNormalFloor3Axle: 370, DoubleDecker: 390 },
    label: "Radio",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    positionByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 380
    },
    positionAdminByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    requiredFor: ["AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Onboard Device 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    positionByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 380,
      AutobusNormalFloor3Axle: 370,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 390
    },
    positionAdminByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 390,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Onboard Device 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    positionByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    positionAdminByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 400,
      AutobusNormalFloor2Axle: 420,
      AutobusNormalFloor3Axle: 410,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 430
    },
    requiredFor: ["MinibusCityIntercity", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt"],
    label: "Command Unit Indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    positionByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 410, AutobusNormalFloor3Axle: 400, DoubleDecker: 420 },
    positionAdminByType: { MinibusTouristic: 430, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    label: "Hostess Seat",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    positionByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 420, AutobusNormalFloor3Axle: 410, DoubleDecker: 430 },
    positionAdminByType: { MinibusTouristic: 440, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    label: "Hostess Microphone",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    positionByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 430,
      AutobusNormalFloor2Axle: 450,
      AutobusNormalFloor3Axle: 440,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 460
    },
    positionAdminByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 390,
      DoubleDecker: 480
    },
    requiredFor: ["AutobusNormalFloor2Axle"],
    label: "Door Mechanism",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    positionByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 440,
      AutobusNormalFloor2Axle: 460,
      AutobusNormalFloor3Axle: 450,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 470
    },
    positionAdminByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 400,
      DoubleDecker: 490
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Reverse Seats From Driver Position",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    positionByType: {
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 400,
      DoubleDecker: 480
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Reverse Seats From Middle Position",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    positionByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 410,
      DoubleDecker: 490
    },
    positionAdminByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Forward Seats From End Position",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    positionByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    positionAdminByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 510,
      AutobusNormalFloor3Axle: 500,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 520
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle"],
    label: "Overhead Compartments",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    positionByType: { AutobusNormalFloor2Axle: 510, AutobusNormalFloor3Axle: 500, DoubleDecker: 520 },
    positionAdminByType: { AutobusNormalFloor2Axle: 530, AutobusNormalFloor3Axle: 520, DoubleDecker: 540 },
    label: "Toilette",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    positionByType: {
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 530
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Forward Seats From Middle Position",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    positionByType: { Autobus18Mt: 390 },
    positionAdminByType: { Autobus18Mt: 410 },
    requiredFor: ["Autobus18Mt"],
    label: "Turntable Internal",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    positionByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 780
    },
    positionAdminByType: {
      MinibusCityIntercity: 380,
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    requiredFor: ["MinibusTouristic"],
    label: "Roof Hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    positionByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 530,
      AutobusNormalFloor3Axle: 520,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 790
    },
    positionAdminByType: {
      MinibusCityIntercity: 390,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 810
    },
    requiredFor: ["MinibusTouristic"],
    label: "Roof Hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    positionByType: {
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    positionAdminByType: {
      MinibusTouristic: 510,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 820
    },
    label: "Roof Hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    positionByType: {
      MinibusCityIntercity: 380,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 530
    },
    positionAdminByType: {
      MinibusCityIntercity: 400,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    requiredFor: ["MinibusCityIntercity", "Autobus18Mt"],
    label: "Disabled Area",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    positionByType: {
      MinibusCityIntercity: 390,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 540
    },
    positionAdminByType: {
      MinibusCityIntercity: 410,
      AutobusNormalFloor2Axle: 580,
      AutobusNormalFloor3Axle: 570,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 560
    },
    label: "Folding Seats",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    positionByType: {
      MinibusCityIntercity: 400,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    positionAdminByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 520,
      AutobusNormalFloor2Axle: 590,
      AutobusNormalFloor3Axle: 580,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 570
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Seats",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    positionByType: { MinibusTouristic: 510, AutobusNormalFloor2Axle: 590, AutobusNormalFloor3Axle: 580, DoubleDecker: 570 },
    positionAdminByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    label: "Mesh",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    positionByType: { MinibusTouristic: 520, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    positionAdminByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    label: "Table",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    positionByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    positionAdminByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    label: "Usb Charging",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    positionByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 580, AutobusNormalFloor3Axle: 570, DoubleDecker: 560 },
    positionAdminByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    label: "Armrest",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    positionByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    positionAdminByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    label: "Footrest",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    positionByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    positionAdminByType: { MinibusTouristic: 580, AutobusNormalFloor2Axle: 660, AutobusNormalFloor3Axle: 650, DoubleDecker: 640 },
    label: "Monitor",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    positionByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    positionAdminByType: { MinibusTouristic: 590, AutobusNormalFloor2Axle: 650, AutobusNormalFloor3Axle: 640, DoubleDecker: 630 },
    label: "Power Outlets",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    positionByType: { MinibusTouristic: 390, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    positionAdminByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 450, AutobusNormalFloor3Axle: 440, DoubleDecker: 460 },
    label: "Coffee Machine",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    positionByType: {
      MinibusCityIntercity: 410,
      MinibusTouristic: 580,
      AutobusNormalFloor2Axle: 650,
      AutobusNormalFloor3Axle: 640,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 660
    },
    positionAdminByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 680
    },
    label: "Seats Bracket",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    positionByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 590,
      AutobusNormalFloor2Axle: 660,
      AutobusNormalFloor3Axle: 650,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 670
    },
    positionAdminByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 690
    },
    label: "Camera",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    positionByType: {
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      DoubleDecker: 1310
    },
    positionAdminByType: {
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      DoubleDecker: 1330
    },
    requiredFor: ["MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "DoubleDecker"],
    label: "Spare Tyre",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    positionByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      Autobus18Mt: 1060,
      DoubleDecker: 1330
    },
    positionAdminByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    positionByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    positionAdminByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    positionByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    positionAdminByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    positionByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    positionAdminByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1230,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1130,
      DoubleDecker: 1400
    },
    label: "Second Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    positionByType: { AutobusNormalFloor3Axle: 1230, Autobus18Mt: 1130, DoubleDecker: 1400 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    positionByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    label: "Third Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    positionByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1290, Autobus18Mt: 1190, DoubleDecker: 1460 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the third axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    positionByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1290,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1190,
      DoubleDecker: 1460
    },
    positionAdminByType: {
      MinibusCityIntercity: 900,
      MinibusTouristic: 1080,
      AutobusNormalFloor2Axle: 1160,
      AutobusNormalFloor3Axle: 1310,
      AutobusLowFloorLowEntry8_12Mt: 980,
      Autobus18Mt: 1210,
      DoubleDecker: 1480
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    positionByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 850
    },
    positionAdminByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Front Undercarriage",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    positionByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    positionAdminByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Right Side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    positionByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    positionAdminByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    label: "First Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    positionByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    positionAdminByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    label: "First Axle Brake Calipers Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    positionByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    positionAdminByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    label: "First Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    positionByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    positionAdminByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    label: "First Axle Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    positionByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 860
    },
    positionAdminByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    label: "First Axle Central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    positionByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    positionAdminByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    positionByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    positionAdminByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    label: "First Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    positionByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    positionAdminByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    label: "First Axle Brake Calipers Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    positionByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    positionAdminByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    label: "First Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    positionByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    positionAdminByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    label: "First Axle Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    positionByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    positionAdminByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Central Undercarriage",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    positionByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    positionAdminByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    label: "Second Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    positionByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    positionAdminByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    label: "Second Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "Second Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "Second Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    positionByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    positionAdminByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    label: "Second Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    positionByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    positionAdminByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    label: "Second Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    positionByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    positionAdminByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    label: "Second Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    positionByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    positionAdminByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    label: "Second Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    positionByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    positionAdminByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    label: "Second Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_first_shock_absorbers_right_side: {
    name: "photo_second_axle_first_shock_absorbers_right_side",
    position: 995,
    position_admin: 995,
    positionByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    positionAdminByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    label: "Second Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    positionByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    positionAdminByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    label: "Second Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_second_shock_absorbers_right_side: {
    name: "photo_second_axle_second_shock_absorbers_right_side",
    position: 1005,
    position_admin: 1005,
    positionByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    positionAdminByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    label: "Second Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    positionByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    positionAdminByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 960,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 820,
      DoubleDecker: 1130
    },
    label: "Second Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    positionByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    positionAdminByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 970,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 830,
      DoubleDecker: 1140
    },
    label: "Second Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    positionByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    positionAdminByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    label: "Second Axle Central",
    group: "undercarriage",
    description: "A photo of the second axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    positionByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    positionAdminByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Second Axle Left Side",
    group: "undercarriage",
    description: "A photo of the second axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side: {
    name: "photo_second_axle_right_side",
    position: 1045,
    position_admin: 1045,
    positionByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    positionAdminByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "DoubleDecker"],
    label: "Second Axle Right Side",
    group: "undercarriage",
    description: "A photo of the second axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    positionByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    label: "Third Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    positionByType: { AutobusNormalFloor3Axle: 990, Autobus18Mt: 860, DoubleDecker: 1160 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    label: "Third Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    positionByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 890, DoubleDecker: 1190 },
    label: "Third Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    positionByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 900, DoubleDecker: 1200 },
    label: "Third Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    positionByType: { Autobus18Mt: 890 },
    positionAdminByType: { Autobus18Mt: 910 },
    label: "Third Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    positionByType: { Autobus18Mt: 900 },
    positionAdminByType: { Autobus18Mt: 920 },
    label: "Third Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    positionByType: {
      AutobusNormalFloor3Axle: 970,
      Autobus18Mt: 840,
      DoubleDecker: 1140
    },
    positionAdminByType: {
      AutobusNormalFloor3Axle: 990,
      Autobus18Mt: 860,
      DoubleDecker: 1160
    },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Right Side",
    group: "undercarriage",
    description: "A photo of the third axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    positionByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 920, DoubleDecker: 1200 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    label: "Third Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    positionByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    label: "Third Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    positionByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1070, Autobus18Mt: 960, DoubleDecker: 1240 },
    label: "Third Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    positionByType: { Autobus18Mt: 960 },
    positionAdminByType: { Autobus18Mt: 980 },
    label: "Third Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    positionByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1080, Autobus18Mt: 970, DoubleDecker: 1250 },
    label: "Third Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    positionByType: { Autobus18Mt: 970 },
    positionAdminByType: { Autobus18Mt: 990 },
    label: "Third Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    positionByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 1070,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 980,
      DoubleDecker: 1240
    },
    positionAdminByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Differential",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    positionByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    positionAdminByType: {
      MinibusCityIntercity: 470,
      MinibusTouristic: 640,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Gearbox",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    positionByType: {
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    label: "Gearbox Plate",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    positionByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 1080,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 990,
      DoubleDecker: 1250
    },
    positionAdminByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    label: "Driveshaft",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    positionByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    positionAdminByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Engine Without Protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    positionByType: {
      MinibusCityIntercity: 490,
      MinibusTouristic: 660,
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    positionAdminByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      Autobus18Mt: 1050,
      DoubleDecker: 1310
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Exhaust",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    positionByType: { Autobus18Mt: 820 },
    positionAdminByType: { Autobus18Mt: 840 },
    label: "Undercarriage Turntable",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    positionByType: {
      MinibusCityIntercity: 900,
      MinibusTouristic: 1080,
      AutobusNormalFloor2Axle: 1160,
      AutobusNormalFloor3Axle: 1310,
      AutobusLowFloorLowEntry8_12Mt: 980,
      Autobus18Mt: 1210,
      DoubleDecker: 1480
    },
    positionAdminByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Vin",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 110, MinibusTouristic: 100 },
    positionAdminByType: { MinibusCityIntercity: 130, MinibusTouristic: 120 },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic"],
    label: "Front Engine",
    group: "exteriors",
    description: "A photo of the engine at the front of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_fourth_door_open: {
    name: "photo_fourth_door_open",
    position: 145,
    position_admin: 145,
    positionByType: { Autobus18Mt: 170 },
    positionAdminByType: { Autobus18Mt: 190 },
    label: "Fourth Door Open",
    group: "exteriors",
    description: "A photo of: Fourth Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_complete_tyre: {
    name: "photo_first_axle_left_side_complete_tyre",
    position: 695,
    position_admin: 695,
    positionByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1050,
      DoubleDecker: 1320
    },
    positionAdminByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Complete Tyre",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Complete Tyre.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_tyre_thickness: {
    name: "photo_first_axle_left_side_tyre_thickness",
    position: 705,
    position_admin: 705,
    positionByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    positionAdminByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    label: "First Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Tyre Thickness.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_size: {
    name: "photo_second_axle_left_side_tyre_size",
    position: 725,
    position_admin: 725,
    positionByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    positionAdminByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_tread: {
    name: "photo_second_axle_left_side_tyre_tread",
    position: 735,
    position_admin: 735,
    positionByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    positionAdminByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1240,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1140,
      DoubleDecker: 1410
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_size: {
    name: "photo_third_axle_left_side_tyre_size",
    position: 745,
    position_admin: 745,
    positionByType: { AutobusNormalFloor3Axle: 1240, Autobus18Mt: 1140, DoubleDecker: 1410 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_tread: {
    name: "photo_third_axle_left_side_tyre_tread",
    position: 755,
    position_admin: 755,
    positionByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1280, Autobus18Mt: 1180, DoubleDecker: 1450 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side_tyre_tread: {
    name: "photo_second_axle_right_side_tyre_tread",
    position: 765,
    position_admin: 765,
    positionByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1280,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1180,
      DoubleDecker: 1450
    },
    positionAdminByType: {
      MinibusCityIntercity: 890,
      MinibusTouristic: 1070,
      AutobusNormalFloor2Axle: 1150,
      AutobusNormalFloor3Axle: 1300,
      AutobusLowFloorLowEntry8_12Mt: 970,
      Autobus18Mt: 1200,
      DoubleDecker: 1470
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Right Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side: {
    name: "photo_third_axle_left_side",
    position: 1185,
    position_admin: 1185,
    positionByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 910, DoubleDecker: 1190 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    requiredFor: ["Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side",
    group: "undercarriage",
    description: "A photo of: Third Axle Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_central: {
    name: "photo_third_axle_central",
    position: 1195,
    position_admin: 1195,
    positionByType: { AutobusNormalFloor3Axle: 960, Autobus18Mt: 830, DoubleDecker: 1130 },
    positionAdminByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    label: "Third Axle Central",
    group: "undercarriage",
    description: "A photo of: Third Axle Central.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_door_open: {
    name: "photo_driver_door_open",
    position: 1300,
    position_admin: 1300,
    positionByType: { MinibusCityIntercity: 200, MinibusTouristic: 200 },
    positionAdminByType: { MinibusCityIntercity: 220, MinibusTouristic: 220 },
    requiredFor: ["MinibusTouristic"],
    label: "Driver Door Open",
    group: "exteriors",
    description: "A photo of: Driver Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_doors_open: {
    name: "photo_rear_doors_open",
    position: 1310,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 210, MinibusTouristic: 210 },
    positionAdminByType: { MinibusCityIntercity: 230, MinibusTouristic: 230 },
    requiredFor: ["MinibusTouristic"],
    label: "Rear Doors Open",
    group: "exteriors",
    description: "A photo of: Rear Doors Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_electric_parking_brake: {
    name: "photo_electric_parking_brake",
    position: 1320,
    position_admin: 1320,
    positionByType: { MinibusCityIntercity: 470, MinibusTouristic: 640 },
    positionAdminByType: { MinibusCityIntercity: 490, MinibusTouristic: 660 },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic"],
    label: "Electric Parking Brake",
    group: "undercarriage",
    description: "A photo of: Electric Parking Brake.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_undercarriage: {
    name: "photo_rear_undercarriage",
    position: 1330,
    position_admin: 1330,
    positionByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    positionAdminByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1060,
      DoubleDecker: 1320
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Rear Undercarriage",
    group: "undercarriage",
    description: "A photo of: Rear Undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_1: {
    name: "photo_luggage_rear_1",
    position: 1340,
    position_admin: 1340,
    positionByType: { MinibusTouristic: 250 },
    positionAdminByType: { MinibusTouristic: 270 },
    label: "Luggage Rear 1",
    group: "exteriors",
    description: "A photo of: Luggage Rear 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_2: {
    name: "photo_luggage_rear_2",
    position: 1350,
    position_admin: 1350,
    positionByType: { MinibusTouristic: 260 },
    positionAdminByType: { MinibusTouristic: 280 },
    label: "Luggage Rear 2",
    group: "exteriors",
    description: "A photo of: Luggage Rear 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_3: {
    name: "photo_luggage_rear_3",
    position: 1360,
    position_admin: 1360,
    positionByType: { MinibusTouristic: 270 },
    positionAdminByType: { MinibusTouristic: 290 },
    label: "Luggage Rear 3",
    group: "exteriors",
    description: "A photo of: Luggage Rear 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rack_right: {
    name: "photo_luggage_rack_right",
    position: 1370,
    position_admin: 1370,
    positionByType: { MinibusTouristic: 280, DoubleDecker: 280 },
    positionAdminByType: { MinibusTouristic: 300, DoubleDecker: 300 },
    requiredFor: ["MinibusTouristic"],
    label: "Luggage Rack Right",
    group: "exteriors",
    description: "A photo of: Luggage Rack Right.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_refrigerator: {
    name: "photo_refrigerator",
    position: 1380,
    position_admin: 1380,
    positionByType: { MinibusTouristic: 400, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    positionAdminByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 460, AutobusNormalFloor3Axle: 450, DoubleDecker: 470 },
    label: "Refrigerator",
    group: "interiors",
    description: "A photo of: Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_suppression_nozzles: {
    name: "photo_fire_suppression_nozzles",
    position: 1390,
    position_admin: 1390,
    positionByType: {
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    label: "Fire Suppression Nozzles",
    group: "exteriors",
    description: "A photo of: Fire Suppression Nozzles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_s_bunk: {
    name: "photo_driver_s_bunk",
    position: 1400,
    position_admin: 1400,
    positionByType: { AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 290 },
    positionAdminByType: { AutobusNormalFloor2Axle: 290, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    label: "Driver's Bunk",
    group: "exteriors",
    description: "A photo of: Driver's Bunk.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_onboard_device_3_left_side: {
    name: "photo_onboard_device_3_left_side",
    position: 1410,
    position_admin: 1410,
    positionByType: {
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 410,
      AutobusNormalFloor3Axle: 400,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 420
    },
    requiredFor: ["AutobusNormalFloor2Axle"],
    label: "Onboard Device 3 Left Side",
    group: "interiors",
    description: "A photo of: Onboard Device 3 Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_2: {
    name: "photo_monitor_2",
    position: 1420,
    position_admin: 1420,
    positionByType: { DoubleDecker: 630 },
    positionAdminByType: { DoubleDecker: 650 },
    label: "Monitor 2",
    group: "interiors",
    description: "A photo of: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_3: {
    name: "photo_monitor_3",
    position: 1430,
    position_admin: 1430,
    positionByType: { DoubleDecker: 640 },
    positionAdminByType: { DoubleDecker: 660 },
    label: "Monitor 3",
    group: "interiors",
    description: "A photo of: Monitor 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_4: {
    name: "photo_monitor_4",
    position: 1440,
    position_admin: 1440,
    positionByType: { DoubleDecker: 650 },
    positionAdminByType: { DoubleDecker: 670 },
    label: "Monitor 4",
    group: "interiors",
    description: "A photo of: Monitor 4.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_refrigerator: {
    name: "photo_second_refrigerator",
    position: 1450,
    position_admin: 1450,
    positionByType: { DoubleDecker: 680 },
    positionAdminByType: { DoubleDecker: 700 },
    label: "Second Refrigerator",
    group: "interiors",
    description: "A photo of: Second Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_kitchen: {
    name: "photo_kitchen",
    position: 1460,
    position_admin: 1460,
    positionByType: { DoubleDecker: 690 },
    positionAdminByType: { DoubleDecker: 710 },
    label: "Kitchen",
    group: "interiors",
    description: "A photo of: Kitchen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_1: {
    name: "photo_ladder_1",
    position: 1470,
    position_admin: 1470,
    positionByType: { DoubleDecker: 720 },
    positionAdminByType: { DoubleDecker: 740 },
    requiredFor: ["DoubleDecker"],
    label: "Ladder 1",
    group: "interiors",
    description: "A photo of: Ladder 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_2: {
    name: "photo_ladder_2",
    position: 1480,
    position_admin: 1480,
    positionByType: { DoubleDecker: 730 },
    positionAdminByType: { DoubleDecker: 750 },
    requiredFor: ["DoubleDecker"],
    label: "Ladder 2",
    group: "interiors",
    description: "A photo of: Ladder 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_windscreen_position: {
    name: "photo_second_floor_reverse_seats_from_windscreen_position",
    position: 1490,
    position_admin: 1490,
    positionByType: { DoubleDecker: 740 },
    positionAdminByType: { DoubleDecker: 760 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Reverse Seats From Windscreen Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Windscreen Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_middle_position: {
    name: "photo_second_floor_reverse_seats_from_middle_position",
    position: 1500,
    position_admin: 1500,
    positionByType: { DoubleDecker: 750 },
    positionAdminByType: { DoubleDecker: 770 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Reverse Seats From Middle Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Middle Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_forward_seats_from_end_position: {
    name: "photo_second_floor_forward_seats_from_end_position",
    position: 1510,
    position_admin: 1510,
    positionByType: { DoubleDecker: 760 },
    positionAdminByType: { DoubleDecker: 780 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Forward Seats From End Position",
    group: "interiors",
    description: "A photo of: Second Floor: Forward Seats From End Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_overhead_compartments: {
    name: "photo_second_floor_overhead_compartments",
    position: 1520,
    position_admin: 1520,
    positionByType: { DoubleDecker: 770 },
    positionAdminByType: { DoubleDecker: 790 },
    label: "Second Floor: Overhead Compartments",
    group: "interiors",
    description: "A photo of: Second Floor: Overhead compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_1: {
    name: "photo_second_floor_monitor_1",
    position: 1530,
    position_admin: 1530,
    positionByType: { DoubleDecker: 810 },
    positionAdminByType: { DoubleDecker: 830 },
    label: "Second Floor: Monitor 1",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_2: {
    name: "photo_second_floor_monitor_2",
    position: 1540,
    position_admin: 1540,
    positionByType: { DoubleDecker: 820 },
    positionAdminByType: { DoubleDecker: 840 },
    label: "Second Floor: Monitor 2",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_right_side: {
    name: "photo_windscreen_from_right_side",
    position: 1620,
    position_admin: 1620,
    positionByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    positionAdminByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 50
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Windscreen From Right Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Right Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_left_side: {
    name: "photo_windscreen_from_left_side",
    position: 1630,
    position_admin: 1630,
    positionByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    positionAdminByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 60
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Windscreen From Left Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Left Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_upper_windscreen: {
    name: "photo_upper_windscreen",
    position: 1640,
    position_admin: 1640,
    positionByType: { DoubleDecker: 50 },
    positionAdminByType: { DoubleDecker: 70 },
    requiredFor: ["DoubleDecker"],
    label: "Upper Windscreen",
    group: "exteriors",
    description: "A photo of: Upper Windscreen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  }
}, bT = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, Iy = {
  video_internal_second_floor_reverse_seats_full: {
    name: "video_internal_second_floor_reverse_seats_full",
    label: "Video: Internal-Second Floor: Reverse Seats From Windscreen Position to the End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 830 },
    positionAdminByType: { DoubleDecker: 850 },
    requiredFor: ["DoubleDecker"]
  },
  video_internal_second_floor_second: {
    name: "video_internal_second_floor_second",
    label: "Video: Internal-Second Floor-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 840 },
    positionAdminByType: { DoubleDecker: 860 },
    requiredFor: ["DoubleDecker"]
  },
  video_engine_working: {
    name: "video_engine_working",
    label: "Video: Engine Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    positionAdminByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ]
  },
  video_wheelchair_ramp_working: {
    name: "video_wheelchair_ramp_working",
    label: "Video: Automatic Wheelchair Ramp Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    positionAdminByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    }
  },
  video_internal_driver_to_end: {
    name: "video_internal_driver_to_end",
    label: "Video: Internal-From Driver Position To The End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 700
    },
    positionAdminByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 720
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ]
  },
  video_internal_second: {
    name: "video_internal_second",
    label: "Video: Internal-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 710
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 730
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"]
  },
  video_warranty: {
    name: "video_warranty",
    label: "Video: Fleequid Internal Use Video",
    group: "exteriors",
    isInternal: !0,
    positionAdminByType: {
      MinibusCityIntercity: 910,
      MinibusTouristic: 14500,
      AutobusNormalFloor2Axle: 14500,
      AutobusNormalFloor3Axle: 14500,
      AutobusLowFloorLowEntry8_12Mt: 14500,
      Autobus18Mt: 14500,
      DoubleDecker: 14500
    }
  }
}, xy = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], Fy = [
  {
    name: "Abruzzo",
    code: "IT-65",
    regionMacro: "center",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    regionMacro: "south",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    regionMacro: "south",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    regionMacro: "south",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    regionMacro: "north",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    regionMacro: "north",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    regionMacro: "center",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    regionMacro: "north",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    regionMacro: "north",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    regionMacro: "center",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    regionMacro: "south",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    regionMacro: "north",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    regionMacro: "south",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    regionMacro: "excluded",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    regionMacro: "excluded",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    regionMacro: "center",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    regionMacro: "north",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    regionMacro: "center",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", regionMacro: "north", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    regionMacro: "north",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], Sy = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], Ny = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], $i = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czech Republic",
      it: "Repubblica Ceca",
      es: "República Checa",
      de: "Tschechische Republik",
      pl: "Czechy",
      fr: "République tchèque",
      nl: "Tsjechië",
      pt: "República Checa",
      cs: "Česko",
      ro: "Republica Cehă",
      ru: "Чешская Республика"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: xy,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Ny,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Fy,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Sy,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, AT = (o) => $i[o].i18nNames.en;
function gT(...o) {
  const t = /* @__PURE__ */ new Set();
  for (const [n, a] of Object.entries($i))
    o.includes(a.continent) && t.add(n);
  return t;
}
const Dl = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function yT(o) {
  if (vy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return o;
}
function vy(o) {
  return typeof o == "string" && Dl.includes(o);
}
const Ll = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function wy(o) {
  return typeof o == "string" && Object.values(Ll).includes(o);
}
function TT(o) {
  if (wy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return o;
}
function MT(o) {
  return Ll[o];
}
const IT = 10 * 1024 * 1024, xT = "pdf", Ey = Object.fromEntries(
  Object.entries($i).map(([o, t]) => [
    o,
    ("regions" in t ? t.regions : []).flatMap(
      (n) => ("provinces" in n ? n.provinces : []).map((a) => a)
    )
  ])
), Cy = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], Dy = qi(Cy), FT = (o) => Dy.parse(o), ST = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, Ly = [...Dl, "EU", "EXTRA_EU"];
function ky(o) {
  return typeof o == "string" && Ly.includes(o);
}
function NT(o) {
  if (ky(o) !== !0)
    throw new Error(`'${o}' is not a valid tax code origin`);
  return o;
}
const vT = [
  "Locate every piece of visible text in this photo of a bus.",
  "Include liveries, operator names, destination signs, phone numbers, web addresses, registration plates, and any small print.",
  "Return one entry per distinct piece of text."
].join(`
`), By = ["ai", "manual"], wT = jr({
  left: mr(),
  top: mr(),
  width: mr(),
  height: mr(),
  origin: qi(By),
  text: Te().optional()
}).readonly(), Ki = "https://145031484.fs1.hubspotusercontent-eu1.net/hubfs/145031484", ET = (o) => `${Ki}/sales/${o}.jpeg`, CT = `${Ki}/sales/fleequid-expert.webp`, DT = (o) => `${Ki}/flags/${o}.svg`, LT = "backoffice@fleequid.com", kT = "+39 0287176063", BT = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, Ry = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function RT(o) {
  return Ry[o];
}
const PT = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, OT = 2, zT = 300, GT = /^ACT-\d+$/iu, UT = /^DS-\d+$/iu, ZT = 0, qT = 25e5, $T = 5e3, KT = 0, HT = 25e5, WT = 5e4, VT = 1980, JT = (/* @__PURE__ */ new Date()).getFullYear(), jT = 1, YT = 3.5, XT = 23, QT = 0.5, eM = 1.5, oM = 5, rM = 0.1, tM = 1.5, nM = 5, iM = 0.1, aM = [5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140], sM = [1, 2, 3, 4], uM = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], lM = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], cM = 100, dM = 500, pM = 100, fM = 50, mM = 650, hM = 10, _M = 1, bM = 150, AM = 1, gM = 1, yM = 150, TM = 1, MM = 0, IM = 18, xM = 1, FM = 1500, SM = 18e3, NM = 500, kl = {
  addressNumber: Te().optional().nullable(),
  alternate: Te().optional().nullable(),
  country: Te(),
  countryCode: Te(),
  fullAddress: Te(),
  latitude: mr(),
  longitude: mr(),
  mapboxId: Te(),
  place: Te(),
  postcode: Te().optional().nullable(),
  region: Te(),
  streetName: Te().optional().nullable()
}, vM = jr(kl), wM = (o) => jr(kl, { error: o }), Py = "AdminUserPasswordResetToken", EM = jr({
  type: oy(Py),
  adminUserId: Te(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: Te()
}), Oy = /^\+[1-9]\d{1,14}$/, CM = (o) => /^[+]?[\s0-9]{6,}$/.test(o), Bl = (o) => typeof o != "string" || (o.match(/\s/g)?.length ?? 0) > 1 ? !1 : Oy.test(o.replace(/\s/g, "")), Rl = "Phone must be in E.164 format (e.g. +393331234567)", DM = () => Te().refine(Bl, { message: Rl }), LM = () => Te().refine((o) => !o || Bl(o), { message: Rl }).optional(), Pl = Te().min(5).brand("Tin");
function kM(o) {
  return Pl.safeParse(o).success;
}
function zy(o) {
  const t = Pl.safeParse(o);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${o}' as Tin: ${t.error.issues.map(({ message: n }) => n).join(", ")}`);
}
function BM(o) {
  return zy(o.replace(/[^a-zA-Z0-9]/g, ""));
}
const RM = (o) => Math.ceil(o * 1.35962), PM = (o, ...t) => o ? t.map((n) => typeof n == "function" ? n() : n) : [];
function Gy(o) {
  return o.length > 0 && !!o[0] && typeof o[0] == "object";
}
const OM = (o) => {
  if (!o)
    return {};
  const n = Object.keys(o).map((a) => Array.isArray(o[a]) && o[a].length > 0 ? Gy(o[a]) ? o[a].map(
    (u, f) => Object.keys(u).map((d) => [`${a}[${f}][${d}]`, u[d]])
  ).flat() : [[`${a}[]`, o[a]]] : o[a] !== null && typeof o[a] == "object" && !Array.isArray(o[a]) ? Object.keys(o[a]).map((u) => [`${a}[${u}]`, o[a][u]]) : [[a, o[a]]]).flat();
  return Object.fromEntries(n);
};
var Ht = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Hr = { exports: {} };
var Uy = Hr.exports, Yu;
function Zy() {
  return Yu || (Yu = 1, (function(o, t) {
    (function() {
      var n, a = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", _ = "Invalid `variable` option passed into `_.template`", T = "Invalid `imports` option passed into `_.template`", S = "__lodash_hash_undefined__", w = 500, z = "__lodash_placeholder__", D = 1, P = 2, ae = 4, ee = 1, co = 2, Ce = 1, Mo = 2, De = 4, oe = 8, he = 16, oo = 32, Bo = 64, po = 128, Tr = 256, rn = 512, ql = 30, $l = "...", Kl = 800, Hl = 16, Ji = 1, Wl = 2, Vl = 3, Ro = 1 / 0, Io = 9007199254740991, Jl = 17976931348623157e292, Xr = NaN, ro = 4294967295, jl = ro - 1, Yl = ro >>> 1, Xl = [
        ["ary", po],
        ["bind", Ce],
        ["bindKey", Mo],
        ["curry", oe],
        ["curryRight", he],
        ["flip", rn],
        ["partial", oo],
        ["partialRight", Bo],
        ["rearg", Tr]
      ], Yo = "[object Arguments]", Qr = "[object Array]", Ql = "[object AsyncFunction]", Mr = "[object Boolean]", Ir = "[object Date]", ec = "[object DOMException]", et = "[object Error]", ot = "[object Function]", ji = "[object GeneratorFunction]", Ve = "[object Map]", xr = "[object Number]", oc = "[object Null]", fo = "[object Object]", Yi = "[object Promise]", rc = "[object Proxy]", Fr = "[object RegExp]", Je = "[object Set]", Sr = "[object String]", rt = "[object Symbol]", tc = "[object Undefined]", Nr = "[object WeakMap]", nc = "[object WeakSet]", vr = "[object ArrayBuffer]", Xo = "[object DataView]", tn = "[object Float32Array]", nn = "[object Float64Array]", an = "[object Int8Array]", sn = "[object Int16Array]", un = "[object Int32Array]", ln = "[object Uint8Array]", cn = "[object Uint8ClampedArray]", dn = "[object Uint16Array]", pn = "[object Uint32Array]", ic = /\b__p \+= '';/g, ac = /\b(__p \+=) '' \+/g, sc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Xi = /&(?:amp|lt|gt|quot|#39);/g, Qi = /[&<>"']/g, uc = RegExp(Xi.source), lc = RegExp(Qi.source), cc = /<%-([\s\S]+?)%>/g, dc = /<%([\s\S]+?)%>/g, ea = /<%=([\s\S]+?)%>/g, pc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fc = /^\w*$/, mc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, fn = /[\\^$.*+?()[\]{}|]/g, hc = RegExp(fn.source), mn = /^\s+/, _c = /\s/, bc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ac = /\{\n\/\* \[wrapped with (.+)\] \*/, gc = /,? & /, yc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, oa = /[()=,{}\[\]\/\s]/, Tc = /\\(\\)?/g, Mc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ra = /\w*$/, Ic = /^[-+]0x[0-9a-f]+$/i, xc = /^0b[01]+$/i, Fc = /^\[object .+?Constructor\]$/, Sc = /^0o[0-7]+$/i, Nc = /^(?:0|[1-9]\d*)$/, vc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, tt = /($^)/, wc = /['\n\r\u2028\u2029\\]/g, nt = "\\ud800-\\udfff", Ec = "\\u0300-\\u036f", Cc = "\\ufe20-\\ufe2f", Dc = "\\u20d0-\\u20ff", ta = Ec + Cc + Dc, na = "\\u2700-\\u27bf", ia = "a-z\\xdf-\\xf6\\xf8-\\xff", Lc = "\\xac\\xb1\\xd7\\xf7", kc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Bc = "\\u2000-\\u206f", Rc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", aa = "A-Z\\xc0-\\xd6\\xd8-\\xde", sa = "\\ufe0e\\ufe0f", ua = Lc + kc + Bc + Rc, hn = "['’]", Pc = "[" + nt + "]", la = "[" + ua + "]", it = "[" + ta + "]", ca = "\\d+", Oc = "[" + na + "]", da = "[" + ia + "]", pa = "[^" + nt + ua + ca + na + ia + aa + "]", _n = "\\ud83c[\\udffb-\\udfff]", zc = "(?:" + it + "|" + _n + ")", fa = "[^" + nt + "]", bn = "(?:\\ud83c[\\udde6-\\uddff]){2}", An = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qo = "[" + aa + "]", ma = "\\u200d", ha = "(?:" + da + "|" + pa + ")", Gc = "(?:" + Qo + "|" + pa + ")", _a = "(?:" + hn + "(?:d|ll|m|re|s|t|ve))?", ba = "(?:" + hn + "(?:D|LL|M|RE|S|T|VE))?", Aa = zc + "?", ga = "[" + sa + "]?", Uc = "(?:" + ma + "(?:" + [fa, bn, An].join("|") + ")" + ga + Aa + ")*", Zc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", qc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ya = ga + Aa + Uc, $c = "(?:" + [Oc, bn, An].join("|") + ")" + ya, Kc = "(?:" + [fa + it + "?", it, bn, An, Pc].join("|") + ")", Hc = RegExp(hn, "g"), Wc = RegExp(it, "g"), gn = RegExp(_n + "(?=" + _n + ")|" + Kc + ya, "g"), Vc = RegExp([
        Qo + "?" + da + "+" + _a + "(?=" + [la, Qo, "$"].join("|") + ")",
        Gc + "+" + ba + "(?=" + [la, Qo + ha, "$"].join("|") + ")",
        Qo + "?" + ha + "+" + _a,
        Qo + "+" + ba,
        qc,
        Zc,
        ca,
        $c
      ].join("|"), "g"), Jc = RegExp("[" + ma + nt + ta + sa + "]"), jc = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Yc = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Xc = -1, Q = {};
      Q[tn] = Q[nn] = Q[an] = Q[sn] = Q[un] = Q[ln] = Q[cn] = Q[dn] = Q[pn] = !0, Q[Yo] = Q[Qr] = Q[vr] = Q[Mr] = Q[Xo] = Q[Ir] = Q[et] = Q[ot] = Q[Ve] = Q[xr] = Q[fo] = Q[Fr] = Q[Je] = Q[Sr] = Q[Nr] = !1;
      var X = {};
      X[Yo] = X[Qr] = X[vr] = X[Xo] = X[Mr] = X[Ir] = X[tn] = X[nn] = X[an] = X[sn] = X[un] = X[Ve] = X[xr] = X[fo] = X[Fr] = X[Je] = X[Sr] = X[rt] = X[ln] = X[cn] = X[dn] = X[pn] = !0, X[et] = X[ot] = X[Nr] = !1;
      var Qc = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, ed = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, od = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, rd = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, td = parseFloat, nd = parseInt, Ta = typeof Ht == "object" && Ht && Ht.Object === Object && Ht, id = typeof self == "object" && self && self.Object === Object && self, _e = Ta || id || Function("return this")(), yn = t && !t.nodeType && t, Po = yn && !0 && o && !o.nodeType && o, Ma = Po && Po.exports === yn, Tn = Ma && Ta.process, Ge = (function() {
        try {
          var b = Po && Po.require && Po.require("util").types;
          return b || Tn && Tn.binding && Tn.binding("util");
        } catch {
        }
      })(), Ia = Ge && Ge.isArrayBuffer, xa = Ge && Ge.isDate, Fa = Ge && Ge.isMap, Sa = Ge && Ge.isRegExp, Na = Ge && Ge.isSet, va = Ge && Ge.isTypedArray;
      function Le(b, y, g) {
        switch (g.length) {
          case 0:
            return b.call(y);
          case 1:
            return b.call(y, g[0]);
          case 2:
            return b.call(y, g[0], g[1]);
          case 3:
            return b.call(y, g[0], g[1], g[2]);
        }
        return b.apply(y, g);
      }
      function ad(b, y, g, v) {
        for (var O = -1, W = b == null ? 0 : b.length; ++O < W; ) {
          var pe = b[O];
          y(v, pe, g(pe), b);
        }
        return v;
      }
      function ke(b, y) {
        for (var g = -1, v = b == null ? 0 : b.length; ++g < v && y(b[g], g, b) !== !1; )
          ;
        return b;
      }
      function sd(b, y) {
        for (var g = b == null ? 0 : b.length; g-- && y(b[g], g, b) !== !1; )
          ;
        return b;
      }
      function wa(b, y) {
        for (var g = -1, v = b == null ? 0 : b.length; ++g < v; )
          if (!y(b[g], g, b))
            return !1;
        return !0;
      }
      function xo(b, y) {
        for (var g = -1, v = b == null ? 0 : b.length, O = 0, W = []; ++g < v; ) {
          var pe = b[g];
          y(pe, g, b) && (W[O++] = pe);
        }
        return W;
      }
      function at(b, y) {
        var g = b == null ? 0 : b.length;
        return !!g && er(b, y, 0) > -1;
      }
      function Mn(b, y, g) {
        for (var v = -1, O = b == null ? 0 : b.length; ++v < O; )
          if (g(y, b[v]))
            return !0;
        return !1;
      }
      function re(b, y) {
        for (var g = -1, v = b == null ? 0 : b.length, O = Array(v); ++g < v; )
          O[g] = y(b[g], g, b);
        return O;
      }
      function Fo(b, y) {
        for (var g = -1, v = y.length, O = b.length; ++g < v; )
          b[O + g] = y[g];
        return b;
      }
      function In(b, y, g, v) {
        var O = -1, W = b == null ? 0 : b.length;
        for (v && W && (g = b[++O]); ++O < W; )
          g = y(g, b[O], O, b);
        return g;
      }
      function ud(b, y, g, v) {
        var O = b == null ? 0 : b.length;
        for (v && O && (g = b[--O]); O--; )
          g = y(g, b[O], O, b);
        return g;
      }
      function xn(b, y) {
        for (var g = -1, v = b == null ? 0 : b.length; ++g < v; )
          if (y(b[g], g, b))
            return !0;
        return !1;
      }
      var ld = Fn("length");
      function cd(b) {
        return b.split("");
      }
      function dd(b) {
        return b.match(yc) || [];
      }
      function Ea(b, y, g) {
        var v;
        return g(b, function(O, W, pe) {
          if (y(O, W, pe))
            return v = W, !1;
        }), v;
      }
      function st(b, y, g, v) {
        for (var O = b.length, W = g + (v ? 1 : -1); v ? W-- : ++W < O; )
          if (y(b[W], W, b))
            return W;
        return -1;
      }
      function er(b, y, g) {
        return y === y ? Id(b, y, g) : st(b, Ca, g);
      }
      function pd(b, y, g, v) {
        for (var O = g - 1, W = b.length; ++O < W; )
          if (v(b[O], y))
            return O;
        return -1;
      }
      function Ca(b) {
        return b !== b;
      }
      function Da(b, y) {
        var g = b == null ? 0 : b.length;
        return g ? Nn(b, y) / g : Xr;
      }
      function Fn(b) {
        return function(y) {
          return y == null ? n : y[b];
        };
      }
      function Sn(b) {
        return function(y) {
          return b == null ? n : b[y];
        };
      }
      function La(b, y, g, v, O) {
        return O(b, function(W, pe, Y) {
          g = v ? (v = !1, W) : y(g, W, pe, Y);
        }), g;
      }
      function fd(b, y) {
        var g = b.length;
        for (b.sort(y); g--; )
          b[g] = b[g].value;
        return b;
      }
      function Nn(b, y) {
        for (var g, v = -1, O = b.length; ++v < O; ) {
          var W = y(b[v]);
          W !== n && (g = g === n ? W : g + W);
        }
        return g;
      }
      function vn(b, y) {
        for (var g = -1, v = Array(b); ++g < b; )
          v[g] = y(g);
        return v;
      }
      function md(b, y) {
        return re(y, function(g) {
          return [g, b[g]];
        });
      }
      function ka(b) {
        return b && b.slice(0, Oa(b) + 1).replace(mn, "");
      }
      function Be(b) {
        return function(y) {
          return b(y);
        };
      }
      function wn(b, y) {
        return re(y, function(g) {
          return b[g];
        });
      }
      function wr(b, y) {
        return b.has(y);
      }
      function Ba(b, y) {
        for (var g = -1, v = b.length; ++g < v && er(y, b[g], 0) > -1; )
          ;
        return g;
      }
      function Ra(b, y) {
        for (var g = b.length; g-- && er(y, b[g], 0) > -1; )
          ;
        return g;
      }
      function hd(b, y) {
        for (var g = b.length, v = 0; g--; )
          b[g] === y && ++v;
        return v;
      }
      var _d = Sn(Qc), bd = Sn(ed);
      function Ad(b) {
        return "\\" + rd[b];
      }
      function gd(b, y) {
        return b == null ? n : b[y];
      }
      function or(b) {
        return Jc.test(b);
      }
      function yd(b) {
        return jc.test(b);
      }
      function Td(b) {
        for (var y, g = []; !(y = b.next()).done; )
          g.push(y.value);
        return g;
      }
      function En(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(v, O) {
          g[++y] = [O, v];
        }), g;
      }
      function Pa(b, y) {
        return function(g) {
          return b(y(g));
        };
      }
      function So(b, y) {
        for (var g = -1, v = b.length, O = 0, W = []; ++g < v; ) {
          var pe = b[g];
          (pe === y || pe === z) && (b[g] = z, W[O++] = g);
        }
        return W;
      }
      function ut(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(v) {
          g[++y] = v;
        }), g;
      }
      function Md(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(v) {
          g[++y] = [v, v];
        }), g;
      }
      function Id(b, y, g) {
        for (var v = g - 1, O = b.length; ++v < O; )
          if (b[v] === y)
            return v;
        return -1;
      }
      function xd(b, y, g) {
        for (var v = g + 1; v--; )
          if (b[v] === y)
            return v;
        return v;
      }
      function rr(b) {
        return or(b) ? Sd(b) : ld(b);
      }
      function je(b) {
        return or(b) ? Nd(b) : cd(b);
      }
      function Oa(b) {
        for (var y = b.length; y-- && _c.test(b.charAt(y)); )
          ;
        return y;
      }
      var Fd = Sn(od);
      function Sd(b) {
        for (var y = gn.lastIndex = 0; gn.test(b); )
          ++y;
        return y;
      }
      function Nd(b) {
        return b.match(gn) || [];
      }
      function vd(b) {
        return b.match(Vc) || [];
      }
      var wd = (function b(y) {
        y = y == null ? _e : tr.defaults(_e.Object(), y, tr.pick(_e, Yc));
        var g = y.Array, v = y.Date, O = y.Error, W = y.Function, pe = y.Math, Y = y.Object, Cn = y.RegExp, Ed = y.String, Ue = y.TypeError, lt = g.prototype, Cd = W.prototype, nr = Y.prototype, ct = y["__core-js_shared__"], dt = Cd.toString, V = nr.hasOwnProperty, Dd = 0, za = (function() {
          var e = /[^.]+$/.exec(ct && ct.keys && ct.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), pt = nr.toString, Ld = dt.call(Y), kd = _e._, Bd = Cn(
          "^" + dt.call(V).replace(fn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), ft = Ma ? y.Buffer : n, No = y.Symbol, mt = y.Uint8Array, Ga = ft ? ft.allocUnsafe : n, ht = Pa(Y.getPrototypeOf, Y), Ua = Y.create, Za = nr.propertyIsEnumerable, _t = lt.splice, qa = No ? No.isConcatSpreadable : n, Er = No ? No.iterator : n, Oo = No ? No.toStringTag : n, bt = (function() {
          try {
            var e = qo(Y, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), Rd = y.clearTimeout !== _e.clearTimeout && y.clearTimeout, Pd = v && v.now !== _e.Date.now && v.now, Od = y.setTimeout !== _e.setTimeout && y.setTimeout, At = pe.ceil, gt = pe.floor, Dn = Y.getOwnPropertySymbols, zd = ft ? ft.isBuffer : n, $a = y.isFinite, Gd = lt.join, Ud = Pa(Y.keys, Y), fe = pe.max, ge = pe.min, Zd = v.now, qd = y.parseInt, Ka = pe.random, $d = lt.reverse, Ln = qo(y, "DataView"), Cr = qo(y, "Map"), kn = qo(y, "Promise"), ir = qo(y, "Set"), Dr = qo(y, "WeakMap"), Lr = qo(Y, "create"), yt = Dr && new Dr(), ar = {}, Kd = $o(Ln), Hd = $o(Cr), Wd = $o(kn), Vd = $o(ir), Jd = $o(Dr), Tt = No ? No.prototype : n, kr = Tt ? Tt.valueOf : n, Ha = Tt ? Tt.toString : n;
        function c(e) {
          if (se(e) && !G(e) && !(e instanceof K)) {
            if (e instanceof Ze)
              return e;
            if (V.call(e, "__wrapped__"))
              return Ws(e);
          }
          return new Ze(e);
        }
        var sr = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(r) {
            if (!ne(r))
              return {};
            if (Ua)
              return Ua(r);
            e.prototype = r;
            var i = new e();
            return e.prototype = n, i;
          };
        })();
        function Mt() {
        }
        function Ze(e, r) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = n;
        }
        c.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: cc,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: dc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: ea,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: c
          }
        }, c.prototype = Mt.prototype, c.prototype.constructor = c, Ze.prototype = sr(Mt.prototype), Ze.prototype.constructor = Ze;
        function K(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ro, this.__views__ = [];
        }
        function jd() {
          var e = new K(this.__wrapped__);
          return e.__actions__ = Se(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Se(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Se(this.__views__), e;
        }
        function Yd() {
          if (this.__filtered__) {
            var e = new K(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Xd() {
          var e = this.__wrapped__.value(), r = this.__dir__, i = G(e), s = r < 0, l = i ? e.length : 0, p = df(0, l, this.__views__), m = p.start, h = p.end, A = h - m, M = s ? h : m - 1, x = this.__iteratees__, F = x.length, N = 0, E = ge(A, this.__takeCount__);
          if (!i || !s && l == A && E == A)
            return _s(e, this.__actions__);
          var R = [];
          e:
            for (; A-- && N < E; ) {
              M += r;
              for (var Z = -1, k = e[M]; ++Z < F; ) {
                var $ = x[Z], H = $.iteratee, Oe = $.type, xe = H(k);
                if (Oe == Wl)
                  k = xe;
                else if (!xe) {
                  if (Oe == Ji)
                    continue e;
                  break e;
                }
              }
              R[N++] = k;
            }
          return R;
        }
        K.prototype = sr(Mt.prototype), K.prototype.constructor = K;
        function zo(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function Qd() {
          this.__data__ = Lr ? Lr(null) : {}, this.size = 0;
        }
        function ep(e) {
          var r = this.has(e) && delete this.__data__[e];
          return this.size -= r ? 1 : 0, r;
        }
        function op(e) {
          var r = this.__data__;
          if (Lr) {
            var i = r[e];
            return i === S ? n : i;
          }
          return V.call(r, e) ? r[e] : n;
        }
        function rp(e) {
          var r = this.__data__;
          return Lr ? r[e] !== n : V.call(r, e);
        }
        function tp(e, r) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = Lr && r === n ? S : r, this;
        }
        zo.prototype.clear = Qd, zo.prototype.delete = ep, zo.prototype.get = op, zo.prototype.has = rp, zo.prototype.set = tp;
        function mo(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function np() {
          this.__data__ = [], this.size = 0;
        }
        function ip(e) {
          var r = this.__data__, i = It(r, e);
          if (i < 0)
            return !1;
          var s = r.length - 1;
          return i == s ? r.pop() : _t.call(r, i, 1), --this.size, !0;
        }
        function ap(e) {
          var r = this.__data__, i = It(r, e);
          return i < 0 ? n : r[i][1];
        }
        function sp(e) {
          return It(this.__data__, e) > -1;
        }
        function up(e, r) {
          var i = this.__data__, s = It(i, e);
          return s < 0 ? (++this.size, i.push([e, r])) : i[s][1] = r, this;
        }
        mo.prototype.clear = np, mo.prototype.delete = ip, mo.prototype.get = ap, mo.prototype.has = sp, mo.prototype.set = up;
        function ho(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function lp() {
          this.size = 0, this.__data__ = {
            hash: new zo(),
            map: new (Cr || mo)(),
            string: new zo()
          };
        }
        function cp(e) {
          var r = Bt(this, e).delete(e);
          return this.size -= r ? 1 : 0, r;
        }
        function dp(e) {
          return Bt(this, e).get(e);
        }
        function pp(e) {
          return Bt(this, e).has(e);
        }
        function fp(e, r) {
          var i = Bt(this, e), s = i.size;
          return i.set(e, r), this.size += i.size == s ? 0 : 1, this;
        }
        ho.prototype.clear = lp, ho.prototype.delete = cp, ho.prototype.get = dp, ho.prototype.has = pp, ho.prototype.set = fp;
        function Go(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new ho(); ++r < i; )
            this.add(e[r]);
        }
        function mp(e) {
          return this.__data__.set(e, S), this;
        }
        function hp(e) {
          return this.__data__.has(e);
        }
        Go.prototype.add = Go.prototype.push = mp, Go.prototype.has = hp;
        function Ye(e) {
          var r = this.__data__ = new mo(e);
          this.size = r.size;
        }
        function _p() {
          this.__data__ = new mo(), this.size = 0;
        }
        function bp(e) {
          var r = this.__data__, i = r.delete(e);
          return this.size = r.size, i;
        }
        function Ap(e) {
          return this.__data__.get(e);
        }
        function gp(e) {
          return this.__data__.has(e);
        }
        function yp(e, r) {
          var i = this.__data__;
          if (i instanceof mo) {
            var s = i.__data__;
            if (!Cr || s.length < u - 1)
              return s.push([e, r]), this.size = ++i.size, this;
            i = this.__data__ = new ho(s);
          }
          return i.set(e, r), this.size = i.size, this;
        }
        Ye.prototype.clear = _p, Ye.prototype.delete = bp, Ye.prototype.get = Ap, Ye.prototype.has = gp, Ye.prototype.set = yp;
        function Wa(e, r) {
          var i = G(e), s = !i && Ko(e), l = !i && !s && Do(e), p = !i && !s && !l && dr(e), m = i || s || l || p, h = m ? vn(e.length, Ed) : [], A = h.length;
          for (var M in e)
            (r || V.call(e, M)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
            (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            p && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
            Ao(M, A))) && h.push(M);
          return h;
        }
        function Va(e) {
          var r = e.length;
          return r ? e[Kn(0, r - 1)] : n;
        }
        function Tp(e, r) {
          return Rt(Se(e), Uo(r, 0, e.length));
        }
        function Mp(e) {
          return Rt(Se(e));
        }
        function Bn(e, r, i) {
          (i !== n && !Qe(e[r], i) || i === n && !(r in e)) && to(e, r, i);
        }
        function Br(e, r, i) {
          var s = e[r];
          (!(V.call(e, r) && Qe(s, i)) || i === n && !(r in e)) && to(e, r, i);
        }
        function It(e, r) {
          for (var i = e.length; i--; )
            if (Qe(e[i][0], r))
              return i;
          return -1;
        }
        function Ip(e, r, i, s) {
          return vo(e, function(l, p, m) {
            r(s, l, i(l), m);
          }), s;
        }
        function Ja(e, r) {
          return e && io(r, me(r), e);
        }
        function xp(e, r) {
          return e && io(r, ve(r), e);
        }
        function to(e, r, i) {
          r == "__proto__" && bt ? bt(e, r, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[r] = i;
        }
        function Rn(e, r) {
          for (var i = -1, s = r.length, l = g(s), p = e == null; ++i < s; )
            l[i] = p ? n : bi(e, r[i]);
          return l;
        }
        function Uo(e, r, i) {
          return e === e && (i !== n && (e = e <= i ? e : i), r !== n && (e = e >= r ? e : r)), e;
        }
        function qe(e, r, i, s, l, p) {
          var m, h = r & D, A = r & P, M = r & ae;
          if (i && (m = l ? i(e, s, l, p) : i(e)), m !== n)
            return m;
          if (!ne(e))
            return e;
          var x = G(e);
          if (x) {
            if (m = ff(e), !h)
              return Se(e, m);
          } else {
            var F = ye(e), N = F == ot || F == ji;
            if (Do(e))
              return gs(e, h);
            if (F == fo || F == Yo || N && !l) {
              if (m = A || N ? {} : Os(e), !h)
                return A ? of(e, xp(m, e)) : ef(e, Ja(m, e));
            } else {
              if (!X[F])
                return l ? e : {};
              m = mf(e, F, h);
            }
          }
          p || (p = new Ye());
          var E = p.get(e);
          if (E)
            return E;
          p.set(e, m), fu(e) ? e.forEach(function(k) {
            m.add(qe(k, r, i, k, e, p));
          }) : du(e) && e.forEach(function(k, $) {
            m.set($, qe(k, r, i, $, e, p));
          });
          var R = M ? A ? ri : oi : A ? ve : me, Z = x ? n : R(e);
          return ke(Z || e, function(k, $) {
            Z && ($ = k, k = e[$]), Br(m, $, qe(k, r, i, $, e, p));
          }), m;
        }
        function Fp(e) {
          var r = me(e);
          return function(i) {
            return ja(i, e, r);
          };
        }
        function ja(e, r, i) {
          var s = i.length;
          if (e == null)
            return !s;
          for (e = Y(e); s--; ) {
            var l = i[s], p = r[l], m = e[l];
            if (m === n && !(l in e) || !p(m))
              return !1;
          }
          return !0;
        }
        function Ya(e, r, i) {
          if (typeof e != "function")
            throw new Ue(d);
          return Zr(function() {
            e.apply(n, i);
          }, r);
        }
        function Rr(e, r, i, s) {
          var l = -1, p = at, m = !0, h = e.length, A = [], M = r.length;
          if (!h)
            return A;
          i && (r = re(r, Be(i))), s ? (p = Mn, m = !1) : r.length >= u && (p = wr, m = !1, r = new Go(r));
          e:
            for (; ++l < h; ) {
              var x = e[l], F = i == null ? x : i(x);
              if (x = s || x !== 0 ? x : 0, m && F === F) {
                for (var N = M; N--; )
                  if (r[N] === F)
                    continue e;
                A.push(x);
              } else p(r, F, s) || A.push(x);
            }
          return A;
        }
        var vo = xs(no), Xa = xs(On, !0);
        function Sp(e, r) {
          var i = !0;
          return vo(e, function(s, l, p) {
            return i = !!r(s, l, p), i;
          }), i;
        }
        function xt(e, r, i) {
          for (var s = -1, l = e.length; ++s < l; ) {
            var p = e[s], m = r(p);
            if (m != null && (h === n ? m === m && !Pe(m) : i(m, h)))
              var h = m, A = p;
          }
          return A;
        }
        function Np(e, r, i, s) {
          var l = e.length;
          for (i = U(i), i < 0 && (i = -i > l ? 0 : l + i), s = s === n || s > l ? l : U(s), s < 0 && (s += l), s = i > s ? 0 : hu(s); i < s; )
            e[i++] = r;
          return e;
        }
        function Qa(e, r) {
          var i = [];
          return vo(e, function(s, l, p) {
            r(s, l, p) && i.push(s);
          }), i;
        }
        function be(e, r, i, s, l) {
          var p = -1, m = e.length;
          for (i || (i = _f), l || (l = []); ++p < m; ) {
            var h = e[p];
            r > 0 && i(h) ? r > 1 ? be(h, r - 1, i, s, l) : Fo(l, h) : s || (l[l.length] = h);
          }
          return l;
        }
        var Pn = Fs(), es = Fs(!0);
        function no(e, r) {
          return e && Pn(e, r, me);
        }
        function On(e, r) {
          return e && es(e, r, me);
        }
        function Ft(e, r) {
          return xo(r, function(i) {
            return go(e[i]);
          });
        }
        function Zo(e, r) {
          r = Eo(r, e);
          for (var i = 0, s = r.length; e != null && i < s; )
            e = e[Xe(r[i++])];
          return i && i == s ? e : n;
        }
        function os(e, r, i) {
          var s = r(e);
          return G(e) ? s : Fo(s, i(e));
        }
        function Me(e) {
          return e == null ? e === n ? tc : oc : Oo && Oo in Y(e) ? cf(e) : If(e);
        }
        function zn(e, r) {
          return e > r;
        }
        function vp(e, r) {
          return e != null && V.call(e, r);
        }
        function wp(e, r) {
          return e != null && r in Y(e);
        }
        function Ep(e, r, i) {
          return e >= ge(r, i) && e < fe(r, i);
        }
        function Gn(e, r, i) {
          for (var s = i ? Mn : at, l = e[0].length, p = e.length, m = p, h = g(p), A = 1 / 0, M = []; m--; ) {
            var x = e[m];
            m && r && (x = re(x, Be(r))), A = ge(x.length, A), h[m] = !i && (r || l >= 120 && x.length >= 120) ? new Go(m && x) : n;
          }
          x = e[0];
          var F = -1, N = h[0];
          e:
            for (; ++F < l && M.length < A; ) {
              var E = x[F], R = r ? r(E) : E;
              if (E = i || E !== 0 ? E : 0, !(N ? wr(N, R) : s(M, R, i))) {
                for (m = p; --m; ) {
                  var Z = h[m];
                  if (!(Z ? wr(Z, R) : s(e[m], R, i)))
                    continue e;
                }
                N && N.push(R), M.push(E);
              }
            }
          return M;
        }
        function Cp(e, r, i, s) {
          return no(e, function(l, p, m) {
            r(s, i(l), p, m);
          }), s;
        }
        function Pr(e, r, i) {
          r = Eo(r, e), e = Zs(e, r);
          var s = e == null ? e : e[Xe(Ke(r))];
          return s == null ? n : Le(s, e, i);
        }
        function rs(e) {
          return se(e) && Me(e) == Yo;
        }
        function Dp(e) {
          return se(e) && Me(e) == vr;
        }
        function Lp(e) {
          return se(e) && Me(e) == Ir;
        }
        function Or(e, r, i, s, l) {
          return e === r ? !0 : e == null || r == null || !se(e) && !se(r) ? e !== e && r !== r : kp(e, r, i, s, Or, l);
        }
        function kp(e, r, i, s, l, p) {
          var m = G(e), h = G(r), A = m ? Qr : ye(e), M = h ? Qr : ye(r);
          A = A == Yo ? fo : A, M = M == Yo ? fo : M;
          var x = A == fo, F = M == fo, N = A == M;
          if (N && Do(e)) {
            if (!Do(r))
              return !1;
            m = !0, x = !1;
          }
          if (N && !x)
            return p || (p = new Ye()), m || dr(e) ? Bs(e, r, i, s, l, p) : uf(e, r, A, i, s, l, p);
          if (!(i & ee)) {
            var E = x && V.call(e, "__wrapped__"), R = F && V.call(r, "__wrapped__");
            if (E || R) {
              var Z = E ? e.value() : e, k = R ? r.value() : r;
              return p || (p = new Ye()), l(Z, k, i, s, p);
            }
          }
          return N ? (p || (p = new Ye()), lf(e, r, i, s, l, p)) : !1;
        }
        function Bp(e) {
          return se(e) && ye(e) == Ve;
        }
        function Un(e, r, i, s) {
          var l = i.length, p = l, m = !s;
          if (e == null)
            return !p;
          for (e = Y(e); l--; ) {
            var h = i[l];
            if (m && h[2] ? h[1] !== e[h[0]] : !(h[0] in e))
              return !1;
          }
          for (; ++l < p; ) {
            h = i[l];
            var A = h[0], M = e[A], x = h[1];
            if (m && h[2]) {
              if (M === n && !(A in e))
                return !1;
            } else {
              var F = new Ye();
              if (s)
                var N = s(M, x, A, e, r, F);
              if (!(N === n ? Or(x, M, ee | co, s, F) : N))
                return !1;
            }
          }
          return !0;
        }
        function ts(e) {
          if (!ne(e) || Af(e))
            return !1;
          var r = go(e) ? Bd : Fc;
          return r.test($o(e));
        }
        function Rp(e) {
          return se(e) && Me(e) == Fr;
        }
        function Pp(e) {
          return se(e) && ye(e) == Je;
        }
        function Op(e) {
          return se(e) && Zt(e.length) && !!Q[Me(e)];
        }
        function ns(e) {
          return typeof e == "function" ? e : e == null ? we : typeof e == "object" ? G(e) ? ss(e[0], e[1]) : as(e) : Nu(e);
        }
        function Zn(e) {
          if (!Ur(e))
            return Ud(e);
          var r = [];
          for (var i in Y(e))
            V.call(e, i) && i != "constructor" && r.push(i);
          return r;
        }
        function zp(e) {
          if (!ne(e))
            return Mf(e);
          var r = Ur(e), i = [];
          for (var s in e)
            s == "constructor" && (r || !V.call(e, s)) || i.push(s);
          return i;
        }
        function qn(e, r) {
          return e < r;
        }
        function is(e, r) {
          var i = -1, s = Ne(e) ? g(e.length) : [];
          return vo(e, function(l, p, m) {
            s[++i] = r(l, p, m);
          }), s;
        }
        function as(e) {
          var r = ni(e);
          return r.length == 1 && r[0][2] ? Gs(r[0][0], r[0][1]) : function(i) {
            return i === e || Un(i, e, r);
          };
        }
        function ss(e, r) {
          return ai(e) && zs(r) ? Gs(Xe(e), r) : function(i) {
            var s = bi(i, e);
            return s === n && s === r ? Ai(i, e) : Or(r, s, ee | co);
          };
        }
        function St(e, r, i, s, l) {
          e !== r && Pn(r, function(p, m) {
            if (l || (l = new Ye()), ne(p))
              Gp(e, r, m, i, St, s, l);
            else {
              var h = s ? s(ui(e, m), p, m + "", e, r, l) : n;
              h === n && (h = p), Bn(e, m, h);
            }
          }, ve);
        }
        function Gp(e, r, i, s, l, p, m) {
          var h = ui(e, i), A = ui(r, i), M = m.get(A);
          if (M) {
            Bn(e, i, M);
            return;
          }
          var x = p ? p(h, A, i + "", e, r, m) : n, F = x === n;
          if (F) {
            var N = G(A), E = !N && Do(A), R = !N && !E && dr(A);
            x = A, N || E || R ? G(h) ? x = h : ue(h) ? x = Se(h) : E ? (F = !1, x = gs(A, !0)) : R ? (F = !1, x = ys(A, !0)) : x = [] : qr(A) || Ko(A) ? (x = h, Ko(h) ? x = _u(h) : (!ne(h) || go(h)) && (x = Os(A))) : F = !1;
          }
          F && (m.set(A, x), l(x, A, s, p, m), m.delete(A)), Bn(e, i, x);
        }
        function us(e, r) {
          var i = e.length;
          if (i)
            return r += r < 0 ? i : 0, Ao(r, i) ? e[r] : n;
        }
        function ls(e, r, i) {
          r.length ? r = re(r, function(p) {
            return G(p) ? function(m) {
              return Zo(m, p.length === 1 ? p[0] : p);
            } : p;
          }) : r = [we];
          var s = -1;
          r = re(r, Be(B()));
          var l = is(e, function(p, m, h) {
            var A = re(r, function(M) {
              return M(p);
            });
            return { criteria: A, index: ++s, value: p };
          });
          return fd(l, function(p, m) {
            return Qp(p, m, i);
          });
        }
        function Up(e, r) {
          return cs(e, r, function(i, s) {
            return Ai(e, s);
          });
        }
        function cs(e, r, i) {
          for (var s = -1, l = r.length, p = {}; ++s < l; ) {
            var m = r[s], h = Zo(e, m);
            i(h, m) && zr(p, Eo(m, e), h);
          }
          return p;
        }
        function Zp(e) {
          return function(r) {
            return Zo(r, e);
          };
        }
        function $n(e, r, i, s) {
          var l = s ? pd : er, p = -1, m = r.length, h = e;
          for (e === r && (r = Se(r)), i && (h = re(e, Be(i))); ++p < m; )
            for (var A = 0, M = r[p], x = i ? i(M) : M; (A = l(h, x, A, s)) > -1; )
              h !== e && _t.call(h, A, 1), _t.call(e, A, 1);
          return e;
        }
        function ds(e, r) {
          for (var i = e ? r.length : 0, s = i - 1; i--; ) {
            var l = r[i];
            if (i == s || l !== p) {
              var p = l;
              Ao(l) ? _t.call(e, l, 1) : Vn(e, l);
            }
          }
          return e;
        }
        function Kn(e, r) {
          return e + gt(Ka() * (r - e + 1));
        }
        function qp(e, r, i, s) {
          for (var l = -1, p = fe(At((r - e) / (i || 1)), 0), m = g(p); p--; )
            m[s ? p : ++l] = e, e += i;
          return m;
        }
        function Hn(e, r) {
          var i = "";
          if (!e || r < 1 || r > Io)
            return i;
          do
            r % 2 && (i += e), r = gt(r / 2), r && (e += e);
          while (r);
          return i;
        }
        function q(e, r) {
          return li(Us(e, r, we), e + "");
        }
        function $p(e) {
          return Va(pr(e));
        }
        function Kp(e, r) {
          var i = pr(e);
          return Rt(i, Uo(r, 0, i.length));
        }
        function zr(e, r, i, s) {
          if (!ne(e))
            return e;
          r = Eo(r, e);
          for (var l = -1, p = r.length, m = p - 1, h = e; h != null && ++l < p; ) {
            var A = Xe(r[l]), M = i;
            if (A === "__proto__" || A === "constructor" || A === "prototype")
              return e;
            if (l != m) {
              var x = h[A];
              M = s ? s(x, A, h) : n, M === n && (M = ne(x) ? x : Ao(r[l + 1]) ? [] : {});
            }
            Br(h, A, M), h = h[A];
          }
          return e;
        }
        var ps = yt ? function(e, r) {
          return yt.set(e, r), e;
        } : we, Hp = bt ? function(e, r) {
          return bt(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: yi(r),
            writable: !0
          });
        } : we;
        function Wp(e) {
          return Rt(pr(e));
        }
        function $e(e, r, i) {
          var s = -1, l = e.length;
          r < 0 && (r = -r > l ? 0 : l + r), i = i > l ? l : i, i < 0 && (i += l), l = r > i ? 0 : i - r >>> 0, r >>>= 0;
          for (var p = g(l); ++s < l; )
            p[s] = e[s + r];
          return p;
        }
        function Vp(e, r) {
          var i;
          return vo(e, function(s, l, p) {
            return i = r(s, l, p), !i;
          }), !!i;
        }
        function Nt(e, r, i) {
          var s = 0, l = e == null ? s : e.length;
          if (typeof r == "number" && r === r && l <= Yl) {
            for (; s < l; ) {
              var p = s + l >>> 1, m = e[p];
              m !== null && !Pe(m) && (i ? m <= r : m < r) ? s = p + 1 : l = p;
            }
            return l;
          }
          return Wn(e, r, we, i);
        }
        function Wn(e, r, i, s) {
          var l = 0, p = e == null ? 0 : e.length;
          if (p === 0)
            return 0;
          r = i(r);
          for (var m = r !== r, h = r === null, A = Pe(r), M = r === n; l < p; ) {
            var x = gt((l + p) / 2), F = i(e[x]), N = F !== n, E = F === null, R = F === F, Z = Pe(F);
            if (m)
              var k = s || R;
            else M ? k = R && (s || N) : h ? k = R && N && (s || !E) : A ? k = R && N && !E && (s || !Z) : E || Z ? k = !1 : k = s ? F <= r : F < r;
            k ? l = x + 1 : p = x;
          }
          return ge(p, jl);
        }
        function fs(e, r) {
          for (var i = -1, s = e.length, l = 0, p = []; ++i < s; ) {
            var m = e[i], h = r ? r(m) : m;
            if (!i || !Qe(h, A)) {
              var A = h;
              p[l++] = m === 0 ? 0 : m;
            }
          }
          return p;
        }
        function ms(e) {
          return typeof e == "number" ? e : Pe(e) ? Xr : +e;
        }
        function Re(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return re(e, Re) + "";
          if (Pe(e))
            return Ha ? Ha.call(e) : "";
          var r = e + "";
          return r == "0" && 1 / e == -Ro ? "-0" : r;
        }
        function wo(e, r, i) {
          var s = -1, l = at, p = e.length, m = !0, h = [], A = h;
          if (i)
            m = !1, l = Mn;
          else if (p >= u) {
            var M = r ? null : af(e);
            if (M)
              return ut(M);
            m = !1, l = wr, A = new Go();
          } else
            A = r ? [] : h;
          e:
            for (; ++s < p; ) {
              var x = e[s], F = r ? r(x) : x;
              if (x = i || x !== 0 ? x : 0, m && F === F) {
                for (var N = A.length; N--; )
                  if (A[N] === F)
                    continue e;
                r && A.push(F), h.push(x);
              } else l(A, F, i) || (A !== h && A.push(F), h.push(x));
            }
          return h;
        }
        function Vn(e, r) {
          r = Eo(r, e);
          var i = -1, s = r.length;
          if (!s)
            return !0;
          for (; ++i < s; ) {
            var l = Xe(r[i]);
            if (l === "__proto__" && !V.call(e, "__proto__") || (l === "constructor" || l === "prototype") && i < s - 1)
              return !1;
          }
          var p = Zs(e, r);
          return p == null || delete p[Xe(Ke(r))];
        }
        function hs(e, r, i, s) {
          return zr(e, r, i(Zo(e, r)), s);
        }
        function vt(e, r, i, s) {
          for (var l = e.length, p = s ? l : -1; (s ? p-- : ++p < l) && r(e[p], p, e); )
            ;
          return i ? $e(e, s ? 0 : p, s ? p + 1 : l) : $e(e, s ? p + 1 : 0, s ? l : p);
        }
        function _s(e, r) {
          var i = e;
          return i instanceof K && (i = i.value()), In(r, function(s, l) {
            return l.func.apply(l.thisArg, Fo([s], l.args));
          }, i);
        }
        function Jn(e, r, i) {
          var s = e.length;
          if (s < 2)
            return s ? wo(e[0]) : [];
          for (var l = -1, p = g(s); ++l < s; )
            for (var m = e[l], h = -1; ++h < s; )
              h != l && (p[l] = Rr(p[l] || m, e[h], r, i));
          return wo(be(p, 1), r, i);
        }
        function bs(e, r, i) {
          for (var s = -1, l = e.length, p = r.length, m = {}; ++s < l; ) {
            var h = s < p ? r[s] : n;
            i(m, e[s], h);
          }
          return m;
        }
        function jn(e) {
          return ue(e) ? e : [];
        }
        function Yn(e) {
          return typeof e == "function" ? e : we;
        }
        function Eo(e, r) {
          return G(e) ? e : ai(e, r) ? [e] : Hs(J(e));
        }
        var Jp = q;
        function Co(e, r, i) {
          var s = e.length;
          return i = i === n ? s : i, !r && i >= s ? e : $e(e, r, i);
        }
        var As = Rd || function(e) {
          return _e.clearTimeout(e);
        };
        function gs(e, r) {
          if (r)
            return e.slice();
          var i = e.length, s = Ga ? Ga(i) : new e.constructor(i);
          return e.copy(s), s;
        }
        function Xn(e) {
          var r = new e.constructor(e.byteLength);
          return new mt(r).set(new mt(e)), r;
        }
        function jp(e, r) {
          var i = r ? Xn(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function Yp(e) {
          var r = new e.constructor(e.source, ra.exec(e));
          return r.lastIndex = e.lastIndex, r;
        }
        function Xp(e) {
          return kr ? Y(kr.call(e)) : {};
        }
        function ys(e, r) {
          var i = r ? Xn(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function Ts(e, r) {
          if (e !== r) {
            var i = e !== n, s = e === null, l = e === e, p = Pe(e), m = r !== n, h = r === null, A = r === r, M = Pe(r);
            if (!h && !M && !p && e > r || p && m && A && !h && !M || s && m && A || !i && A || !l)
              return 1;
            if (!s && !p && !M && e < r || M && i && l && !s && !p || h && i && l || !m && l || !A)
              return -1;
          }
          return 0;
        }
        function Qp(e, r, i) {
          for (var s = -1, l = e.criteria, p = r.criteria, m = l.length, h = i.length; ++s < m; ) {
            var A = Ts(l[s], p[s]);
            if (A) {
              if (s >= h)
                return A;
              var M = i[s];
              return A * (M == "desc" ? -1 : 1);
            }
          }
          return e.index - r.index;
        }
        function Ms(e, r, i, s) {
          for (var l = -1, p = e.length, m = i.length, h = -1, A = r.length, M = fe(p - m, 0), x = g(A + M), F = !s; ++h < A; )
            x[h] = r[h];
          for (; ++l < m; )
            (F || l < p) && (x[i[l]] = e[l]);
          for (; M--; )
            x[h++] = e[l++];
          return x;
        }
        function Is(e, r, i, s) {
          for (var l = -1, p = e.length, m = -1, h = i.length, A = -1, M = r.length, x = fe(p - h, 0), F = g(x + M), N = !s; ++l < x; )
            F[l] = e[l];
          for (var E = l; ++A < M; )
            F[E + A] = r[A];
          for (; ++m < h; )
            (N || l < p) && (F[E + i[m]] = e[l++]);
          return F;
        }
        function Se(e, r) {
          var i = -1, s = e.length;
          for (r || (r = g(s)); ++i < s; )
            r[i] = e[i];
          return r;
        }
        function io(e, r, i, s) {
          var l = !i;
          i || (i = {});
          for (var p = -1, m = r.length; ++p < m; ) {
            var h = r[p], A = s ? s(i[h], e[h], h, i, e) : n;
            A === n && (A = e[h]), l ? to(i, h, A) : Br(i, h, A);
          }
          return i;
        }
        function ef(e, r) {
          return io(e, ii(e), r);
        }
        function of(e, r) {
          return io(e, Rs(e), r);
        }
        function wt(e, r) {
          return function(i, s) {
            var l = G(i) ? ad : Ip, p = r ? r() : {};
            return l(i, e, B(s, 2), p);
          };
        }
        function ur(e) {
          return q(function(r, i) {
            var s = -1, l = i.length, p = l > 1 ? i[l - 1] : n, m = l > 2 ? i[2] : n;
            for (p = e.length > 3 && typeof p == "function" ? (l--, p) : n, m && Ie(i[0], i[1], m) && (p = l < 3 ? n : p, l = 1), r = Y(r); ++s < l; ) {
              var h = i[s];
              h && e(r, h, s, p);
            }
            return r;
          });
        }
        function xs(e, r) {
          return function(i, s) {
            if (i == null)
              return i;
            if (!Ne(i))
              return e(i, s);
            for (var l = i.length, p = r ? l : -1, m = Y(i); (r ? p-- : ++p < l) && s(m[p], p, m) !== !1; )
              ;
            return i;
          };
        }
        function Fs(e) {
          return function(r, i, s) {
            for (var l = -1, p = Y(r), m = s(r), h = m.length; h--; ) {
              var A = m[e ? h : ++l];
              if (i(p[A], A, p) === !1)
                break;
            }
            return r;
          };
        }
        function rf(e, r, i) {
          var s = r & Ce, l = Gr(e);
          function p() {
            var m = this && this !== _e && this instanceof p ? l : e;
            return m.apply(s ? i : this, arguments);
          }
          return p;
        }
        function Ss(e) {
          return function(r) {
            r = J(r);
            var i = or(r) ? je(r) : n, s = i ? i[0] : r.charAt(0), l = i ? Co(i, 1).join("") : r.slice(1);
            return s[e]() + l;
          };
        }
        function lr(e) {
          return function(r) {
            return In(Fu(xu(r).replace(Hc, "")), e, "");
          };
        }
        function Gr(e) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new e();
              case 1:
                return new e(r[0]);
              case 2:
                return new e(r[0], r[1]);
              case 3:
                return new e(r[0], r[1], r[2]);
              case 4:
                return new e(r[0], r[1], r[2], r[3]);
              case 5:
                return new e(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var i = sr(e.prototype), s = e.apply(i, r);
            return ne(s) ? s : i;
          };
        }
        function tf(e, r, i) {
          var s = Gr(e);
          function l() {
            for (var p = arguments.length, m = g(p), h = p, A = cr(l); h--; )
              m[h] = arguments[h];
            var M = p < 3 && m[0] !== A && m[p - 1] !== A ? [] : So(m, A);
            if (p -= M.length, p < i)
              return Cs(
                e,
                r,
                Et,
                l.placeholder,
                n,
                m,
                M,
                n,
                n,
                i - p
              );
            var x = this && this !== _e && this instanceof l ? s : e;
            return Le(x, this, m);
          }
          return l;
        }
        function Ns(e) {
          return function(r, i, s) {
            var l = Y(r);
            if (!Ne(r)) {
              var p = B(i, 3);
              r = me(r), i = function(h) {
                return p(l[h], h, l);
              };
            }
            var m = e(r, i, s);
            return m > -1 ? l[p ? r[m] : m] : n;
          };
        }
        function vs(e) {
          return bo(function(r) {
            var i = r.length, s = i, l = Ze.prototype.thru;
            for (e && r.reverse(); s--; ) {
              var p = r[s];
              if (typeof p != "function")
                throw new Ue(d);
              if (l && !m && kt(p) == "wrapper")
                var m = new Ze([], !0);
            }
            for (s = m ? s : i; ++s < i; ) {
              p = r[s];
              var h = kt(p), A = h == "wrapper" ? ti(p) : n;
              A && si(A[0]) && A[1] == (po | oe | oo | Tr) && !A[4].length && A[9] == 1 ? m = m[kt(A[0])].apply(m, A[3]) : m = p.length == 1 && si(p) ? m[h]() : m.thru(p);
            }
            return function() {
              var M = arguments, x = M[0];
              if (m && M.length == 1 && G(x))
                return m.plant(x).value();
              for (var F = 0, N = i ? r[F].apply(this, M) : x; ++F < i; )
                N = r[F].call(this, N);
              return N;
            };
          });
        }
        function Et(e, r, i, s, l, p, m, h, A, M) {
          var x = r & po, F = r & Ce, N = r & Mo, E = r & (oe | he), R = r & rn, Z = N ? n : Gr(e);
          function k() {
            for (var $ = arguments.length, H = g($), Oe = $; Oe--; )
              H[Oe] = arguments[Oe];
            if (E)
              var xe = cr(k), ze = hd(H, xe);
            if (s && (H = Ms(H, s, l, E)), p && (H = Is(H, p, m, E)), $ -= ze, E && $ < M) {
              var le = So(H, xe);
              return Cs(
                e,
                r,
                Et,
                k.placeholder,
                i,
                H,
                le,
                h,
                A,
                M - $
              );
            }
            var eo = F ? i : this, To = N ? eo[e] : e;
            return $ = H.length, h ? H = xf(H, h) : R && $ > 1 && H.reverse(), x && A < $ && (H.length = A), this && this !== _e && this instanceof k && (To = Z || Gr(To)), To.apply(eo, H);
          }
          return k;
        }
        function ws(e, r) {
          return function(i, s) {
            return Cp(i, e, r(s), {});
          };
        }
        function Ct(e, r) {
          return function(i, s) {
            var l;
            if (i === n && s === n)
              return r;
            if (i !== n && (l = i), s !== n) {
              if (l === n)
                return s;
              typeof i == "string" || typeof s == "string" ? (i = Re(i), s = Re(s)) : (i = ms(i), s = ms(s)), l = e(i, s);
            }
            return l;
          };
        }
        function Qn(e) {
          return bo(function(r) {
            return r = re(r, Be(B())), q(function(i) {
              var s = this;
              return e(r, function(l) {
                return Le(l, s, i);
              });
            });
          });
        }
        function Dt(e, r) {
          r = r === n ? " " : Re(r);
          var i = r.length;
          if (i < 2)
            return i ? Hn(r, e) : r;
          var s = Hn(r, At(e / rr(r)));
          return or(r) ? Co(je(s), 0, e).join("") : s.slice(0, e);
        }
        function nf(e, r, i, s) {
          var l = r & Ce, p = Gr(e);
          function m() {
            for (var h = -1, A = arguments.length, M = -1, x = s.length, F = g(x + A), N = this && this !== _e && this instanceof m ? p : e; ++M < x; )
              F[M] = s[M];
            for (; A--; )
              F[M++] = arguments[++h];
            return Le(N, l ? i : this, F);
          }
          return m;
        }
        function Es(e) {
          return function(r, i, s) {
            return s && typeof s != "number" && Ie(r, i, s) && (i = s = n), r = yo(r), i === n ? (i = r, r = 0) : i = yo(i), s = s === n ? r < i ? 1 : -1 : yo(s), qp(r, i, s, e);
          };
        }
        function Lt(e) {
          return function(r, i) {
            return typeof r == "string" && typeof i == "string" || (r = He(r), i = He(i)), e(r, i);
          };
        }
        function Cs(e, r, i, s, l, p, m, h, A, M) {
          var x = r & oe, F = x ? m : n, N = x ? n : m, E = x ? p : n, R = x ? n : p;
          r |= x ? oo : Bo, r &= ~(x ? Bo : oo), r & De || (r &= -4);
          var Z = [
            e,
            r,
            l,
            E,
            F,
            R,
            N,
            h,
            A,
            M
          ], k = i.apply(n, Z);
          return si(e) && qs(k, Z), k.placeholder = s, $s(k, e, r);
        }
        function ei(e) {
          var r = pe[e];
          return function(i, s) {
            if (i = He(i), s = s == null ? 0 : ge(U(s), 292), s && $a(i)) {
              var l = (J(i) + "e").split("e"), p = r(l[0] + "e" + (+l[1] + s));
              return l = (J(p) + "e").split("e"), +(l[0] + "e" + (+l[1] - s));
            }
            return r(i);
          };
        }
        var af = ir && 1 / ut(new ir([, -0]))[1] == Ro ? function(e) {
          return new ir(e);
        } : Ii;
        function Ds(e) {
          return function(r) {
            var i = ye(r);
            return i == Ve ? En(r) : i == Je ? Md(r) : md(r, e(r));
          };
        }
        function _o(e, r, i, s, l, p, m, h) {
          var A = r & Mo;
          if (!A && typeof e != "function")
            throw new Ue(d);
          var M = s ? s.length : 0;
          if (M || (r &= -97, s = l = n), m = m === n ? m : fe(U(m), 0), h = h === n ? h : U(h), M -= l ? l.length : 0, r & Bo) {
            var x = s, F = l;
            s = l = n;
          }
          var N = A ? n : ti(e), E = [
            e,
            r,
            i,
            s,
            l,
            x,
            F,
            p,
            m,
            h
          ];
          if (N && Tf(E, N), e = E[0], r = E[1], i = E[2], s = E[3], l = E[4], h = E[9] = E[9] === n ? A ? 0 : e.length : fe(E[9] - M, 0), !h && r & (oe | he) && (r &= -25), !r || r == Ce)
            var R = rf(e, r, i);
          else r == oe || r == he ? R = tf(e, r, h) : (r == oo || r == (Ce | oo)) && !l.length ? R = nf(e, r, i, s) : R = Et.apply(n, E);
          var Z = N ? ps : qs;
          return $s(Z(R, E), e, r);
        }
        function Ls(e, r, i, s) {
          return e === n || Qe(e, nr[i]) && !V.call(s, i) ? r : e;
        }
        function ks(e, r, i, s, l, p) {
          return ne(e) && ne(r) && (p.set(r, e), St(e, r, n, ks, p), p.delete(r)), e;
        }
        function sf(e) {
          return qr(e) ? n : e;
        }
        function Bs(e, r, i, s, l, p) {
          var m = i & ee, h = e.length, A = r.length;
          if (h != A && !(m && A > h))
            return !1;
          var M = p.get(e), x = p.get(r);
          if (M && x)
            return M == r && x == e;
          var F = -1, N = !0, E = i & co ? new Go() : n;
          for (p.set(e, r), p.set(r, e); ++F < h; ) {
            var R = e[F], Z = r[F];
            if (s)
              var k = m ? s(Z, R, F, r, e, p) : s(R, Z, F, e, r, p);
            if (k !== n) {
              if (k)
                continue;
              N = !1;
              break;
            }
            if (E) {
              if (!xn(r, function($, H) {
                if (!wr(E, H) && (R === $ || l(R, $, i, s, p)))
                  return E.push(H);
              })) {
                N = !1;
                break;
              }
            } else if (!(R === Z || l(R, Z, i, s, p))) {
              N = !1;
              break;
            }
          }
          return p.delete(e), p.delete(r), N;
        }
        function uf(e, r, i, s, l, p, m) {
          switch (i) {
            case Xo:
              if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
                return !1;
              e = e.buffer, r = r.buffer;
            case vr:
              return !(e.byteLength != r.byteLength || !p(new mt(e), new mt(r)));
            case Mr:
            case Ir:
            case xr:
              return Qe(+e, +r);
            case et:
              return e.name == r.name && e.message == r.message;
            case Fr:
            case Sr:
              return e == r + "";
            case Ve:
              var h = En;
            case Je:
              var A = s & ee;
              if (h || (h = ut), e.size != r.size && !A)
                return !1;
              var M = m.get(e);
              if (M)
                return M == r;
              s |= co, m.set(e, r);
              var x = Bs(h(e), h(r), s, l, p, m);
              return m.delete(e), x;
            case rt:
              if (kr)
                return kr.call(e) == kr.call(r);
          }
          return !1;
        }
        function lf(e, r, i, s, l, p) {
          var m = i & ee, h = oi(e), A = h.length, M = oi(r), x = M.length;
          if (A != x && !m)
            return !1;
          for (var F = A; F--; ) {
            var N = h[F];
            if (!(m ? N in r : V.call(r, N)))
              return !1;
          }
          var E = p.get(e), R = p.get(r);
          if (E && R)
            return E == r && R == e;
          var Z = !0;
          p.set(e, r), p.set(r, e);
          for (var k = m; ++F < A; ) {
            N = h[F];
            var $ = e[N], H = r[N];
            if (s)
              var Oe = m ? s(H, $, N, r, e, p) : s($, H, N, e, r, p);
            if (!(Oe === n ? $ === H || l($, H, i, s, p) : Oe)) {
              Z = !1;
              break;
            }
            k || (k = N == "constructor");
          }
          if (Z && !k) {
            var xe = e.constructor, ze = r.constructor;
            xe != ze && "constructor" in e && "constructor" in r && !(typeof xe == "function" && xe instanceof xe && typeof ze == "function" && ze instanceof ze) && (Z = !1);
          }
          return p.delete(e), p.delete(r), Z;
        }
        function bo(e) {
          return li(Us(e, n, js), e + "");
        }
        function oi(e) {
          return os(e, me, ii);
        }
        function ri(e) {
          return os(e, ve, Rs);
        }
        var ti = yt ? function(e) {
          return yt.get(e);
        } : Ii;
        function kt(e) {
          for (var r = e.name + "", i = ar[r], s = V.call(ar, r) ? i.length : 0; s--; ) {
            var l = i[s], p = l.func;
            if (p == null || p == e)
              return l.name;
          }
          return r;
        }
        function cr(e) {
          var r = V.call(c, "placeholder") ? c : e;
          return r.placeholder;
        }
        function B() {
          var e = c.iteratee || Ti;
          return e = e === Ti ? ns : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Bt(e, r) {
          var i = e.__data__;
          return bf(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
        }
        function ni(e) {
          for (var r = me(e), i = r.length; i--; ) {
            var s = r[i], l = e[s];
            r[i] = [s, l, zs(l)];
          }
          return r;
        }
        function qo(e, r) {
          var i = gd(e, r);
          return ts(i) ? i : n;
        }
        function cf(e) {
          var r = V.call(e, Oo), i = e[Oo];
          try {
            e[Oo] = n;
            var s = !0;
          } catch {
          }
          var l = pt.call(e);
          return s && (r ? e[Oo] = i : delete e[Oo]), l;
        }
        var ii = Dn ? function(e) {
          return e == null ? [] : (e = Y(e), xo(Dn(e), function(r) {
            return Za.call(e, r);
          }));
        } : xi, Rs = Dn ? function(e) {
          for (var r = []; e; )
            Fo(r, ii(e)), e = ht(e);
          return r;
        } : xi, ye = Me;
        (Ln && ye(new Ln(new ArrayBuffer(1))) != Xo || Cr && ye(new Cr()) != Ve || kn && ye(kn.resolve()) != Yi || ir && ye(new ir()) != Je || Dr && ye(new Dr()) != Nr) && (ye = function(e) {
          var r = Me(e), i = r == fo ? e.constructor : n, s = i ? $o(i) : "";
          if (s)
            switch (s) {
              case Kd:
                return Xo;
              case Hd:
                return Ve;
              case Wd:
                return Yi;
              case Vd:
                return Je;
              case Jd:
                return Nr;
            }
          return r;
        });
        function df(e, r, i) {
          for (var s = -1, l = i.length; ++s < l; ) {
            var p = i[s], m = p.size;
            switch (p.type) {
              case "drop":
                e += m;
                break;
              case "dropRight":
                r -= m;
                break;
              case "take":
                r = ge(r, e + m);
                break;
              case "takeRight":
                e = fe(e, r - m);
                break;
            }
          }
          return { start: e, end: r };
        }
        function pf(e) {
          var r = e.match(Ac);
          return r ? r[1].split(gc) : [];
        }
        function Ps(e, r, i) {
          r = Eo(r, e);
          for (var s = -1, l = r.length, p = !1; ++s < l; ) {
            var m = Xe(r[s]);
            if (!(p = e != null && i(e, m)))
              break;
            e = e[m];
          }
          return p || ++s != l ? p : (l = e == null ? 0 : e.length, !!l && Zt(l) && Ao(m, l) && (G(e) || Ko(e)));
        }
        function ff(e) {
          var r = e.length, i = new e.constructor(r);
          return r && typeof e[0] == "string" && V.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function Os(e) {
          return typeof e.constructor == "function" && !Ur(e) ? sr(ht(e)) : {};
        }
        function mf(e, r, i) {
          var s = e.constructor;
          switch (r) {
            case vr:
              return Xn(e);
            case Mr:
            case Ir:
              return new s(+e);
            case Xo:
              return jp(e, i);
            case tn:
            case nn:
            case an:
            case sn:
            case un:
            case ln:
            case cn:
            case dn:
            case pn:
              return ys(e, i);
            case Ve:
              return new s();
            case xr:
            case Sr:
              return new s(e);
            case Fr:
              return Yp(e);
            case Je:
              return new s();
            case rt:
              return Xp(e);
          }
        }
        function hf(e, r) {
          var i = r.length;
          if (!i)
            return e;
          var s = i - 1;
          return r[s] = (i > 1 ? "& " : "") + r[s], r = r.join(i > 2 ? ", " : " "), e.replace(bc, `{
/* [wrapped with ` + r + `] */
`);
        }
        function _f(e) {
          return G(e) || Ko(e) || !!(qa && e && e[qa]);
        }
        function Ao(e, r) {
          var i = typeof e;
          return r = r ?? Io, !!r && (i == "number" || i != "symbol" && Nc.test(e)) && e > -1 && e % 1 == 0 && e < r;
        }
        function Ie(e, r, i) {
          if (!ne(i))
            return !1;
          var s = typeof r;
          return (s == "number" ? Ne(i) && Ao(r, i.length) : s == "string" && r in i) ? Qe(i[r], e) : !1;
        }
        function ai(e, r) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || Pe(e) ? !0 : fc.test(e) || !pc.test(e) || r != null && e in Y(r);
        }
        function bf(e) {
          var r = typeof e;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
        }
        function si(e) {
          var r = kt(e), i = c[r];
          if (typeof i != "function" || !(r in K.prototype))
            return !1;
          if (e === i)
            return !0;
          var s = ti(i);
          return !!s && e === s[0];
        }
        function Af(e) {
          return !!za && za in e;
        }
        var gf = ct ? go : Fi;
        function Ur(e) {
          var r = e && e.constructor, i = typeof r == "function" && r.prototype || nr;
          return e === i;
        }
        function zs(e) {
          return e === e && !ne(e);
        }
        function Gs(e, r) {
          return function(i) {
            return i == null ? !1 : i[e] === r && (r !== n || e in Y(i));
          };
        }
        function yf(e) {
          var r = Gt(e, function(s) {
            return i.size === w && i.clear(), s;
          }), i = r.cache;
          return r;
        }
        function Tf(e, r) {
          var i = e[1], s = r[1], l = i | s, p = l < (Ce | Mo | po), m = s == po && i == oe || s == po && i == Tr && e[7].length <= r[8] || s == (po | Tr) && r[7].length <= r[8] && i == oe;
          if (!(p || m))
            return e;
          s & Ce && (e[2] = r[2], l |= i & Ce ? 0 : De);
          var h = r[3];
          if (h) {
            var A = e[3];
            e[3] = A ? Ms(A, h, r[4]) : h, e[4] = A ? So(e[3], z) : r[4];
          }
          return h = r[5], h && (A = e[5], e[5] = A ? Is(A, h, r[6]) : h, e[6] = A ? So(e[5], z) : r[6]), h = r[7], h && (e[7] = h), s & po && (e[8] = e[8] == null ? r[8] : ge(e[8], r[8])), e[9] == null && (e[9] = r[9]), e[0] = r[0], e[1] = l, e;
        }
        function Mf(e) {
          var r = [];
          if (e != null)
            for (var i in Y(e))
              r.push(i);
          return r;
        }
        function If(e) {
          return pt.call(e);
        }
        function Us(e, r, i) {
          return r = fe(r === n ? e.length - 1 : r, 0), function() {
            for (var s = arguments, l = -1, p = fe(s.length - r, 0), m = g(p); ++l < p; )
              m[l] = s[r + l];
            l = -1;
            for (var h = g(r + 1); ++l < r; )
              h[l] = s[l];
            return h[r] = i(m), Le(e, this, h);
          };
        }
        function Zs(e, r) {
          return r.length < 2 ? e : Zo(e, $e(r, 0, -1));
        }
        function xf(e, r) {
          for (var i = e.length, s = ge(r.length, i), l = Se(e); s--; ) {
            var p = r[s];
            e[s] = Ao(p, i) ? l[p] : n;
          }
          return e;
        }
        function ui(e, r) {
          if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
            return e[r];
        }
        var qs = Ks(ps), Zr = Od || function(e, r) {
          return _e.setTimeout(e, r);
        }, li = Ks(Hp);
        function $s(e, r, i) {
          var s = r + "";
          return li(e, hf(s, Ff(pf(s), i)));
        }
        function Ks(e) {
          var r = 0, i = 0;
          return function() {
            var s = Zd(), l = Hl - (s - i);
            if (i = s, l > 0) {
              if (++r >= Kl)
                return arguments[0];
            } else
              r = 0;
            return e.apply(n, arguments);
          };
        }
        function Rt(e, r) {
          var i = -1, s = e.length, l = s - 1;
          for (r = r === n ? s : r; ++i < r; ) {
            var p = Kn(i, l), m = e[p];
            e[p] = e[i], e[i] = m;
          }
          return e.length = r, e;
        }
        var Hs = yf(function(e) {
          var r = [];
          return e.charCodeAt(0) === 46 && r.push(""), e.replace(mc, function(i, s, l, p) {
            r.push(l ? p.replace(Tc, "$1") : s || i);
          }), r;
        });
        function Xe(e) {
          if (typeof e == "string" || Pe(e))
            return e;
          var r = e + "";
          return r == "0" && 1 / e == -Ro ? "-0" : r;
        }
        function $o(e) {
          if (e != null) {
            try {
              return dt.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function Ff(e, r) {
          return ke(Xl, function(i) {
            var s = "_." + i[0];
            r & i[1] && !at(e, s) && e.push(s);
          }), e.sort();
        }
        function Ws(e) {
          if (e instanceof K)
            return e.clone();
          var r = new Ze(e.__wrapped__, e.__chain__);
          return r.__actions__ = Se(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r;
        }
        function Sf(e, r, i) {
          (i ? Ie(e, r, i) : r === n) ? r = 1 : r = fe(U(r), 0);
          var s = e == null ? 0 : e.length;
          if (!s || r < 1)
            return [];
          for (var l = 0, p = 0, m = g(At(s / r)); l < s; )
            m[p++] = $e(e, l, l += r);
          return m;
        }
        function Nf(e) {
          for (var r = -1, i = e == null ? 0 : e.length, s = 0, l = []; ++r < i; ) {
            var p = e[r];
            p && (l[s++] = p);
          }
          return l;
        }
        function vf() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var r = g(e - 1), i = arguments[0], s = e; s--; )
            r[s - 1] = arguments[s];
          return Fo(G(i) ? Se(i) : [i], be(r, 1));
        }
        var wf = q(function(e, r) {
          return ue(e) ? Rr(e, be(r, 1, ue, !0)) : [];
        }), Ef = q(function(e, r) {
          var i = Ke(r);
          return ue(i) && (i = n), ue(e) ? Rr(e, be(r, 1, ue, !0), B(i, 2)) : [];
        }), Cf = q(function(e, r) {
          var i = Ke(r);
          return ue(i) && (i = n), ue(e) ? Rr(e, be(r, 1, ue, !0), n, i) : [];
        });
        function Df(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === n ? 1 : U(r), $e(e, r < 0 ? 0 : r, s)) : [];
        }
        function Lf(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === n ? 1 : U(r), r = s - r, $e(e, 0, r < 0 ? 0 : r)) : [];
        }
        function kf(e, r) {
          return e && e.length ? vt(e, B(r, 3), !0, !0) : [];
        }
        function Bf(e, r) {
          return e && e.length ? vt(e, B(r, 3), !0) : [];
        }
        function Rf(e, r, i, s) {
          var l = e == null ? 0 : e.length;
          return l ? (i && typeof i != "number" && Ie(e, r, i) && (i = 0, s = l), Np(e, r, i, s)) : [];
        }
        function Vs(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : U(i);
          return l < 0 && (l = fe(s + l, 0)), st(e, B(r, 3), l);
        }
        function Js(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s - 1;
          return i !== n && (l = U(i), l = i < 0 ? fe(s + l, 0) : ge(l, s - 1)), st(e, B(r, 3), l, !0);
        }
        function js(e) {
          var r = e == null ? 0 : e.length;
          return r ? be(e, 1) : [];
        }
        function Pf(e) {
          var r = e == null ? 0 : e.length;
          return r ? be(e, Ro) : [];
        }
        function Of(e, r) {
          var i = e == null ? 0 : e.length;
          return i ? (r = r === n ? 1 : U(r), be(e, r)) : [];
        }
        function zf(e) {
          for (var r = -1, i = e == null ? 0 : e.length, s = {}; ++r < i; ) {
            var l = e[r];
            to(s, l[0], l[1]);
          }
          return s;
        }
        function Ys(e) {
          return e && e.length ? e[0] : n;
        }
        function Gf(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : U(i);
          return l < 0 && (l = fe(s + l, 0)), er(e, r, l);
        }
        function Uf(e) {
          var r = e == null ? 0 : e.length;
          return r ? $e(e, 0, -1) : [];
        }
        var Zf = q(function(e) {
          var r = re(e, jn);
          return r.length && r[0] === e[0] ? Gn(r) : [];
        }), qf = q(function(e) {
          var r = Ke(e), i = re(e, jn);
          return r === Ke(i) ? r = n : i.pop(), i.length && i[0] === e[0] ? Gn(i, B(r, 2)) : [];
        }), $f = q(function(e) {
          var r = Ke(e), i = re(e, jn);
          return r = typeof r == "function" ? r : n, r && i.pop(), i.length && i[0] === e[0] ? Gn(i, n, r) : [];
        });
        function Kf(e, r) {
          return e == null ? "" : Gd.call(e, r);
        }
        function Ke(e) {
          var r = e == null ? 0 : e.length;
          return r ? e[r - 1] : n;
        }
        function Hf(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s;
          return i !== n && (l = U(i), l = l < 0 ? fe(s + l, 0) : ge(l, s - 1)), r === r ? xd(e, r, l) : st(e, Ca, l, !0);
        }
        function Wf(e, r) {
          return e && e.length ? us(e, U(r)) : n;
        }
        var Vf = q(Xs);
        function Xs(e, r) {
          return e && e.length && r && r.length ? $n(e, r) : e;
        }
        function Jf(e, r, i) {
          return e && e.length && r && r.length ? $n(e, r, B(i, 2)) : e;
        }
        function jf(e, r, i) {
          return e && e.length && r && r.length ? $n(e, r, n, i) : e;
        }
        var Yf = bo(function(e, r) {
          var i = e == null ? 0 : e.length, s = Rn(e, r);
          return ds(e, re(r, function(l) {
            return Ao(l, i) ? +l : l;
          }).sort(Ts)), s;
        });
        function Xf(e, r) {
          var i = [];
          if (!(e && e.length))
            return i;
          var s = -1, l = [], p = e.length;
          for (r = B(r, 3); ++s < p; ) {
            var m = e[s];
            r(m, s, e) && (i.push(m), l.push(s));
          }
          return ds(e, l), i;
        }
        function ci(e) {
          return e == null ? e : $d.call(e);
        }
        function Qf(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (i && typeof i != "number" && Ie(e, r, i) ? (r = 0, i = s) : (r = r == null ? 0 : U(r), i = i === n ? s : U(i)), $e(e, r, i)) : [];
        }
        function em(e, r) {
          return Nt(e, r);
        }
        function om(e, r, i) {
          return Wn(e, r, B(i, 2));
        }
        function rm(e, r) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Nt(e, r);
            if (s < i && Qe(e[s], r))
              return s;
          }
          return -1;
        }
        function tm(e, r) {
          return Nt(e, r, !0);
        }
        function nm(e, r, i) {
          return Wn(e, r, B(i, 2), !0);
        }
        function im(e, r) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Nt(e, r, !0) - 1;
            if (Qe(e[s], r))
              return s;
          }
          return -1;
        }
        function am(e) {
          return e && e.length ? fs(e) : [];
        }
        function sm(e, r) {
          return e && e.length ? fs(e, B(r, 2)) : [];
        }
        function um(e) {
          var r = e == null ? 0 : e.length;
          return r ? $e(e, 1, r) : [];
        }
        function lm(e, r, i) {
          return e && e.length ? (r = i || r === n ? 1 : U(r), $e(e, 0, r < 0 ? 0 : r)) : [];
        }
        function cm(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === n ? 1 : U(r), r = s - r, $e(e, r < 0 ? 0 : r, s)) : [];
        }
        function dm(e, r) {
          return e && e.length ? vt(e, B(r, 3), !1, !0) : [];
        }
        function pm(e, r) {
          return e && e.length ? vt(e, B(r, 3)) : [];
        }
        var fm = q(function(e) {
          return wo(be(e, 1, ue, !0));
        }), mm = q(function(e) {
          var r = Ke(e);
          return ue(r) && (r = n), wo(be(e, 1, ue, !0), B(r, 2));
        }), hm = q(function(e) {
          var r = Ke(e);
          return r = typeof r == "function" ? r : n, wo(be(e, 1, ue, !0), n, r);
        });
        function _m(e) {
          return e && e.length ? wo(e) : [];
        }
        function bm(e, r) {
          return e && e.length ? wo(e, B(r, 2)) : [];
        }
        function Am(e, r) {
          return r = typeof r == "function" ? r : n, e && e.length ? wo(e, n, r) : [];
        }
        function di(e) {
          if (!(e && e.length))
            return [];
          var r = 0;
          return e = xo(e, function(i) {
            if (ue(i))
              return r = fe(i.length, r), !0;
          }), vn(r, function(i) {
            return re(e, Fn(i));
          });
        }
        function Qs(e, r) {
          if (!(e && e.length))
            return [];
          var i = di(e);
          return r == null ? i : re(i, function(s) {
            return Le(r, n, s);
          });
        }
        var gm = q(function(e, r) {
          return ue(e) ? Rr(e, r) : [];
        }), ym = q(function(e) {
          return Jn(xo(e, ue));
        }), Tm = q(function(e) {
          var r = Ke(e);
          return ue(r) && (r = n), Jn(xo(e, ue), B(r, 2));
        }), Mm = q(function(e) {
          var r = Ke(e);
          return r = typeof r == "function" ? r : n, Jn(xo(e, ue), n, r);
        }), Im = q(di);
        function xm(e, r) {
          return bs(e || [], r || [], Br);
        }
        function Fm(e, r) {
          return bs(e || [], r || [], zr);
        }
        var Sm = q(function(e) {
          var r = e.length, i = r > 1 ? e[r - 1] : n;
          return i = typeof i == "function" ? (e.pop(), i) : n, Qs(e, i);
        });
        function eu(e) {
          var r = c(e);
          return r.__chain__ = !0, r;
        }
        function Nm(e, r) {
          return r(e), e;
        }
        function Pt(e, r) {
          return r(e);
        }
        var vm = bo(function(e) {
          var r = e.length, i = r ? e[0] : 0, s = this.__wrapped__, l = function(p) {
            return Rn(p, e);
          };
          return r > 1 || this.__actions__.length || !(s instanceof K) || !Ao(i) ? this.thru(l) : (s = s.slice(i, +i + (r ? 1 : 0)), s.__actions__.push({
            func: Pt,
            args: [l],
            thisArg: n
          }), new Ze(s, this.__chain__).thru(function(p) {
            return r && !p.length && p.push(n), p;
          }));
        });
        function wm() {
          return eu(this);
        }
        function Em() {
          return new Ze(this.value(), this.__chain__);
        }
        function Cm() {
          this.__values__ === n && (this.__values__ = mu(this.value()));
          var e = this.__index__ >= this.__values__.length, r = e ? n : this.__values__[this.__index__++];
          return { done: e, value: r };
        }
        function Dm() {
          return this;
        }
        function Lm(e) {
          for (var r, i = this; i instanceof Mt; ) {
            var s = Ws(i);
            s.__index__ = 0, s.__values__ = n, r ? l.__wrapped__ = s : r = s;
            var l = s;
            i = i.__wrapped__;
          }
          return l.__wrapped__ = e, r;
        }
        function km() {
          var e = this.__wrapped__;
          if (e instanceof K) {
            var r = e;
            return this.__actions__.length && (r = new K(this)), r = r.reverse(), r.__actions__.push({
              func: Pt,
              args: [ci],
              thisArg: n
            }), new Ze(r, this.__chain__);
          }
          return this.thru(ci);
        }
        function Bm() {
          return _s(this.__wrapped__, this.__actions__);
        }
        var Rm = wt(function(e, r, i) {
          V.call(e, i) ? ++e[i] : to(e, i, 1);
        });
        function Pm(e, r, i) {
          var s = G(e) ? wa : Sp;
          return i && Ie(e, r, i) && (r = n), s(e, B(r, 3));
        }
        function Om(e, r) {
          var i = G(e) ? xo : Qa;
          return i(e, B(r, 3));
        }
        var zm = Ns(Vs), Gm = Ns(Js);
        function Um(e, r) {
          return be(Ot(e, r), 1);
        }
        function Zm(e, r) {
          return be(Ot(e, r), Ro);
        }
        function qm(e, r, i) {
          return i = i === n ? 1 : U(i), be(Ot(e, r), i);
        }
        function ou(e, r) {
          var i = G(e) ? ke : vo;
          return i(e, B(r, 3));
        }
        function ru(e, r) {
          var i = G(e) ? sd : Xa;
          return i(e, B(r, 3));
        }
        var $m = wt(function(e, r, i) {
          V.call(e, i) ? e[i].push(r) : to(e, i, [r]);
        });
        function Km(e, r, i, s) {
          e = Ne(e) ? e : pr(e), i = i && !s ? U(i) : 0;
          var l = e.length;
          return i < 0 && (i = fe(l + i, 0)), qt(e) ? i <= l && e.indexOf(r, i) > -1 : !!l && er(e, r, i) > -1;
        }
        var Hm = q(function(e, r, i) {
          var s = -1, l = typeof r == "function", p = Ne(e) ? g(e.length) : [];
          return vo(e, function(m) {
            p[++s] = l ? Le(r, m, i) : Pr(m, r, i);
          }), p;
        }), Wm = wt(function(e, r, i) {
          to(e, i, r);
        });
        function Ot(e, r) {
          var i = G(e) ? re : is;
          return i(e, B(r, 3));
        }
        function Vm(e, r, i, s) {
          return e == null ? [] : (G(r) || (r = r == null ? [] : [r]), i = s ? n : i, G(i) || (i = i == null ? [] : [i]), ls(e, r, i));
        }
        var Jm = wt(function(e, r, i) {
          e[i ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function jm(e, r, i) {
          var s = G(e) ? In : La, l = arguments.length < 3;
          return s(e, B(r, 4), i, l, vo);
        }
        function Ym(e, r, i) {
          var s = G(e) ? ud : La, l = arguments.length < 3;
          return s(e, B(r, 4), i, l, Xa);
        }
        function Xm(e, r) {
          var i = G(e) ? xo : Qa;
          return i(e, Ut(B(r, 3)));
        }
        function Qm(e) {
          var r = G(e) ? Va : $p;
          return r(e);
        }
        function eh(e, r, i) {
          (i ? Ie(e, r, i) : r === n) ? r = 1 : r = U(r);
          var s = G(e) ? Tp : Kp;
          return s(e, r);
        }
        function oh(e) {
          var r = G(e) ? Mp : Wp;
          return r(e);
        }
        function rh(e) {
          if (e == null)
            return 0;
          if (Ne(e))
            return qt(e) ? rr(e) : e.length;
          var r = ye(e);
          return r == Ve || r == Je ? e.size : Zn(e).length;
        }
        function th(e, r, i) {
          var s = G(e) ? xn : Vp;
          return i && Ie(e, r, i) && (r = n), s(e, B(r, 3));
        }
        var nh = q(function(e, r) {
          if (e == null)
            return [];
          var i = r.length;
          return i > 1 && Ie(e, r[0], r[1]) ? r = [] : i > 2 && Ie(r[0], r[1], r[2]) && (r = [r[0]]), ls(e, be(r, 1), []);
        }), zt = Pd || function() {
          return _e.Date.now();
        };
        function ih(e, r) {
          if (typeof r != "function")
            throw new Ue(d);
          return e = U(e), function() {
            if (--e < 1)
              return r.apply(this, arguments);
          };
        }
        function tu(e, r, i) {
          return r = i ? n : r, r = e && r == null ? e.length : r, _o(e, po, n, n, n, n, r);
        }
        function nu(e, r) {
          var i;
          if (typeof r != "function")
            throw new Ue(d);
          return e = U(e), function() {
            return --e > 0 && (i = r.apply(this, arguments)), e <= 1 && (r = n), i;
          };
        }
        var pi = q(function(e, r, i) {
          var s = Ce;
          if (i.length) {
            var l = So(i, cr(pi));
            s |= oo;
          }
          return _o(e, s, r, i, l);
        }), iu = q(function(e, r, i) {
          var s = Ce | Mo;
          if (i.length) {
            var l = So(i, cr(iu));
            s |= oo;
          }
          return _o(r, s, e, i, l);
        });
        function au(e, r, i) {
          r = i ? n : r;
          var s = _o(e, oe, n, n, n, n, n, r);
          return s.placeholder = au.placeholder, s;
        }
        function su(e, r, i) {
          r = i ? n : r;
          var s = _o(e, he, n, n, n, n, n, r);
          return s.placeholder = su.placeholder, s;
        }
        function uu(e, r, i) {
          var s, l, p, m, h, A, M = 0, x = !1, F = !1, N = !0;
          if (typeof e != "function")
            throw new Ue(d);
          r = He(r) || 0, ne(i) && (x = !!i.leading, F = "maxWait" in i, p = F ? fe(He(i.maxWait) || 0, r) : p, N = "trailing" in i ? !!i.trailing : N);
          function E(le) {
            var eo = s, To = l;
            return s = l = n, M = le, m = e.apply(To, eo), m;
          }
          function R(le) {
            return M = le, h = Zr($, r), x ? E(le) : m;
          }
          function Z(le) {
            var eo = le - A, To = le - M, vu = r - eo;
            return F ? ge(vu, p - To) : vu;
          }
          function k(le) {
            var eo = le - A, To = le - M;
            return A === n || eo >= r || eo < 0 || F && To >= p;
          }
          function $() {
            var le = zt();
            if (k(le))
              return H(le);
            h = Zr($, Z(le));
          }
          function H(le) {
            return h = n, N && s ? E(le) : (s = l = n, m);
          }
          function Oe() {
            h !== n && As(h), M = 0, s = A = l = h = n;
          }
          function xe() {
            return h === n ? m : H(zt());
          }
          function ze() {
            var le = zt(), eo = k(le);
            if (s = arguments, l = this, A = le, eo) {
              if (h === n)
                return R(A);
              if (F)
                return As(h), h = Zr($, r), E(A);
            }
            return h === n && (h = Zr($, r)), m;
          }
          return ze.cancel = Oe, ze.flush = xe, ze;
        }
        var ah = q(function(e, r) {
          return Ya(e, 1, r);
        }), sh = q(function(e, r, i) {
          return Ya(e, He(r) || 0, i);
        });
        function uh(e) {
          return _o(e, rn);
        }
        function Gt(e, r) {
          if (typeof e != "function" || r != null && typeof r != "function")
            throw new Ue(d);
          var i = function() {
            var s = arguments, l = r ? r.apply(this, s) : s[0], p = i.cache;
            if (p.has(l))
              return p.get(l);
            var m = e.apply(this, s);
            return i.cache = p.set(l, m) || p, m;
          };
          return i.cache = new (Gt.Cache || ho)(), i;
        }
        Gt.Cache = ho;
        function Ut(e) {
          if (typeof e != "function")
            throw new Ue(d);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, r[0]);
              case 2:
                return !e.call(this, r[0], r[1]);
              case 3:
                return !e.call(this, r[0], r[1], r[2]);
            }
            return !e.apply(this, r);
          };
        }
        function lh(e) {
          return nu(2, e);
        }
        var ch = Jp(function(e, r) {
          r = r.length == 1 && G(r[0]) ? re(r[0], Be(B())) : re(be(r, 1), Be(B()));
          var i = r.length;
          return q(function(s) {
            for (var l = -1, p = ge(s.length, i); ++l < p; )
              s[l] = r[l].call(this, s[l]);
            return Le(e, this, s);
          });
        }), fi = q(function(e, r) {
          var i = So(r, cr(fi));
          return _o(e, oo, n, r, i);
        }), lu = q(function(e, r) {
          var i = So(r, cr(lu));
          return _o(e, Bo, n, r, i);
        }), dh = bo(function(e, r) {
          return _o(e, Tr, n, n, n, r);
        });
        function ph(e, r) {
          if (typeof e != "function")
            throw new Ue(d);
          return r = r === n ? r : U(r), q(e, r);
        }
        function fh(e, r) {
          if (typeof e != "function")
            throw new Ue(d);
          return r = r == null ? 0 : fe(U(r), 0), q(function(i) {
            var s = i[r], l = Co(i, 0, r);
            return s && Fo(l, s), Le(e, this, l);
          });
        }
        function mh(e, r, i) {
          var s = !0, l = !0;
          if (typeof e != "function")
            throw new Ue(d);
          return ne(i) && (s = "leading" in i ? !!i.leading : s, l = "trailing" in i ? !!i.trailing : l), uu(e, r, {
            leading: s,
            maxWait: r,
            trailing: l
          });
        }
        function hh(e) {
          return tu(e, 1);
        }
        function _h(e, r) {
          return fi(Yn(r), e);
        }
        function bh() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function Ah(e) {
          return qe(e, ae);
        }
        function gh(e, r) {
          return r = typeof r == "function" ? r : n, qe(e, ae, r);
        }
        function yh(e) {
          return qe(e, D | ae);
        }
        function Th(e, r) {
          return r = typeof r == "function" ? r : n, qe(e, D | ae, r);
        }
        function Mh(e, r) {
          return r == null || ja(e, r, me(r));
        }
        function Qe(e, r) {
          return e === r || e !== e && r !== r;
        }
        var Ih = Lt(zn), xh = Lt(function(e, r) {
          return e >= r;
        }), Ko = rs(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? rs : function(e) {
          return se(e) && V.call(e, "callee") && !Za.call(e, "callee");
        }, G = g.isArray, Fh = Ia ? Be(Ia) : Dp;
        function Ne(e) {
          return e != null && Zt(e.length) && !go(e);
        }
        function ue(e) {
          return se(e) && Ne(e);
        }
        function Sh(e) {
          return e === !0 || e === !1 || se(e) && Me(e) == Mr;
        }
        var Do = zd || Fi, Nh = xa ? Be(xa) : Lp;
        function vh(e) {
          return se(e) && e.nodeType === 1 && !qr(e);
        }
        function wh(e) {
          if (e == null)
            return !0;
          if (Ne(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || Do(e) || dr(e) || Ko(e)))
            return !e.length;
          var r = ye(e);
          if (r == Ve || r == Je)
            return !e.size;
          if (Ur(e))
            return !Zn(e).length;
          for (var i in e)
            if (V.call(e, i))
              return !1;
          return !0;
        }
        function Eh(e, r) {
          return Or(e, r);
        }
        function Ch(e, r, i) {
          i = typeof i == "function" ? i : n;
          var s = i ? i(e, r) : n;
          return s === n ? Or(e, r, n, i) : !!s;
        }
        function mi(e) {
          if (!se(e))
            return !1;
          var r = Me(e);
          return r == et || r == ec || typeof e.message == "string" && typeof e.name == "string" && !qr(e);
        }
        function Dh(e) {
          return typeof e == "number" && $a(e);
        }
        function go(e) {
          if (!ne(e))
            return !1;
          var r = Me(e);
          return r == ot || r == ji || r == Ql || r == rc;
        }
        function cu(e) {
          return typeof e == "number" && e == U(e);
        }
        function Zt(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Io;
        }
        function ne(e) {
          var r = typeof e;
          return e != null && (r == "object" || r == "function");
        }
        function se(e) {
          return e != null && typeof e == "object";
        }
        var du = Fa ? Be(Fa) : Bp;
        function Lh(e, r) {
          return e === r || Un(e, r, ni(r));
        }
        function kh(e, r, i) {
          return i = typeof i == "function" ? i : n, Un(e, r, ni(r), i);
        }
        function Bh(e) {
          return pu(e) && e != +e;
        }
        function Rh(e) {
          if (gf(e))
            throw new O(f);
          return ts(e);
        }
        function Ph(e) {
          return e === null;
        }
        function Oh(e) {
          return e == null;
        }
        function pu(e) {
          return typeof e == "number" || se(e) && Me(e) == xr;
        }
        function qr(e) {
          if (!se(e) || Me(e) != fo)
            return !1;
          var r = ht(e);
          if (r === null)
            return !0;
          var i = V.call(r, "constructor") && r.constructor;
          return typeof i == "function" && i instanceof i && dt.call(i) == Ld;
        }
        var hi = Sa ? Be(Sa) : Rp;
        function zh(e) {
          return cu(e) && e >= -Io && e <= Io;
        }
        var fu = Na ? Be(Na) : Pp;
        function qt(e) {
          return typeof e == "string" || !G(e) && se(e) && Me(e) == Sr;
        }
        function Pe(e) {
          return typeof e == "symbol" || se(e) && Me(e) == rt;
        }
        var dr = va ? Be(va) : Op;
        function Gh(e) {
          return e === n;
        }
        function Uh(e) {
          return se(e) && ye(e) == Nr;
        }
        function Zh(e) {
          return se(e) && Me(e) == nc;
        }
        var qh = Lt(qn), $h = Lt(function(e, r) {
          return e <= r;
        });
        function mu(e) {
          if (!e)
            return [];
          if (Ne(e))
            return qt(e) ? je(e) : Se(e);
          if (Er && e[Er])
            return Td(e[Er]());
          var r = ye(e), i = r == Ve ? En : r == Je ? ut : pr;
          return i(e);
        }
        function yo(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === Ro || e === -Ro) {
            var r = e < 0 ? -1 : 1;
            return r * Jl;
          }
          return e === e ? e : 0;
        }
        function U(e) {
          var r = yo(e), i = r % 1;
          return r === r ? i ? r - i : r : 0;
        }
        function hu(e) {
          return e ? Uo(U(e), 0, ro) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (Pe(e))
            return Xr;
          if (ne(e)) {
            var r = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ne(r) ? r + "" : r;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = ka(e);
          var i = xc.test(e);
          return i || Sc.test(e) ? nd(e.slice(2), i ? 2 : 8) : Ic.test(e) ? Xr : +e;
        }
        function _u(e) {
          return io(e, ve(e));
        }
        function Kh(e) {
          return e ? Uo(U(e), -Io, Io) : e === 0 ? e : 0;
        }
        function J(e) {
          return e == null ? "" : Re(e);
        }
        var Hh = ur(function(e, r) {
          if (Ur(r) || Ne(r)) {
            io(r, me(r), e);
            return;
          }
          for (var i in r)
            V.call(r, i) && Br(e, i, r[i]);
        }), bu = ur(function(e, r) {
          io(r, ve(r), e);
        }), Au = ur(function(e, r, i, s) {
          io(r, ve(r), e, s);
        }), _i = ur(function(e, r, i, s) {
          io(r, me(r), e, s);
        }), Wh = bo(Rn);
        function Vh(e, r) {
          var i = sr(e);
          return r == null ? i : Ja(i, r);
        }
        var Jh = q(function(e, r) {
          e = Y(e);
          var i = -1, s = r.length, l = s > 2 ? r[2] : n;
          for (l && Ie(r[0], r[1], l) && (s = 1); ++i < s; )
            for (var p = r[i], m = ve(p), h = -1, A = m.length; ++h < A; ) {
              var M = m[h], x = e[M];
              (x === n || Qe(x, nr[M]) && !V.call(e, M)) && (e[M] = p[M]);
            }
          return e;
        }), jh = q(function(e) {
          return e.push(n, ks), Le(gu, n, e);
        });
        function Yh(e, r) {
          return Ea(e, B(r, 3), no);
        }
        function Xh(e, r) {
          return Ea(e, B(r, 3), On);
        }
        function Qh(e, r) {
          return e == null ? e : Pn(e, B(r, 3), ve);
        }
        function e_(e, r) {
          return e == null ? e : es(e, B(r, 3), ve);
        }
        function o_(e, r) {
          return e && no(e, B(r, 3));
        }
        function r_(e, r) {
          return e && On(e, B(r, 3));
        }
        function t_(e) {
          return e == null ? [] : Ft(e, me(e));
        }
        function n_(e) {
          return e == null ? [] : Ft(e, ve(e));
        }
        function bi(e, r, i) {
          var s = e == null ? n : Zo(e, r);
          return s === n ? i : s;
        }
        function i_(e, r) {
          return e != null && Ps(e, r, vp);
        }
        function Ai(e, r) {
          return e != null && Ps(e, r, wp);
        }
        var a_ = ws(function(e, r, i) {
          r != null && typeof r.toString != "function" && (r = pt.call(r)), e[r] = i;
        }, yi(we)), s_ = ws(function(e, r, i) {
          r != null && typeof r.toString != "function" && (r = pt.call(r)), V.call(e, r) ? e[r].push(i) : e[r] = [i];
        }, B), u_ = q(Pr);
        function me(e) {
          return Ne(e) ? Wa(e) : Zn(e);
        }
        function ve(e) {
          return Ne(e) ? Wa(e, !0) : zp(e);
        }
        function l_(e, r) {
          var i = {};
          return r = B(r, 3), no(e, function(s, l, p) {
            to(i, r(s, l, p), s);
          }), i;
        }
        function c_(e, r) {
          var i = {};
          return r = B(r, 3), no(e, function(s, l, p) {
            to(i, l, r(s, l, p));
          }), i;
        }
        var d_ = ur(function(e, r, i) {
          St(e, r, i);
        }), gu = ur(function(e, r, i, s) {
          St(e, r, i, s);
        }), p_ = bo(function(e, r) {
          var i = {};
          if (e == null)
            return i;
          var s = !1;
          r = re(r, function(p) {
            return p = Eo(p, e), s || (s = p.length > 1), p;
          }), io(e, ri(e), i), s && (i = qe(i, D | P | ae, sf));
          for (var l = r.length; l--; )
            Vn(i, r[l]);
          return i;
        });
        function f_(e, r) {
          return yu(e, Ut(B(r)));
        }
        var m_ = bo(function(e, r) {
          return e == null ? {} : Up(e, r);
        });
        function yu(e, r) {
          if (e == null)
            return {};
          var i = re(ri(e), function(s) {
            return [s];
          });
          return r = B(r), cs(e, i, function(s, l) {
            return r(s, l[0]);
          });
        }
        function h_(e, r, i) {
          r = Eo(r, e);
          var s = -1, l = r.length;
          for (l || (l = 1, e = n); ++s < l; ) {
            var p = e == null ? n : e[Xe(r[s])];
            p === n && (s = l, p = i), e = go(p) ? p.call(e) : p;
          }
          return e;
        }
        function __(e, r, i) {
          return e == null ? e : zr(e, r, i);
        }
        function b_(e, r, i, s) {
          return s = typeof s == "function" ? s : n, e == null ? e : zr(e, r, i, s);
        }
        var Tu = Ds(me), Mu = Ds(ve);
        function A_(e, r, i) {
          var s = G(e), l = s || Do(e) || dr(e);
          if (r = B(r, 4), i == null) {
            var p = e && e.constructor;
            l ? i = s ? new p() : [] : ne(e) ? i = go(p) ? sr(ht(e)) : {} : i = {};
          }
          return (l ? ke : no)(e, function(m, h, A) {
            return r(i, m, h, A);
          }), i;
        }
        function g_(e, r) {
          return e == null ? !0 : Vn(e, r);
        }
        function y_(e, r, i) {
          return e == null ? e : hs(e, r, Yn(i));
        }
        function T_(e, r, i, s) {
          return s = typeof s == "function" ? s : n, e == null ? e : hs(e, r, Yn(i), s);
        }
        function pr(e) {
          return e == null ? [] : wn(e, me(e));
        }
        function M_(e) {
          return e == null ? [] : wn(e, ve(e));
        }
        function I_(e, r, i) {
          return i === n && (i = r, r = n), i !== n && (i = He(i), i = i === i ? i : 0), r !== n && (r = He(r), r = r === r ? r : 0), Uo(He(e), r, i);
        }
        function x_(e, r, i) {
          return r = yo(r), i === n ? (i = r, r = 0) : i = yo(i), e = He(e), Ep(e, r, i);
        }
        function F_(e, r, i) {
          if (i && typeof i != "boolean" && Ie(e, r, i) && (r = i = n), i === n && (typeof r == "boolean" ? (i = r, r = n) : typeof e == "boolean" && (i = e, e = n)), e === n && r === n ? (e = 0, r = 1) : (e = yo(e), r === n ? (r = e, e = 0) : r = yo(r)), e > r) {
            var s = e;
            e = r, r = s;
          }
          if (i || e % 1 || r % 1) {
            var l = Ka();
            return ge(e + l * (r - e + td("1e-" + ((l + "").length - 1))), r);
          }
          return Kn(e, r);
        }
        var S_ = lr(function(e, r, i) {
          return r = r.toLowerCase(), e + (i ? Iu(r) : r);
        });
        function Iu(e) {
          return gi(J(e).toLowerCase());
        }
        function xu(e) {
          return e = J(e), e && e.replace(vc, _d).replace(Wc, "");
        }
        function N_(e, r, i) {
          e = J(e), r = Re(r);
          var s = e.length;
          i = i === n ? s : Uo(U(i), 0, s);
          var l = i;
          return i -= r.length, i >= 0 && e.slice(i, l) == r;
        }
        function v_(e) {
          return e = J(e), e && lc.test(e) ? e.replace(Qi, bd) : e;
        }
        function w_(e) {
          return e = J(e), e && hc.test(e) ? e.replace(fn, "\\$&") : e;
        }
        var E_ = lr(function(e, r, i) {
          return e + (i ? "-" : "") + r.toLowerCase();
        }), C_ = lr(function(e, r, i) {
          return e + (i ? " " : "") + r.toLowerCase();
        }), D_ = Ss("toLowerCase");
        function L_(e, r, i) {
          e = J(e), r = U(r);
          var s = r ? rr(e) : 0;
          if (!r || s >= r)
            return e;
          var l = (r - s) / 2;
          return Dt(gt(l), i) + e + Dt(At(l), i);
        }
        function k_(e, r, i) {
          e = J(e), r = U(r);
          var s = r ? rr(e) : 0;
          return r && s < r ? e + Dt(r - s, i) : e;
        }
        function B_(e, r, i) {
          e = J(e), r = U(r);
          var s = r ? rr(e) : 0;
          return r && s < r ? Dt(r - s, i) + e : e;
        }
        function R_(e, r, i) {
          return i || r == null ? r = 0 : r && (r = +r), qd(J(e).replace(mn, ""), r || 0);
        }
        function P_(e, r, i) {
          return (i ? Ie(e, r, i) : r === n) ? r = 1 : r = U(r), Hn(J(e), r);
        }
        function O_() {
          var e = arguments, r = J(e[0]);
          return e.length < 3 ? r : r.replace(e[1], e[2]);
        }
        var z_ = lr(function(e, r, i) {
          return e + (i ? "_" : "") + r.toLowerCase();
        });
        function G_(e, r, i) {
          return i && typeof i != "number" && Ie(e, r, i) && (r = i = n), i = i === n ? ro : i >>> 0, i ? (e = J(e), e && (typeof r == "string" || r != null && !hi(r)) && (r = Re(r), !r && or(e)) ? Co(je(e), 0, i) : e.split(r, i)) : [];
        }
        var U_ = lr(function(e, r, i) {
          return e + (i ? " " : "") + gi(r);
        });
        function Z_(e, r, i) {
          return e = J(e), i = i == null ? 0 : Uo(U(i), 0, e.length), r = Re(r), e.slice(i, i + r.length) == r;
        }
        function q_(e, r, i) {
          var s = c.templateSettings;
          i && Ie(e, r, i) && (r = n), e = J(e), r = _i({}, r, s, Ls);
          var l = _i({}, r.imports, s.imports, Ls), p = me(l), m = wn(l, p);
          ke(p, function(k) {
            if (oa.test(k))
              throw new O(T);
          });
          var h, A, M = 0, x = r.interpolate || tt, F = "__p += '", N = Cn(
            (r.escape || tt).source + "|" + x.source + "|" + (x === ea ? Mc : tt).source + "|" + (r.evaluate || tt).source + "|$",
            "g"
          ), E = "//# sourceURL=" + (V.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Xc + "]") + `
`;
          e.replace(N, function(k, $, H, Oe, xe, ze) {
            return H || (H = Oe), F += e.slice(M, ze).replace(wc, Ad), $ && (h = !0, F += `' +
__e(` + $ + `) +
'`), xe && (A = !0, F += `';
` + xe + `;
__p += '`), H && (F += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), M = ze + k.length, k;
          }), F += `';
`;
          var R = V.call(r, "variable") && r.variable;
          if (!R)
            F = `with (obj) {
` + F + `
}
`;
          else if (oa.test(R))
            throw new O(_);
          F = (A ? F.replace(ic, "") : F).replace(ac, "$1").replace(sc, "$1;"), F = "function(" + (R || "obj") + `) {
` + (R ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (h ? ", __e = _.escape" : "") + (A ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + F + `return __p
}`;
          var Z = Su(function() {
            return W(p, E + "return " + F).apply(n, m);
          });
          if (Z.source = F, mi(Z))
            throw Z;
          return Z;
        }
        function $_(e) {
          return J(e).toLowerCase();
        }
        function K_(e) {
          return J(e).toUpperCase();
        }
        function H_(e, r, i) {
          if (e = J(e), e && (i || r === n))
            return ka(e);
          if (!e || !(r = Re(r)))
            return e;
          var s = je(e), l = je(r), p = Ba(s, l), m = Ra(s, l) + 1;
          return Co(s, p, m).join("");
        }
        function W_(e, r, i) {
          if (e = J(e), e && (i || r === n))
            return e.slice(0, Oa(e) + 1);
          if (!e || !(r = Re(r)))
            return e;
          var s = je(e), l = Ra(s, je(r)) + 1;
          return Co(s, 0, l).join("");
        }
        function V_(e, r, i) {
          if (e = J(e), e && (i || r === n))
            return e.replace(mn, "");
          if (!e || !(r = Re(r)))
            return e;
          var s = je(e), l = Ba(s, je(r));
          return Co(s, l).join("");
        }
        function J_(e, r) {
          var i = ql, s = $l;
          if (ne(r)) {
            var l = "separator" in r ? r.separator : l;
            i = "length" in r ? U(r.length) : i, s = "omission" in r ? Re(r.omission) : s;
          }
          e = J(e);
          var p = e.length;
          if (or(e)) {
            var m = je(e);
            p = m.length;
          }
          if (i >= p)
            return e;
          var h = i - rr(s);
          if (h < 1)
            return s;
          var A = m ? Co(m, 0, h).join("") : e.slice(0, h);
          if (l === n)
            return A + s;
          if (m && (h += A.length - h), hi(l)) {
            if (e.slice(h).search(l)) {
              var M, x = A;
              for (l.global || (l = Cn(l.source, J(ra.exec(l)) + "g")), l.lastIndex = 0; M = l.exec(x); )
                var F = M.index;
              A = A.slice(0, F === n ? h : F);
            }
          } else if (e.indexOf(Re(l), h) != h) {
            var N = A.lastIndexOf(l);
            N > -1 && (A = A.slice(0, N));
          }
          return A + s;
        }
        function j_(e) {
          return e = J(e), e && uc.test(e) ? e.replace(Xi, Fd) : e;
        }
        var Y_ = lr(function(e, r, i) {
          return e + (i ? " " : "") + r.toUpperCase();
        }), gi = Ss("toUpperCase");
        function Fu(e, r, i) {
          return e = J(e), r = i ? n : r, r === n ? yd(e) ? vd(e) : dd(e) : e.match(r) || [];
        }
        var Su = q(function(e, r) {
          try {
            return Le(e, n, r);
          } catch (i) {
            return mi(i) ? i : new O(i);
          }
        }), X_ = bo(function(e, r) {
          return ke(r, function(i) {
            i = Xe(i), to(e, i, pi(e[i], e));
          }), e;
        });
        function Q_(e) {
          var r = e == null ? 0 : e.length, i = B();
          return e = r ? re(e, function(s) {
            if (typeof s[1] != "function")
              throw new Ue(d);
            return [i(s[0]), s[1]];
          }) : [], q(function(s) {
            for (var l = -1; ++l < r; ) {
              var p = e[l];
              if (Le(p[0], this, s))
                return Le(p[1], this, s);
            }
          });
        }
        function eb(e) {
          return Fp(qe(e, D));
        }
        function yi(e) {
          return function() {
            return e;
          };
        }
        function ob(e, r) {
          return e == null || e !== e ? r : e;
        }
        var rb = vs(), tb = vs(!0);
        function we(e) {
          return e;
        }
        function Ti(e) {
          return ns(typeof e == "function" ? e : qe(e, D));
        }
        function nb(e) {
          return as(qe(e, D));
        }
        function ib(e, r) {
          return ss(e, qe(r, D));
        }
        var ab = q(function(e, r) {
          return function(i) {
            return Pr(i, e, r);
          };
        }), sb = q(function(e, r) {
          return function(i) {
            return Pr(e, i, r);
          };
        });
        function Mi(e, r, i) {
          var s = me(r), l = Ft(r, s);
          i == null && !(ne(r) && (l.length || !s.length)) && (i = r, r = e, e = this, l = Ft(r, me(r)));
          var p = !(ne(i) && "chain" in i) || !!i.chain, m = go(e);
          return ke(l, function(h) {
            var A = r[h];
            e[h] = A, m && (e.prototype[h] = function() {
              var M = this.__chain__;
              if (p || M) {
                var x = e(this.__wrapped__), F = x.__actions__ = Se(this.__actions__);
                return F.push({ func: A, args: arguments, thisArg: e }), x.__chain__ = M, x;
              }
              return A.apply(e, Fo([this.value()], arguments));
            });
          }), e;
        }
        function ub() {
          return _e._ === this && (_e._ = kd), this;
        }
        function Ii() {
        }
        function lb(e) {
          return e = U(e), q(function(r) {
            return us(r, e);
          });
        }
        var cb = Qn(re), db = Qn(wa), pb = Qn(xn);
        function Nu(e) {
          return ai(e) ? Fn(Xe(e)) : Zp(e);
        }
        function fb(e) {
          return function(r) {
            return e == null ? n : Zo(e, r);
          };
        }
        var mb = Es(), hb = Es(!0);
        function xi() {
          return [];
        }
        function Fi() {
          return !1;
        }
        function _b() {
          return {};
        }
        function bb() {
          return "";
        }
        function Ab() {
          return !0;
        }
        function gb(e, r) {
          if (e = U(e), e < 1 || e > Io)
            return [];
          var i = ro, s = ge(e, ro);
          r = B(r), e -= ro;
          for (var l = vn(s, r); ++i < e; )
            r(i);
          return l;
        }
        function yb(e) {
          return G(e) ? re(e, Xe) : Pe(e) ? [e] : Se(Hs(J(e)));
        }
        function Tb(e) {
          var r = ++Dd;
          return J(e) + r;
        }
        var Mb = Ct(function(e, r) {
          return e + r;
        }, 0), Ib = ei("ceil"), xb = Ct(function(e, r) {
          return e / r;
        }, 1), Fb = ei("floor");
        function Sb(e) {
          return e && e.length ? xt(e, we, zn) : n;
        }
        function Nb(e, r) {
          return e && e.length ? xt(e, B(r, 2), zn) : n;
        }
        function vb(e) {
          return Da(e, we);
        }
        function wb(e, r) {
          return Da(e, B(r, 2));
        }
        function Eb(e) {
          return e && e.length ? xt(e, we, qn) : n;
        }
        function Cb(e, r) {
          return e && e.length ? xt(e, B(r, 2), qn) : n;
        }
        var Db = Ct(function(e, r) {
          return e * r;
        }, 1), Lb = ei("round"), kb = Ct(function(e, r) {
          return e - r;
        }, 0);
        function Bb(e) {
          return e && e.length ? Nn(e, we) : 0;
        }
        function Rb(e, r) {
          return e && e.length ? Nn(e, B(r, 2)) : 0;
        }
        return c.after = ih, c.ary = tu, c.assign = Hh, c.assignIn = bu, c.assignInWith = Au, c.assignWith = _i, c.at = Wh, c.before = nu, c.bind = pi, c.bindAll = X_, c.bindKey = iu, c.castArray = bh, c.chain = eu, c.chunk = Sf, c.compact = Nf, c.concat = vf, c.cond = Q_, c.conforms = eb, c.constant = yi, c.countBy = Rm, c.create = Vh, c.curry = au, c.curryRight = su, c.debounce = uu, c.defaults = Jh, c.defaultsDeep = jh, c.defer = ah, c.delay = sh, c.difference = wf, c.differenceBy = Ef, c.differenceWith = Cf, c.drop = Df, c.dropRight = Lf, c.dropRightWhile = kf, c.dropWhile = Bf, c.fill = Rf, c.filter = Om, c.flatMap = Um, c.flatMapDeep = Zm, c.flatMapDepth = qm, c.flatten = js, c.flattenDeep = Pf, c.flattenDepth = Of, c.flip = uh, c.flow = rb, c.flowRight = tb, c.fromPairs = zf, c.functions = t_, c.functionsIn = n_, c.groupBy = $m, c.initial = Uf, c.intersection = Zf, c.intersectionBy = qf, c.intersectionWith = $f, c.invert = a_, c.invertBy = s_, c.invokeMap = Hm, c.iteratee = Ti, c.keyBy = Wm, c.keys = me, c.keysIn = ve, c.map = Ot, c.mapKeys = l_, c.mapValues = c_, c.matches = nb, c.matchesProperty = ib, c.memoize = Gt, c.merge = d_, c.mergeWith = gu, c.method = ab, c.methodOf = sb, c.mixin = Mi, c.negate = Ut, c.nthArg = lb, c.omit = p_, c.omitBy = f_, c.once = lh, c.orderBy = Vm, c.over = cb, c.overArgs = ch, c.overEvery = db, c.overSome = pb, c.partial = fi, c.partialRight = lu, c.partition = Jm, c.pick = m_, c.pickBy = yu, c.property = Nu, c.propertyOf = fb, c.pull = Vf, c.pullAll = Xs, c.pullAllBy = Jf, c.pullAllWith = jf, c.pullAt = Yf, c.range = mb, c.rangeRight = hb, c.rearg = dh, c.reject = Xm, c.remove = Xf, c.rest = ph, c.reverse = ci, c.sampleSize = eh, c.set = __, c.setWith = b_, c.shuffle = oh, c.slice = Qf, c.sortBy = nh, c.sortedUniq = am, c.sortedUniqBy = sm, c.split = G_, c.spread = fh, c.tail = um, c.take = lm, c.takeRight = cm, c.takeRightWhile = dm, c.takeWhile = pm, c.tap = Nm, c.throttle = mh, c.thru = Pt, c.toArray = mu, c.toPairs = Tu, c.toPairsIn = Mu, c.toPath = yb, c.toPlainObject = _u, c.transform = A_, c.unary = hh, c.union = fm, c.unionBy = mm, c.unionWith = hm, c.uniq = _m, c.uniqBy = bm, c.uniqWith = Am, c.unset = g_, c.unzip = di, c.unzipWith = Qs, c.update = y_, c.updateWith = T_, c.values = pr, c.valuesIn = M_, c.without = gm, c.words = Fu, c.wrap = _h, c.xor = ym, c.xorBy = Tm, c.xorWith = Mm, c.zip = Im, c.zipObject = xm, c.zipObjectDeep = Fm, c.zipWith = Sm, c.entries = Tu, c.entriesIn = Mu, c.extend = bu, c.extendWith = Au, Mi(c, c), c.add = Mb, c.attempt = Su, c.camelCase = S_, c.capitalize = Iu, c.ceil = Ib, c.clamp = I_, c.clone = Ah, c.cloneDeep = yh, c.cloneDeepWith = Th, c.cloneWith = gh, c.conformsTo = Mh, c.deburr = xu, c.defaultTo = ob, c.divide = xb, c.endsWith = N_, c.eq = Qe, c.escape = v_, c.escapeRegExp = w_, c.every = Pm, c.find = zm, c.findIndex = Vs, c.findKey = Yh, c.findLast = Gm, c.findLastIndex = Js, c.findLastKey = Xh, c.floor = Fb, c.forEach = ou, c.forEachRight = ru, c.forIn = Qh, c.forInRight = e_, c.forOwn = o_, c.forOwnRight = r_, c.get = bi, c.gt = Ih, c.gte = xh, c.has = i_, c.hasIn = Ai, c.head = Ys, c.identity = we, c.includes = Km, c.indexOf = Gf, c.inRange = x_, c.invoke = u_, c.isArguments = Ko, c.isArray = G, c.isArrayBuffer = Fh, c.isArrayLike = Ne, c.isArrayLikeObject = ue, c.isBoolean = Sh, c.isBuffer = Do, c.isDate = Nh, c.isElement = vh, c.isEmpty = wh, c.isEqual = Eh, c.isEqualWith = Ch, c.isError = mi, c.isFinite = Dh, c.isFunction = go, c.isInteger = cu, c.isLength = Zt, c.isMap = du, c.isMatch = Lh, c.isMatchWith = kh, c.isNaN = Bh, c.isNative = Rh, c.isNil = Oh, c.isNull = Ph, c.isNumber = pu, c.isObject = ne, c.isObjectLike = se, c.isPlainObject = qr, c.isRegExp = hi, c.isSafeInteger = zh, c.isSet = fu, c.isString = qt, c.isSymbol = Pe, c.isTypedArray = dr, c.isUndefined = Gh, c.isWeakMap = Uh, c.isWeakSet = Zh, c.join = Kf, c.kebabCase = E_, c.last = Ke, c.lastIndexOf = Hf, c.lowerCase = C_, c.lowerFirst = D_, c.lt = qh, c.lte = $h, c.max = Sb, c.maxBy = Nb, c.mean = vb, c.meanBy = wb, c.min = Eb, c.minBy = Cb, c.stubArray = xi, c.stubFalse = Fi, c.stubObject = _b, c.stubString = bb, c.stubTrue = Ab, c.multiply = Db, c.nth = Wf, c.noConflict = ub, c.noop = Ii, c.now = zt, c.pad = L_, c.padEnd = k_, c.padStart = B_, c.parseInt = R_, c.random = F_, c.reduce = jm, c.reduceRight = Ym, c.repeat = P_, c.replace = O_, c.result = h_, c.round = Lb, c.runInContext = b, c.sample = Qm, c.size = rh, c.snakeCase = z_, c.some = th, c.sortedIndex = em, c.sortedIndexBy = om, c.sortedIndexOf = rm, c.sortedLastIndex = tm, c.sortedLastIndexBy = nm, c.sortedLastIndexOf = im, c.startCase = U_, c.startsWith = Z_, c.subtract = kb, c.sum = Bb, c.sumBy = Rb, c.template = q_, c.times = gb, c.toFinite = yo, c.toInteger = U, c.toLength = hu, c.toLower = $_, c.toNumber = He, c.toSafeInteger = Kh, c.toString = J, c.toUpper = K_, c.trim = H_, c.trimEnd = W_, c.trimStart = V_, c.truncate = J_, c.unescape = j_, c.uniqueId = Tb, c.upperCase = Y_, c.upperFirst = gi, c.each = ou, c.eachRight = ru, c.first = Ys, Mi(c, (function() {
          var e = {};
          return no(c, function(r, i) {
            V.call(c.prototype, i) || (e[i] = r);
          }), e;
        })(), { chain: !1 }), c.VERSION = a, ke(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          c[e].placeholder = c;
        }), ke(["drop", "take"], function(e, r) {
          K.prototype[e] = function(i) {
            i = i === n ? 1 : fe(U(i), 0);
            var s = this.__filtered__ && !r ? new K(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = ge(i, s.__takeCount__) : s.__views__.push({
              size: ge(i, ro),
              type: e + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, K.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), ke(["filter", "map", "takeWhile"], function(e, r) {
          var i = r + 1, s = i == Ji || i == Vl;
          K.prototype[e] = function(l) {
            var p = this.clone();
            return p.__iteratees__.push({
              iteratee: B(l, 3),
              type: i
            }), p.__filtered__ = p.__filtered__ || s, p;
          };
        }), ke(["head", "last"], function(e, r) {
          var i = "take" + (r ? "Right" : "");
          K.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), ke(["initial", "tail"], function(e, r) {
          var i = "drop" + (r ? "" : "Right");
          K.prototype[e] = function() {
            return this.__filtered__ ? new K(this) : this[i](1);
          };
        }), K.prototype.compact = function() {
          return this.filter(we);
        }, K.prototype.find = function(e) {
          return this.filter(e).head();
        }, K.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, K.prototype.invokeMap = q(function(e, r) {
          return typeof e == "function" ? new K(this) : this.map(function(i) {
            return Pr(i, e, r);
          });
        }), K.prototype.reject = function(e) {
          return this.filter(Ut(B(e)));
        }, K.prototype.slice = function(e, r) {
          e = U(e);
          var i = this;
          return i.__filtered__ && (e > 0 || r < 0) ? new K(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), r !== n && (r = U(r), i = r < 0 ? i.dropRight(-r) : i.take(r - e)), i);
        }, K.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, K.prototype.toArray = function() {
          return this.take(ro);
        }, no(K.prototype, function(e, r) {
          var i = /^(?:filter|find|map|reject)|While$/.test(r), s = /^(?:head|last)$/.test(r), l = c[s ? "take" + (r == "last" ? "Right" : "") : r], p = s || /^find/.test(r);
          l && (c.prototype[r] = function() {
            var m = this.__wrapped__, h = s ? [1] : arguments, A = m instanceof K, M = h[0], x = A || G(m), F = function($) {
              var H = l.apply(c, Fo([$], h));
              return s && N ? H[0] : H;
            };
            x && i && typeof M == "function" && M.length != 1 && (A = x = !1);
            var N = this.__chain__, E = !!this.__actions__.length, R = p && !N, Z = A && !E;
            if (!p && x) {
              m = Z ? m : new K(this);
              var k = e.apply(m, h);
              return k.__actions__.push({ func: Pt, args: [F], thisArg: n }), new Ze(k, N);
            }
            return R && Z ? e.apply(this, h) : (k = this.thru(F), R ? s ? k.value()[0] : k.value() : k);
          });
        }), ke(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var r = lt[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
          c.prototype[e] = function() {
            var l = arguments;
            if (s && !this.__chain__) {
              var p = this.value();
              return r.apply(G(p) ? p : [], l);
            }
            return this[i](function(m) {
              return r.apply(G(m) ? m : [], l);
            });
          };
        }), no(K.prototype, function(e, r) {
          var i = c[r];
          if (i) {
            var s = i.name + "";
            V.call(ar, s) || (ar[s] = []), ar[s].push({ name: r, func: i });
          }
        }), ar[Et(n, Mo).name] = [{
          name: "wrapper",
          func: n
        }], K.prototype.clone = jd, K.prototype.reverse = Yd, K.prototype.value = Xd, c.prototype.at = vm, c.prototype.chain = wm, c.prototype.commit = Em, c.prototype.next = Cm, c.prototype.plant = Lm, c.prototype.reverse = km, c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = Bm, c.prototype.first = c.prototype.head, Er && (c.prototype[Er] = Dm), c;
      }), tr = wd();
      Po ? ((Po.exports = tr)._ = tr, yn._ = tr) : _e._ = tr;
    }).call(Uy);
  })(Hr, Hr.exports)), Hr.exports;
}
var Wr = Zy();
const zM = (o, t) => {
  const n = Wr.mapValues(o, (u) => u === "" || u === void 0 ? null : u);
  return Wr.omit(n, t);
}, GM = (o, t, n) => {
  const a = n ? Wr.omitBy(n, (u) => u === null) : {};
  Wr.assign(o, t, Wr.pick(a, Object.keys(o)));
}, UM = (o) => {
  const { properties: t } = o, { context: n } = t;
  return {
    addressNumber: n.address?.address_number,
    alternate: n.region?.alternate?.name,
    country: n.country?.name,
    countryCode: n.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: n.place?.name,
    postcode: n.postcode?.name,
    region: n.region?.name,
    regionCode: n.region?.region_code_full,
    streetName: n.street?.name
  };
}, ZM = (o, t) => {
  if (t == null)
    return null;
  const n = t.trim();
  if (n.length === 0)
    return null;
  const a = Ey[o] ?? [];
  if (a.length === 0)
    return n.toUpperCase();
  const u = n.toLowerCase(), f = a.find((d) => d.code.toLowerCase() === u || d.name.toLowerCase() === u);
  return f ? f.code.toUpperCase() : null;
}, qM = (o, t, n, a = 0) => Array.from({ length: (t - o) / n + 1 }, (u, f) => Number((o + f * n).toFixed(a))), $M = (o) => {
  if (typeof o != "string") return !1;
  const t = o.replace(/-\d{1,2}$/, ""), n = /^\d+$/.test(t), a = /^[a-zA-Z0-9]+$/.test(t), u = t.length;
  return n && u >= 8 && u <= 10 || a && u === 17;
}, KM = (o, t) => {
  if (typeof o != "number" || !Number.isInteger(o)) return !1;
  const n = -(2 ** (t - 1)), a = 2 ** (t - 1) - 1;
  return o >= n && o <= a;
}, qy = [
  { threshold: 0, step: 1 },
  { threshold: 10, step: 5 },
  { threshold: 50, step: 10 },
  { threshold: 100, step: 50 },
  { threshold: 1e3, step: 100 },
  { threshold: 5e3, step: 200 },
  { threshold: 1e4, step: 500 },
  { threshold: 5e4, step: 1e3 }
];
class Ol {
  constructor(t) {
    if (!t[0])
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.tiers = [...t].sort((a, u) => a.threshold - u.threshold);
    const n = this.tiers[0];
    if (!n)
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.firstTier = n;
  }
  /** Creates an instance with the default MVP1 tiers (see DEFAULT_SALE_STEP_TIERS). */
  static createDefault() {
    return new Ol(qy);
  }
  /**
   * Checks whether an amount falls on the stepped price grid.
   *
   * @example validateAmount(1200) // true  (tier 1000-4999, step 100: (1200-1000) % 100 === 0)
   * @example validateAmount(1250) // false (tier 1000-4999, step 100: (1250-1000) % 100 !== 0)
   */
  validateAmount(t) {
    if (t < 0)
      return !1;
    const n = this.getTierForAmount(t, "up");
    return (t - n.threshold) % n.step === 0;
  }
  /**
   * Rounds an amount down (floor) to the nearest valid step value.
   *
   * @example getStepRoundedAmount(5300) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  /**
   * Rounds a reserve price up (ceil) to the nearest valid step value.
   *
   * @example getStepRoundedReservePrice(5100) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  /**
   * Computes the Nth stepped amount past baseAmount. Positive deltaSteps moves up,
   * negative moves down. Correctly switches step size when crossing tier boundaries.
   * Throws if baseAmount is not itself a stepped amount, unless allowFreeBaseAmount
   * is set: a free base then counts as one move, landing on the first stepped amount
   * past it before the remaining steps are applied.
   *
   * @example getDeltaStepsAmount(4900, 2)  // 5200 (4900+100=5000, then 5000+200=5200)
   * @example getDeltaStepsAmount(5000, -1) // 4900 (at boundary, uses lower tier step 100)
   * @example getDeltaStepsAmount(9010, 1, { allowFreeBaseAmount: true }) // 9200, not 9400
   */
  getDeltaStepsAmount(t, n, { allowFreeBaseAmount: a = !1 } = {}) {
    if (this.validateAmount(t))
      return this.computeDeltaStepsAmount(t, n);
    if (!a)
      throw new Error(
        "Error in SaleSteppedPrice.getDeltaStepsAmount, base is not a valid amount (pass allowFreeBaseAmount to step from a free one)"
      );
    if (n === 0)
      return t;
    const u = this.getStepRoundedValue(t, n > 0 ? Math.ceil : Math.floor);
    return this.computeDeltaStepsAmount(u, n - Math.sign(n));
  }
  /**
   * Computes a default starting price for an auction given its reserve price.
   * Uses an exponential decay formula (BSD-3693) so the gap between starting
   * and reserve grows fast for cheap items and plateaus at ~25.000 for expensive ones.
   *
   * @example getAuctionStartingPriceDefaultValue(10000)  // 4600
   * @example getAuctionStartingPriceDefaultValue(100000) // 76500
   */
  getAuctionStartingPriceDefaultValue(t) {
    const a = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(a);
  }
  /**
   * Returns the minimum negotiation offer for a direct sale: 30% of the price,
   * rounded down to the nearest valid step.
   *
   * @example getDirectSaleMinNegotiationOfferDefaultValue(10000) // 3000
   */
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  /**
   * Computes the suggested (discounted) price for a direct sale.
   * Uses a sigmoid that yields ~76% for low prices, trending toward
   * 100% for very high prices. Result is rounded down to the nearest valid step.
   *
   * @example getDirectSaleSuggestedPriceDefaultValue(5000)   // 4050  (~81%)
   * @example getDirectSaleSuggestedPriceDefaultValue(100000) // 88000 (~89%)
   */
  getDirectSaleSuggestedPriceDefaultValue(t) {
    const u = 0.98 - 0.16999999999999993 * Math.exp(-6e-6 * t);
    return this.getStepRoundedAmount(t * u);
  }
  /**
   * Finds the applicable tier for a given amount.
   * - direction 'up': returns the tier whose threshold is <= amount (used for validation/rounding)
   * - direction 'down': returns the tier whose threshold is < amount (at a boundary, picks the lower tier)
   */
  getTierForAmount(t, n) {
    const a = n === "up" ? (u) => u <= t : (u) => u < t;
    for (let u = this.tiers.length - 1; u >= 0; u--) {
      const f = this.tiers[u];
      if (f && a(f.threshold))
        return f;
    }
    return this.firstTier;
  }
  /** Rounds a value to the nearest valid step using the given rounding function (floor or ceil). */
  getStepRoundedValue(t, n) {
    const a = this.getTierForAmount(t, "up"), u = t - a.threshold;
    return n(u / a.step) * a.step + a.threshold;
  }
  /** Recursive implementation of getDeltaStepsAmount. Moves one step per call, recalculating the tier each time. */
  computeDeltaStepsAmount(t, n) {
    if (n === 0)
      return t;
    const a = n / Math.abs(n), u = n > 0 ? "up" : "down", f = this.getTierForAmount(t, u);
    return this.computeDeltaStepsAmount(t + f.step * a, n - a);
  }
}
const HM = ({
  reservePrice: o,
  isToBeScraped: t,
  isOneEuro: n
}) => {
  const a = t || o < 5e3 ? 50 : o < 1e4 ? 100 : o < 5e4 ? 500 : 1e3, u = t ? 50 : o < 5e3 ? 100 : o < 1e4 ? 500 : (o < 5e4, 1e3), f = t ? 1e3 : o < 5e3 ? 5e3 : o < 1e4 ? 1e4 : 5e4, d = t || n ? 250 : o <= 5e4 ? 500 : 1e3;
  return {
    minStepDefaultValue: a,
    maxStepDefaultValue: u,
    thresholdDefaultValue: f,
    bailDefaultValue: d
  };
};
function Ar(o) {
  const t = Object.prototype.toString.call(o);
  return o instanceof Date || typeof o == "object" && t === "[object Date]" ? new o.constructor(+o) : typeof o == "number" || t === "[object Number]" || typeof o == "string" || t === "[object String]" ? new Date(o) : /* @__PURE__ */ new Date(NaN);
}
function $y(o, t) {
  const n = Ar(o), a = Ar(t);
  return n.getTime() > a.getTime();
}
function Ky(o, t) {
  const n = Ar(o), a = Ar(t);
  return +n < +a;
}
function Xu(o, t) {
  const n = Ar(o), a = Ar(t);
  return +n == +a;
}
function Hi(o) {
  throw new Error("Should not have reached this line");
}
var uo = /* @__PURE__ */ ((o) => (o.Seller = "Seller", o.Buyer = "Buyer", o))(uo || {}), lo = /* @__PURE__ */ ((o) => (o.FixedPercentage = "FixedPercentage", o.FixedAmount = "FixedAmount", o.Standard = "Standard", o))(lo || {});
const Hy = /* @__PURE__ */ new Date("2025-11-24"), Wy = /* @__PURE__ */ new Date("2025-11-28"), hr = 250, Ci = 0.0875, zl = 0.0375, Gl = 5250, Di = 1e5, Ul = 2500, Vy = (o, [t, n]) => (Xu(o, t) || $y(o, t)) && (Ky(o, n) || Xu(o, n)), Zl = ({
  feeTarget: o,
  baseAmount: t,
  assetsCount: n,
  feeConfiguration: a
}) => {
  const u = {
    [uo.Seller]: 1,
    [uo.Buyer]: -1
  }[o], f = t / n;
  return (() => {
    if (!a || a.type === lo.Standard) {
      const d = Ul - hr * u;
      return (() => {
        if (f <= d) return f + hr * u;
        const T = Di - hr * u - Ci * Di * u;
        return f <= T ? (f + hr * u) / (1 - Ci * u) : (f + Gl * u) / (1 - zl * u);
      })() * n;
    }
    if (a.type === lo.FixedPercentage)
      return t / (1 - a.feeOverrideValue * u);
    if (a.type === lo.FixedAmount)
      return t + a.feeOverrideValue * u;
    Hi(a.type);
  })();
}, WM = ({
  feeTarget: o,
  baseAmount: t,
  assetsCount: n,
  referenceDate: a,
  feeConfiguration: u
}) => {
  const f = t / n, d = (() => {
    if (!u || u.type === lo.Standard)
      return f <= Ul ? hr * n : f <= Di ? (hr + Ci * f) * n : (Gl + zl * f) * n;
    if (u.type === lo.FixedPercentage)
      return t * u.feeOverrideValue;
    if (u.type === lo.FixedAmount)
      return u.feeOverrideValue;
    Hi(u.type);
  })(), T = o === uo.Buyer && a && Vy(a, [Hy, Wy]) ? d * 0.5 : d;
  return {
    grossTotal: Math.ceil(o === uo.Buyer ? t + d : t),
    grossNet: Math.ceil(o === uo.Buyer ? t : t - d),
    grossFees: Math.ceil(d),
    total: Math.ceil(o === uo.Buyer ? t + T : t),
    net: Math.ceil(o === uo.Buyer ? t : t - T),
    fees: Math.ceil(T)
  };
}, VM = ({
  sellerReservePrice: o,
  assetsCount: t,
  feeConfiguration: n
}) => {
  const a = Math.ceil(
    Zl({
      feeTarget: uo.Seller,
      baseAmount: o,
      assetsCount: t,
      feeConfiguration: n
    })
  );
  return {
    sellerReservePrice: o,
    fees: a - o,
    reservePrice: a
  };
}, JM = ({
  buyerBudget: o,
  assetsCount: t,
  feeConfiguration: n
}) => {
  const a = Math.ceil(
    Zl({
      feeTarget: uo.Buyer,
      baseAmount: o,
      assetsCount: t,
      feeConfiguration: n
    })
  );
  return {
    buyerBudget: o,
    fees: o - a,
    buyerMaxOffer: a
  };
}, jM = ({
  sellerReservePrice: o,
  feeConfiguration: t
}) => {
  const n = (() => {
    if (!t || t.type === lo.Standard)
      return o <= 2250 ? 250 : o <= 91e3 ? (o + 250) / 0.9125 : (o + 5250) / 0.9625;
    if (t.type === lo.FixedPercentage)
      return o / (1 - t.feeOverrideValue);
    if (t.type === lo.FixedAmount)
      return o + t.feeOverrideValue;
    Hi(t.type);
  })();
  return Math.ceil(n);
}, YM = ({
  isSeller: o,
  isCustomerService: t,
  isAssignedSalesRep: n
}) => o || t || n, XM = (o, t) => {
  let n = null;
  for (const a of o) {
    const u = t(a);
    (!n || u < n.fees) && (n = { candidate: a, fees: u });
  }
  return n ? n.candidate : null;
}, Jy = [
  "MinibusCityIntercity",
  "MinibusTouristic",
  "AutobusNormalFloor2Axle",
  "AutobusNormalFloor3Axle",
  "AutobusLowFloorLowEntry8_12Mt",
  "Autobus18Mt",
  "DoubleDecker"
];
function QM(o) {
  return typeof o == "string" && Jy.includes(o);
}
const jy = My, Yy = Iy, Wi = 10, Xy = Wi - 1, Vi = [
  ...Object.values(jy).map(
    (o) => ({
      name: o.name,
      kind: "image",
      isInternal: !1,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType,
      requiredFor: o.requiredFor
    })
  ),
  ...Object.values(Yy).map(
    (o) => ({
      name: o.name,
      kind: "video",
      isInternal: o.isInternal,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType,
      requiredFor: o.requiredFor
    })
  )
], Yr = new Map(Vi.map((o) => [o.name, o]));
function eI(o) {
  return Yr.get(o)?.isInternal ?? !1;
}
function oI(o) {
  return o === "DoubleDecker";
}
function rI(o) {
  const t = Yr.get(o);
  return t ? t.kind === "image" ? "IMAGES_BASE" : o === "video_engine_working" ? "VIDEOS_ENGINE" : o === "video_warranty" ? "VIDEOS_WARRANTY" : "VIDEOS_OTHER" : null;
}
function Wt(o) {
  return Vi.filter((t) => t.positionAdminByType?.[o] !== void 0).sort((t, n) => (t.positionAdminByType?.[o] ?? 0) - (n.positionAdminByType?.[o] ?? 0)).map((t) => ({
    name: t.name,
    kind: t.kind,
    isInternal: t.isInternal,
    label: t.label,
    group: t.group,
    positionInspection: t.positionAdminByType?.[o] ?? 0,
    positionFleequid: t.positionByType?.[o] ?? null
  }));
}
function tI(o) {
  return Number.isInteger(o) && o > 0 && o % Wi !== 0;
}
function Qy(o) {
  return o.anchor === void 0 ? null : { anchor: o.anchor, offset: o.position % Wi };
}
function nI({
  anchorPositionInspection: o,
  siblingOffsets: t,
  takenPositions: n
}) {
  const a = new Set(t), u = new Set(n);
  for (let f = 1; f <= Xy; f++) {
    const d = o + f;
    if (!a.has(f) && !u.has(d))
      return d;
  }
  return null;
}
function iI(o, t) {
  const n = Qy(t), a = n === null ? void 0 : Yr.get(n.anchor);
  if (n === null || !a || a.isInternal)
    return null;
  const u = a.positionByType?.[o];
  return u === void 0 ? null : u + n.offset;
}
function aI(o) {
  return Vi.filter((t) => !t.isInternal && t.positionByType?.[o] !== void 0).sort((t, n) => (t.positionByType?.[o] ?? 0) - (n.positionByType?.[o] ?? 0)).map((t) => t.name);
}
function sI(o, t) {
  const n = Yr.get(t);
  return !n || n.isInternal ? null : n.positionByType?.[o] ?? null;
}
const eT = [
  {
    applies: (o) => o.enginePresent === !1,
    media: [
      "video_engine_working",
      "photo_engine_below_without_protection",
      "photo_any_devices_onboard_3",
      "photo_dashboard_on_for_number_km_and_lights_on"
    ]
  },
  { applies: (o) => o.gearboxPresent === !1, media: ["photo_gearbox"] },
  { applies: (o) => o.spareWheel === !1, media: ["spare_wheel"] },
  { applies: (o) => o.tachograph === "Absent", media: ["photo_tachograph"] },
  { applies: (o) => o.wheelchairPlaces === 0, media: ["photo_disabled_area"] },
  { applies: (o) => o.hatBox === !1, media: ["photo_overhead_compartments"] },
  // The licence plate: a vehicle still to be registered has none.
  { applies: Li, media: ["photo_plate_vehicle"] }
];
function oT(o) {
  const { trustReportType: t } = o;
  if (t === null || o.toBeScraped === !0)
    return [];
  const n = new Set(eT.filter((a) => a.applies(o)).flatMap((a) => a.media));
  return Wt(t).filter(
    (a) => Yr.get(a.name)?.requiredFor?.includes(t) === !0 && !n.has(a.name)
  );
}
function uI(o, t) {
  return oT(o).filter((n) => !t.has(n.name));
}
function lI({
  from: o,
  to: t,
  held: n
}) {
  const a = new Set(Wt(o).map((_) => _.name)), u = new Set(Wt(t).map((_) => _.name)), f = { kept: [], dropped: [], missing: [], keptExtras: [], droppedExtras: [], untouched: [] };
  for (const { name: _, anchor: T } of n)
    a.has(_) || u.has(_) ? (u.has(_) ? f.kept : f.dropped).push(_) : T === void 0 ? f.untouched.push(_) : (u.has(T) ? f.keptExtras : f.droppedExtras).push(_);
  const d = new Set(n.map(({ name: _ }) => _));
  for (const _ of Wt(t))
    d.has(_.name) || f.missing.push(_.name);
  return f;
}
var rT = /* @__PURE__ */ ((o) => (o.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", o.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", o.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", o.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", o.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", o))(rT || {});
const cI = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  Py as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  GT as AUCTION_INCREMENT_ID_REGEX,
  EM as AdminUserPasswordResetTokenPayloadSchema,
  _T as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  My as BUS_ASSET_BASE_IMAGES,
  bT as BUS_ASSET_COVER_IMAGES,
  Iy as BUS_ASSET_VIDEOS,
  fT as CalcomBookingMetadataSchema,
  qy as DEFAULT_SALE_STEP_TIERS,
  UT as DIRECT_SALE_INCREMENT_ID_REGEX,
  xT as FILE_UPLOAD_EXTENSIONS,
  IT as FILE_UPLOAD_PDF_MAX_SIZE,
  uM as FILTER_COMPANION_SEATS_VALUES,
  SM as FILTER_DISPLACEMENT_END,
  FM as FILTER_DISPLACEMENT_START,
  NM as FILTER_DISPLACEMENT_STEP,
  sM as FILTER_FOLDING_SEATS_VALUES,
  dM as FILTER_FUEL_TANK_CAPACITY_END,
  cM as FILTER_FUEL_TANK_CAPACITY_START,
  pM as FILTER_FUEL_TANK_CAPACITY_STEP,
  nM as FILTER_HEIGHT_END,
  tM as FILTER_HEIGHT_START,
  iM as FILTER_HEIGHT_STEP,
  HT as FILTER_KM_END,
  KT as FILTER_KM_START,
  WT as FILTER_KM_STEP,
  XT as FILTER_LENGTH_END,
  YT as FILTER_LENGTH_START,
  QT as FILTER_LENGTH_STEP,
  IM as FILTER_OPENABLE_WINDOWS_END,
  MM as FILTER_OPENABLE_WINDOWS_START,
  xM as FILTER_OPENABLE_WINDOWS_STEP,
  mM as FILTER_POWER_END,
  fM as FILTER_POWER_START,
  hM as FILTER_POWER_STEP,
  qT as FILTER_PRICE_END,
  ZT as FILTER_PRICE_START,
  $T as FILTER_PRICE_STEP,
  JT as FILTER_REGISTRATION_YEAR_END,
  VT as FILTER_REGISTRATION_YEAR_START,
  jT as FILTER_REGISTRATION_YEAR_STEP,
  aM as FILTER_SEATS_VALUES,
  yM as FILTER_STANDING_PLACES_END,
  gM as FILTER_STANDING_PLACES_START,
  TM as FILTER_STANDING_PLACES_STEP,
  bM as FILTER_TOTAL_CAPACITY_END,
  _M as FILTER_TOTAL_CAPACITY_START,
  AM as FILTER_TOTAL_CAPACITY_STEP,
  lM as FILTER_WHEELCHAIR_PLACES_VALUES,
  oM as FILTER_WIDTH_END,
  eM as FILTER_WIDTH_START,
  rM as FILTER_WIDTH_STEP,
  uo as FeeTarget,
  lo as FeeType,
  By as INPAINT_BOX_ORIGINS,
  Fy as ITALIAN_REGIONS,
  Dy as LanguageISO6391Schema,
  BT as MAPBOX_API_CONFIG,
  Xy as MAX_DISCRETIONARY_PHOTOS_PER_GAP,
  hT as ONE_EURO_STARTING_PRICE,
  rT as PowertrainWarrantyIneligibilityReason,
  zT as SEARCH_INTERPRET_MAX_QUERY_LENGTH,
  OT as SEARCH_MIN_QUERY_LENGTH,
  mT as STEP_LOWEST_COMMON_DENOMINATOR,
  Ol as SaleSteppedPrice,
  vT as TEXT_INPAINT_DEFAULT_PROMPT,
  cI as VAS_CLAIM_CONFIGURATION,
  zM as adaptFormDataToDto,
  UM as adaptMapboxFeatureToAddressBody,
  vM as addressFormFieldSchema,
  dT as busClasses,
  tT as busDossierDocumentKeys,
  Pb as busRegistrationDependentFieldKeys,
  cT as busTypes,
  JM as computeBuyerMaxOfferAndFees,
  WM as computeFees,
  YM as computeIsSellerPov,
  jM as computeReservePrice,
  HM as computeSaleDefaultValues,
  VM as computeSellerReservePriceAndFees,
  RM as convertKwToHp,
  $i as countriesConfig,
  Dl as countryIso2List,
  LT as customerServiceEmail,
  kT as customerServicePhone,
  OM as fetchFormatQuery,
  wM as getAddressFormFieldSchema,
  yT as getAsCountryISO2,
  TT as getAsCountryISO3,
  FT as getAsLanguageISO6391,
  NT as getAsTaxCodeOrigin,
  zy as getAsTin,
  lT as getBusDossierDocumentResponsibility,
  iT as getBusDossierFieldResponsibility,
  aT as getBusDossierRequiredVaryingFields,
  gT as getCountryCodesByContinent,
  MT as getCountryISO3FromISO2,
  AT as getCountryNameInEnglish,
  aI as getFleequidOrder,
  DT as getHubspotFlagUrl,
  ET as getHubspotSalesRepImageUrl,
  Wt as getInspectionSequence,
  RT as getLanguage6391FromCountryIso2,
  rI as getMediaTypeForName,
  uI as getMissingRequiredMedia,
  oT as getRequiredMedia,
  CT as hubspotDefaultSalesRepImageUrl,
  Ki as hubspotPublicFilesBaseUrl,
  GM as initFormData,
  wT as inpaintBoxSchema,
  PM as insertIf,
  tI as isAnchoredPosition,
  sT as isBusDossierDocumentHidden,
  uT as isBusDossierDocumentRequired,
  nT as isBusDossierFieldHidden,
  Zb as isBusDossierFieldRequired,
  Li as isBusToBeRegistered,
  vy as isCountryISO2,
  wy as isCountryISO3,
  KM as isDbIntegerValidator,
  oI as isDoubleDecker,
  eI as isInternalMedia,
  ky as isTaxCodeOrigin,
  kM as isTin,
  QM as isTrustReportType,
  Ob as isWaivedByBusRegistration,
  ST as languageNames,
  PT as languageToRepresentativeCountryMap,
  BM as parseAsTin,
  CM as phoneValidator,
  Bl as phoneValidatorE164,
  XM as pickLowestFee,
  Ey as provinces,
  qM as range,
  lI as reconcileForTrustReportTypeChange,
  Qy as resolveDiscretionaryAnchor,
  sI as resolveFleequidPosition,
  iI as resolveInterlacedFleequidPosition,
  nI as resolveNextAnchoredPosition,
  ZM as resolveProvinceCode,
  pT as suggestedLuggageCapacity,
  Ly as taxCodeOriginList,
  Jy as trustReportTypes,
  $M as vinValidator,
  DM as zodPhoneE164,
  LM as zodPhoneE164Optional
};
//# sourceMappingURL=shared.mjs.map
